(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0217"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0217"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9EfTK", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $70642e8a64c79dfc$export$ffb0004e005737fa; }, function (v) { return $70642e8a64c79dfc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $70642e8a64c79dfc$export$34b9dba7ce09269b; }, function (v) { return $70642e8a64c79dfc$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $70642e8a64c79dfc$export$25062201e9e25d76; }, function (v) { return $70642e8a64c79dfc$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $70642e8a64c79dfc$export$ffb0004e005737fa;
var $70642e8a64c79dfc$export$34b9dba7ce09269b;
var $70642e8a64c79dfc$export$25062201e9e25d76;
"use strict";

var $1wHBI = parcelRequire("1wHBI");
var $70642e8a64c79dfc$var$k = Symbol.for("react.element"), $70642e8a64c79dfc$var$l = Symbol.for("react.fragment"), $70642e8a64c79dfc$var$m = Object.prototype.hasOwnProperty, $70642e8a64c79dfc$var$n = $1wHBI.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $70642e8a64c79dfc$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $70642e8a64c79dfc$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$70642e8a64c79dfc$var$m.call(a, b) && !$70642e8a64c79dfc$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $70642e8a64c79dfc$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $70642e8a64c79dfc$var$n.current
    };
}
$70642e8a64c79dfc$export$ffb0004e005737fa = $70642e8a64c79dfc$var$l;
$70642e8a64c79dfc$export$34b9dba7ce09269b = $70642e8a64c79dfc$var$q;
$70642e8a64c79dfc$export$25062201e9e25d76 = $70642e8a64c79dfc$var$q;

});
parcelRegister("1wHBI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gmjGy"));

});
parcelRegister("gmjGy", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $be8df8872c3b1da1$export$dca3b0875bd9a954; }, function (v) { return $be8df8872c3b1da1$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $be8df8872c3b1da1$export$16fa2f45be04daa8; }, function (v) { return $be8df8872c3b1da1$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $be8df8872c3b1da1$export$ffb0004e005737fa; }, function (v) { return $be8df8872c3b1da1$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $be8df8872c3b1da1$export$e2c29f18771995cb; }, function (v) { return $be8df8872c3b1da1$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $be8df8872c3b1da1$export$221d75b3f55bb0bd; }, function (v) { return $be8df8872c3b1da1$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $be8df8872c3b1da1$export$5f8d39834fd61797; }, function (v) { return $be8df8872c3b1da1$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $be8df8872c3b1da1$export$74bf444e3cd11ea5; }, function (v) { return $be8df8872c3b1da1$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $be8df8872c3b1da1$export$ae55be85d98224ed; }, function (v) { return $be8df8872c3b1da1$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $be8df8872c3b1da1$export$3ba232387fd5d6dd; }, function (v) { return $be8df8872c3b1da1$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $be8df8872c3b1da1$export$e530037191fcd5d7; }, function (v) { return $be8df8872c3b1da1$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $be8df8872c3b1da1$export$fd42f52fd3ae1109; }, function (v) { return $be8df8872c3b1da1$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $be8df8872c3b1da1$export$c8a8987d4410bf2d; }, function (v) { return $be8df8872c3b1da1$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $be8df8872c3b1da1$export$d38cd72104c1f0e9; }, function (v) { return $be8df8872c3b1da1$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $be8df8872c3b1da1$export$7d1e3a5e95ceca43; }, function (v) { return $be8df8872c3b1da1$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $be8df8872c3b1da1$export$257a8862b851cb5b; }, function (v) { return $be8df8872c3b1da1$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $be8df8872c3b1da1$export$a8257692ac88316c; }, function (v) { return $be8df8872c3b1da1$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $be8df8872c3b1da1$export$488013bae63b21da; }, function (v) { return $be8df8872c3b1da1$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $be8df8872c3b1da1$export$7c73462e0d25e514; }, function (v) { return $be8df8872c3b1da1$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $be8df8872c3b1da1$export$7568632d0d33d16d; }, function (v) { return $be8df8872c3b1da1$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $be8df8872c3b1da1$export$88948ce120ea2619; }, function (v) { return $be8df8872c3b1da1$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $be8df8872c3b1da1$export$35808ee640e87ca7; }, function (v) { return $be8df8872c3b1da1$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $be8df8872c3b1da1$export$fae74005e78b1a27; }, function (v) { return $be8df8872c3b1da1$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $be8df8872c3b1da1$export$dc8fbce3eb94dc1e; }, function (v) { return $be8df8872c3b1da1$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $be8df8872c3b1da1$export$6a7bc4e911dc01cf; }, function (v) { return $be8df8872c3b1da1$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $be8df8872c3b1da1$export$6d9c69b0de29b591; }, function (v) { return $be8df8872c3b1da1$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $be8df8872c3b1da1$export$f680877a34711e37; }, function (v) { return $be8df8872c3b1da1$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $be8df8872c3b1da1$export$d5a552a76deda3c2; }, function (v) { return $be8df8872c3b1da1$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $be8df8872c3b1da1$export$aaabe4eda9ed9969; }, function (v) { return $be8df8872c3b1da1$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $be8df8872c3b1da1$export$e5c5a5f917a5871c; }, function (v) { return $be8df8872c3b1da1$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $be8df8872c3b1da1$export$1538c33de8887b59; }, function (v) { return $be8df8872c3b1da1$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $be8df8872c3b1da1$export$13e3392192263954; }, function (v) { return $be8df8872c3b1da1$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $be8df8872c3b1da1$export$b8f5890fc79d6aca; }, function (v) { return $be8df8872c3b1da1$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $be8df8872c3b1da1$export$60241385465d0a34; }, function (v) { return $be8df8872c3b1da1$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $be8df8872c3b1da1$export$306c0aa65ff9ec16; }, function (v) { return $be8df8872c3b1da1$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $be8df8872c3b1da1$export$7b286972b8d8ccbf; }, function (v) { return $be8df8872c3b1da1$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $be8df8872c3b1da1$export$83d89fbfd8236492; }, function (v) { return $be8df8872c3b1da1$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $be8df8872c3b1da1$export$dca3b0875bd9a954;
var $be8df8872c3b1da1$export$16fa2f45be04daa8;
var $be8df8872c3b1da1$export$ffb0004e005737fa;
var $be8df8872c3b1da1$export$e2c29f18771995cb;
var $be8df8872c3b1da1$export$221d75b3f55bb0bd;
var $be8df8872c3b1da1$export$5f8d39834fd61797;
var $be8df8872c3b1da1$export$74bf444e3cd11ea5;
var $be8df8872c3b1da1$export$ae55be85d98224ed;
var $be8df8872c3b1da1$export$3ba232387fd5d6dd;
var $be8df8872c3b1da1$export$e530037191fcd5d7;
var $be8df8872c3b1da1$export$fd42f52fd3ae1109;
var $be8df8872c3b1da1$export$c8a8987d4410bf2d;
var $be8df8872c3b1da1$export$d38cd72104c1f0e9;
var $be8df8872c3b1da1$export$7d1e3a5e95ceca43;
var $be8df8872c3b1da1$export$257a8862b851cb5b;
var $be8df8872c3b1da1$export$a8257692ac88316c;
var $be8df8872c3b1da1$export$488013bae63b21da;
var $be8df8872c3b1da1$export$7c73462e0d25e514;
var $be8df8872c3b1da1$export$7568632d0d33d16d;
var $be8df8872c3b1da1$export$88948ce120ea2619;
var $be8df8872c3b1da1$export$35808ee640e87ca7;
var $be8df8872c3b1da1$export$fae74005e78b1a27;
var $be8df8872c3b1da1$export$dc8fbce3eb94dc1e;
var $be8df8872c3b1da1$export$6a7bc4e911dc01cf;
var $be8df8872c3b1da1$export$6d9c69b0de29b591;
var $be8df8872c3b1da1$export$f680877a34711e37;
var $be8df8872c3b1da1$export$d5a552a76deda3c2;
var $be8df8872c3b1da1$export$aaabe4eda9ed9969;
var $be8df8872c3b1da1$export$e5c5a5f917a5871c;
var $be8df8872c3b1da1$export$1538c33de8887b59;
var $be8df8872c3b1da1$export$13e3392192263954;
var $be8df8872c3b1da1$export$b8f5890fc79d6aca;
var $be8df8872c3b1da1$export$60241385465d0a34;
var $be8df8872c3b1da1$export$306c0aa65ff9ec16;
var $be8df8872c3b1da1$export$7b286972b8d8ccbf;
var $be8df8872c3b1da1$export$83d89fbfd8236492;
"use strict";
var $be8df8872c3b1da1$var$l = Symbol.for("react.element"), $be8df8872c3b1da1$var$n = Symbol.for("react.portal"), $be8df8872c3b1da1$var$p = Symbol.for("react.fragment"), $be8df8872c3b1da1$var$q = Symbol.for("react.strict_mode"), $be8df8872c3b1da1$var$r = Symbol.for("react.profiler"), $be8df8872c3b1da1$var$t = Symbol.for("react.provider"), $be8df8872c3b1da1$var$u = Symbol.for("react.context"), $be8df8872c3b1da1$var$v = Symbol.for("react.forward_ref"), $be8df8872c3b1da1$var$w = Symbol.for("react.suspense"), $be8df8872c3b1da1$var$x = Symbol.for("react.memo"), $be8df8872c3b1da1$var$y = Symbol.for("react.lazy"), $be8df8872c3b1da1$var$z = Symbol.iterator;
function $be8df8872c3b1da1$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $be8df8872c3b1da1$var$z && a[$be8df8872c3b1da1$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $be8df8872c3b1da1$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $be8df8872c3b1da1$var$C = Object.assign, $be8df8872c3b1da1$var$D = {};
function $be8df8872c3b1da1$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $be8df8872c3b1da1$var$D;
    this.updater = e || $be8df8872c3b1da1$var$B;
}
$be8df8872c3b1da1$var$E.prototype.isReactComponent = {};
$be8df8872c3b1da1$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$be8df8872c3b1da1$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $be8df8872c3b1da1$var$F() {}
$be8df8872c3b1da1$var$F.prototype = $be8df8872c3b1da1$var$E.prototype;
function $be8df8872c3b1da1$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $be8df8872c3b1da1$var$D;
    this.updater = e || $be8df8872c3b1da1$var$B;
}
var $be8df8872c3b1da1$var$H = $be8df8872c3b1da1$var$G.prototype = new $be8df8872c3b1da1$var$F;
$be8df8872c3b1da1$var$H.constructor = $be8df8872c3b1da1$var$G;
$be8df8872c3b1da1$var$C($be8df8872c3b1da1$var$H, $be8df8872c3b1da1$var$E.prototype);
$be8df8872c3b1da1$var$H.isPureReactComponent = !0;
var $be8df8872c3b1da1$var$I = Array.isArray, $be8df8872c3b1da1$var$J = Object.prototype.hasOwnProperty, $be8df8872c3b1da1$var$K = {
    current: null
}, $be8df8872c3b1da1$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $be8df8872c3b1da1$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$be8df8872c3b1da1$var$J.call(b, d) && !$be8df8872c3b1da1$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $be8df8872c3b1da1$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $be8df8872c3b1da1$var$K.current
    };
}
function $be8df8872c3b1da1$var$N(a, b) {
    return {
        $$typeof: $be8df8872c3b1da1$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $be8df8872c3b1da1$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $be8df8872c3b1da1$var$l;
}
function $be8df8872c3b1da1$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $be8df8872c3b1da1$var$P = /\/+/g;
function $be8df8872c3b1da1$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $be8df8872c3b1da1$var$escape("" + a.key) : b.toString(36);
}
function $be8df8872c3b1da1$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $be8df8872c3b1da1$var$l:
                case $be8df8872c3b1da1$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $be8df8872c3b1da1$var$Q(h, 0) : d, $be8df8872c3b1da1$var$I(c) ? (e = "", null != a && (e = a.replace($be8df8872c3b1da1$var$P, "$&/") + "/"), $be8df8872c3b1da1$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($be8df8872c3b1da1$var$O(c) && (c = $be8df8872c3b1da1$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($be8df8872c3b1da1$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($be8df8872c3b1da1$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $be8df8872c3b1da1$var$Q(k, g);
        h += $be8df8872c3b1da1$var$R(k, b, e, f, c);
    }
    else if (f = $be8df8872c3b1da1$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $be8df8872c3b1da1$var$Q(k, g++), h += $be8df8872c3b1da1$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $be8df8872c3b1da1$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $be8df8872c3b1da1$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $be8df8872c3b1da1$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $be8df8872c3b1da1$var$U = {
    current: null
}, $be8df8872c3b1da1$var$V = {
    transition: null
}, $be8df8872c3b1da1$var$W = {
    ReactCurrentDispatcher: $be8df8872c3b1da1$var$U,
    ReactCurrentBatchConfig: $be8df8872c3b1da1$var$V,
    ReactCurrentOwner: $be8df8872c3b1da1$var$K
};
function $be8df8872c3b1da1$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$be8df8872c3b1da1$export$dca3b0875bd9a954 = {
    map: $be8df8872c3b1da1$var$S,
    forEach: function(a, b, e) {
        $be8df8872c3b1da1$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $be8df8872c3b1da1$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $be8df8872c3b1da1$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$be8df8872c3b1da1$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$be8df8872c3b1da1$export$16fa2f45be04daa8 = $be8df8872c3b1da1$var$E;
$be8df8872c3b1da1$export$ffb0004e005737fa = $be8df8872c3b1da1$var$p;
$be8df8872c3b1da1$export$e2c29f18771995cb = $be8df8872c3b1da1$var$r;
$be8df8872c3b1da1$export$221d75b3f55bb0bd = $be8df8872c3b1da1$var$G;
$be8df8872c3b1da1$export$5f8d39834fd61797 = $be8df8872c3b1da1$var$q;
$be8df8872c3b1da1$export$74bf444e3cd11ea5 = $be8df8872c3b1da1$var$w;
$be8df8872c3b1da1$export$ae55be85d98224ed = $be8df8872c3b1da1$var$W;
$be8df8872c3b1da1$export$3ba232387fd5d6dd = $be8df8872c3b1da1$var$X;
$be8df8872c3b1da1$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $be8df8872c3b1da1$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $be8df8872c3b1da1$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$be8df8872c3b1da1$var$J.call(b, f) && !$be8df8872c3b1da1$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $be8df8872c3b1da1$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$be8df8872c3b1da1$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $be8df8872c3b1da1$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $be8df8872c3b1da1$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$be8df8872c3b1da1$export$c8a8987d4410bf2d = $be8df8872c3b1da1$var$M;
$be8df8872c3b1da1$export$d38cd72104c1f0e9 = function(a) {
    var b = $be8df8872c3b1da1$var$M.bind(null, a);
    b.type = a;
    return b;
};
$be8df8872c3b1da1$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$be8df8872c3b1da1$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $be8df8872c3b1da1$var$v,
        render: a
    };
};
$be8df8872c3b1da1$export$a8257692ac88316c = $be8df8872c3b1da1$var$O;
$be8df8872c3b1da1$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $be8df8872c3b1da1$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $be8df8872c3b1da1$var$T
    };
};
$be8df8872c3b1da1$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $be8df8872c3b1da1$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$be8df8872c3b1da1$export$7568632d0d33d16d = function(a) {
    var b = $be8df8872c3b1da1$var$V.transition;
    $be8df8872c3b1da1$var$V.transition = {};
    try {
        a();
    } finally{
        $be8df8872c3b1da1$var$V.transition = b;
    }
};
$be8df8872c3b1da1$export$88948ce120ea2619 = $be8df8872c3b1da1$var$X;
$be8df8872c3b1da1$export$35808ee640e87ca7 = function(a, b) {
    return $be8df8872c3b1da1$var$U.current.useCallback(a, b);
};
$be8df8872c3b1da1$export$fae74005e78b1a27 = function(a) {
    return $be8df8872c3b1da1$var$U.current.useContext(a);
};
$be8df8872c3b1da1$export$dc8fbce3eb94dc1e = function() {};
$be8df8872c3b1da1$export$6a7bc4e911dc01cf = function(a) {
    return $be8df8872c3b1da1$var$U.current.useDeferredValue(a);
};
$be8df8872c3b1da1$export$6d9c69b0de29b591 = function(a, b) {
    return $be8df8872c3b1da1$var$U.current.useEffect(a, b);
};
$be8df8872c3b1da1$export$f680877a34711e37 = function() {
    return $be8df8872c3b1da1$var$U.current.useId();
};
$be8df8872c3b1da1$export$d5a552a76deda3c2 = function(a, b, e) {
    return $be8df8872c3b1da1$var$U.current.useImperativeHandle(a, b, e);
};
$be8df8872c3b1da1$export$aaabe4eda9ed9969 = function(a, b) {
    return $be8df8872c3b1da1$var$U.current.useInsertionEffect(a, b);
};
$be8df8872c3b1da1$export$e5c5a5f917a5871c = function(a, b) {
    return $be8df8872c3b1da1$var$U.current.useLayoutEffect(a, b);
};
$be8df8872c3b1da1$export$1538c33de8887b59 = function(a, b) {
    return $be8df8872c3b1da1$var$U.current.useMemo(a, b);
};
$be8df8872c3b1da1$export$13e3392192263954 = function(a, b, e) {
    return $be8df8872c3b1da1$var$U.current.useReducer(a, b, e);
};
$be8df8872c3b1da1$export$b8f5890fc79d6aca = function(a) {
    return $be8df8872c3b1da1$var$U.current.useRef(a);
};
$be8df8872c3b1da1$export$60241385465d0a34 = function(a) {
    return $be8df8872c3b1da1$var$U.current.useState(a);
};
$be8df8872c3b1da1$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $be8df8872c3b1da1$var$U.current.useSyncExternalStore(a, b, e);
};
$be8df8872c3b1da1$export$7b286972b8d8ccbf = function() {
    return $be8df8872c3b1da1$var$U.current.useTransition();
};
$be8df8872c3b1da1$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("e33fO", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $a3a3deaca4efee87$export$ae55be85d98224ed; }, function (v) { return $a3a3deaca4efee87$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $a3a3deaca4efee87$export$d39a5bbd09211389; }, function (v) { return $a3a3deaca4efee87$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $a3a3deaca4efee87$export$882461b6382ed46c; }, function (v) { return $a3a3deaca4efee87$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $a3a3deaca4efee87$export$466bfc07425424d5; }, function (v) { return $a3a3deaca4efee87$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $a3a3deaca4efee87$export$cd75ccfd720a3cd4; }, function (v) { return $a3a3deaca4efee87$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $a3a3deaca4efee87$export$fa8d919ba61d84db; }, function (v) { return $a3a3deaca4efee87$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $a3a3deaca4efee87$export$757ceba2d55c277e; }, function (v) { return $a3a3deaca4efee87$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $a3a3deaca4efee87$export$b3890eb0ae9dca99; }, function (v) { return $a3a3deaca4efee87$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $a3a3deaca4efee87$export$502457920280e6be; }, function (v) { return $a3a3deaca4efee87$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $a3a3deaca4efee87$export$c78a37762a8d58e1; }, function (v) { return $a3a3deaca4efee87$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $a3a3deaca4efee87$export$dc54d992c10e8a18; }, function (v) { return $a3a3deaca4efee87$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $a3a3deaca4efee87$export$83d89fbfd8236492; }, function (v) { return $a3a3deaca4efee87$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $a3a3deaca4efee87$export$ae55be85d98224ed;
var $a3a3deaca4efee87$export$d39a5bbd09211389;
var $a3a3deaca4efee87$export$882461b6382ed46c;
var $a3a3deaca4efee87$export$466bfc07425424d5;
var $a3a3deaca4efee87$export$cd75ccfd720a3cd4;
var $a3a3deaca4efee87$export$fa8d919ba61d84db;
var $a3a3deaca4efee87$export$757ceba2d55c277e;
var $a3a3deaca4efee87$export$b3890eb0ae9dca99;
var $a3a3deaca4efee87$export$502457920280e6be;
var $a3a3deaca4efee87$export$c78a37762a8d58e1;
var $a3a3deaca4efee87$export$dc54d992c10e8a18;
var $a3a3deaca4efee87$export$83d89fbfd8236492;
"use strict";

var $1wHBI = parcelRequire("1wHBI");

var $82Omh = parcelRequire("82Omh");
function $a3a3deaca4efee87$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $a3a3deaca4efee87$var$da = new Set, $a3a3deaca4efee87$var$ea = {};
function $a3a3deaca4efee87$var$fa(a, b) {
    $a3a3deaca4efee87$var$ha(a, b);
    $a3a3deaca4efee87$var$ha(a + "Capture", b);
}
function $a3a3deaca4efee87$var$ha(a, b) {
    $a3a3deaca4efee87$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$a3a3deaca4efee87$var$da.add(b[a]);
}
var $a3a3deaca4efee87$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $a3a3deaca4efee87$var$ja = Object.prototype.hasOwnProperty, $a3a3deaca4efee87$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $a3a3deaca4efee87$var$la = {}, $a3a3deaca4efee87$var$ma = {};
function $a3a3deaca4efee87$var$oa(a) {
    if ($a3a3deaca4efee87$var$ja.call($a3a3deaca4efee87$var$ma, a)) return !0;
    if ($a3a3deaca4efee87$var$ja.call($a3a3deaca4efee87$var$la, a)) return !1;
    if ($a3a3deaca4efee87$var$ka.test(a)) return $a3a3deaca4efee87$var$ma[a] = !0;
    $a3a3deaca4efee87$var$la[a] = !0;
    return !1;
}
function $a3a3deaca4efee87$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $a3a3deaca4efee87$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $a3a3deaca4efee87$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $a3a3deaca4efee87$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $a3a3deaca4efee87$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $a3a3deaca4efee87$var$z[a] = new $a3a3deaca4efee87$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $a3a3deaca4efee87$var$z[b] = new $a3a3deaca4efee87$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $a3a3deaca4efee87$var$z[a] = new $a3a3deaca4efee87$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $a3a3deaca4efee87$var$z[a] = new $a3a3deaca4efee87$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $a3a3deaca4efee87$var$z[a] = new $a3a3deaca4efee87$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $a3a3deaca4efee87$var$z[a] = new $a3a3deaca4efee87$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $a3a3deaca4efee87$var$z[a] = new $a3a3deaca4efee87$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $a3a3deaca4efee87$var$z[a] = new $a3a3deaca4efee87$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $a3a3deaca4efee87$var$z[a] = new $a3a3deaca4efee87$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $a3a3deaca4efee87$var$ra = /[\-:]([a-z])/g;
function $a3a3deaca4efee87$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($a3a3deaca4efee87$var$ra, $a3a3deaca4efee87$var$sa);
    $a3a3deaca4efee87$var$z[b] = new $a3a3deaca4efee87$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($a3a3deaca4efee87$var$ra, $a3a3deaca4efee87$var$sa);
    $a3a3deaca4efee87$var$z[b] = new $a3a3deaca4efee87$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($a3a3deaca4efee87$var$ra, $a3a3deaca4efee87$var$sa);
    $a3a3deaca4efee87$var$z[b] = new $a3a3deaca4efee87$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $a3a3deaca4efee87$var$z[a] = new $a3a3deaca4efee87$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$a3a3deaca4efee87$var$z.xlinkHref = new $a3a3deaca4efee87$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $a3a3deaca4efee87$var$z[a] = new $a3a3deaca4efee87$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $a3a3deaca4efee87$var$ta(a, b, c, d) {
    var e = $a3a3deaca4efee87$var$z.hasOwnProperty(b) ? $a3a3deaca4efee87$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $a3a3deaca4efee87$var$qa(b, c, e, d) && (c = null), d || null === e ? $a3a3deaca4efee87$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $a3a3deaca4efee87$var$ua = $1wHBI.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $a3a3deaca4efee87$var$va = Symbol.for("react.element"), $a3a3deaca4efee87$var$wa = Symbol.for("react.portal"), $a3a3deaca4efee87$var$ya = Symbol.for("react.fragment"), $a3a3deaca4efee87$var$za = Symbol.for("react.strict_mode"), $a3a3deaca4efee87$var$Aa = Symbol.for("react.profiler"), $a3a3deaca4efee87$var$Ba = Symbol.for("react.provider"), $a3a3deaca4efee87$var$Ca = Symbol.for("react.context"), $a3a3deaca4efee87$var$Da = Symbol.for("react.forward_ref"), $a3a3deaca4efee87$var$Ea = Symbol.for("react.suspense"), $a3a3deaca4efee87$var$Fa = Symbol.for("react.suspense_list"), $a3a3deaca4efee87$var$Ga = Symbol.for("react.memo"), $a3a3deaca4efee87$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $a3a3deaca4efee87$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $a3a3deaca4efee87$var$Ja = Symbol.iterator;
function $a3a3deaca4efee87$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $a3a3deaca4efee87$var$Ja && a[$a3a3deaca4efee87$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $a3a3deaca4efee87$var$A = Object.assign, $a3a3deaca4efee87$var$La;
function $a3a3deaca4efee87$var$Ma(a) {
    if (void 0 === $a3a3deaca4efee87$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $a3a3deaca4efee87$var$La = b && b[1] || "";
    }
    return "\n" + $a3a3deaca4efee87$var$La + a;
}
var $a3a3deaca4efee87$var$Na = !1;
function $a3a3deaca4efee87$var$Oa(a, b) {
    if (!a || $a3a3deaca4efee87$var$Na) return "";
    $a3a3deaca4efee87$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $a3a3deaca4efee87$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $a3a3deaca4efee87$var$Ma(a) : "";
}
function $a3a3deaca4efee87$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $a3a3deaca4efee87$var$Ma(a.type);
        case 16:
            return $a3a3deaca4efee87$var$Ma("Lazy");
        case 13:
            return $a3a3deaca4efee87$var$Ma("Suspense");
        case 19:
            return $a3a3deaca4efee87$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $a3a3deaca4efee87$var$Oa(a.type, !1), a;
        case 11:
            return a = $a3a3deaca4efee87$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $a3a3deaca4efee87$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $a3a3deaca4efee87$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $a3a3deaca4efee87$var$ya:
            return "Fragment";
        case $a3a3deaca4efee87$var$wa:
            return "Portal";
        case $a3a3deaca4efee87$var$Aa:
            return "Profiler";
        case $a3a3deaca4efee87$var$za:
            return "StrictMode";
        case $a3a3deaca4efee87$var$Ea:
            return "Suspense";
        case $a3a3deaca4efee87$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $a3a3deaca4efee87$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $a3a3deaca4efee87$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $a3a3deaca4efee87$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $a3a3deaca4efee87$var$Ga:
            return b = a.displayName || null, null !== b ? b : $a3a3deaca4efee87$var$Qa(a.type) || "Memo";
        case $a3a3deaca4efee87$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $a3a3deaca4efee87$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $a3a3deaca4efee87$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $a3a3deaca4efee87$var$Qa(b);
        case 8:
            return b === $a3a3deaca4efee87$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $a3a3deaca4efee87$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $a3a3deaca4efee87$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $a3a3deaca4efee87$var$Ua(a) {
    var b = $a3a3deaca4efee87$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $a3a3deaca4efee87$var$Va(a) {
    a._valueTracker || (a._valueTracker = $a3a3deaca4efee87$var$Ua(a));
}
function $a3a3deaca4efee87$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $a3a3deaca4efee87$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $a3a3deaca4efee87$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $a3a3deaca4efee87$var$Ya(a, b) {
    var c = b.checked;
    return $a3a3deaca4efee87$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $a3a3deaca4efee87$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $a3a3deaca4efee87$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a3a3deaca4efee87$var$ab(a, b) {
    b = b.checked;
    null != b && $a3a3deaca4efee87$var$ta(a, "checked", b, !1);
}
function $a3a3deaca4efee87$var$bb(a, b) {
    $a3a3deaca4efee87$var$ab(a, b);
    var c = $a3a3deaca4efee87$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $a3a3deaca4efee87$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $a3a3deaca4efee87$var$cb(a, b.type, $a3a3deaca4efee87$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $a3a3deaca4efee87$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $a3a3deaca4efee87$var$cb(a, b, c) {
    if ("number" !== b || $a3a3deaca4efee87$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $a3a3deaca4efee87$var$eb = Array.isArray;
function $a3a3deaca4efee87$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $a3a3deaca4efee87$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $a3a3deaca4efee87$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($a3a3deaca4efee87$var$p(91));
    return $a3a3deaca4efee87$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $a3a3deaca4efee87$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($a3a3deaca4efee87$var$p(92));
            if ($a3a3deaca4efee87$var$eb(c)) {
                if (1 < c.length) throw Error($a3a3deaca4efee87$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $a3a3deaca4efee87$var$Sa(c)
    };
}
function $a3a3deaca4efee87$var$ib(a, b) {
    var c = $a3a3deaca4efee87$var$Sa(b.value), d = $a3a3deaca4efee87$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $a3a3deaca4efee87$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $a3a3deaca4efee87$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $a3a3deaca4efee87$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $a3a3deaca4efee87$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $a3a3deaca4efee87$var$mb, $a3a3deaca4efee87$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $a3a3deaca4efee87$var$mb = $a3a3deaca4efee87$var$mb || document.createElement("div");
        $a3a3deaca4efee87$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $a3a3deaca4efee87$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $a3a3deaca4efee87$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $a3a3deaca4efee87$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $a3a3deaca4efee87$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($a3a3deaca4efee87$var$pb).forEach(function(a) {
    $a3a3deaca4efee87$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $a3a3deaca4efee87$var$pb[b] = $a3a3deaca4efee87$var$pb[a];
    });
});
function $a3a3deaca4efee87$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $a3a3deaca4efee87$var$pb.hasOwnProperty(a) && $a3a3deaca4efee87$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $a3a3deaca4efee87$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $a3a3deaca4efee87$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $a3a3deaca4efee87$var$tb = $a3a3deaca4efee87$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $a3a3deaca4efee87$var$ub(a, b) {
    if (b) {
        if ($a3a3deaca4efee87$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($a3a3deaca4efee87$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($a3a3deaca4efee87$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($a3a3deaca4efee87$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($a3a3deaca4efee87$var$p(62));
    }
}
function $a3a3deaca4efee87$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $a3a3deaca4efee87$var$wb = null;
function $a3a3deaca4efee87$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $a3a3deaca4efee87$var$yb = null, $a3a3deaca4efee87$var$zb = null, $a3a3deaca4efee87$var$Ab = null;
function $a3a3deaca4efee87$var$Bb(a) {
    if (a = $a3a3deaca4efee87$var$Cb(a)) {
        if ("function" !== typeof $a3a3deaca4efee87$var$yb) throw Error($a3a3deaca4efee87$var$p(280));
        var b = a.stateNode;
        b && (b = $a3a3deaca4efee87$var$Db(b), $a3a3deaca4efee87$var$yb(a.stateNode, a.type, b));
    }
}
function $a3a3deaca4efee87$var$Eb(a) {
    $a3a3deaca4efee87$var$zb ? $a3a3deaca4efee87$var$Ab ? $a3a3deaca4efee87$var$Ab.push(a) : $a3a3deaca4efee87$var$Ab = [
        a
    ] : $a3a3deaca4efee87$var$zb = a;
}
function $a3a3deaca4efee87$var$Fb() {
    if ($a3a3deaca4efee87$var$zb) {
        var a = $a3a3deaca4efee87$var$zb, b = $a3a3deaca4efee87$var$Ab;
        $a3a3deaca4efee87$var$Ab = $a3a3deaca4efee87$var$zb = null;
        $a3a3deaca4efee87$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$a3a3deaca4efee87$var$Bb(b[a]);
    }
}
function $a3a3deaca4efee87$var$Gb(a, b) {
    return a(b);
}
function $a3a3deaca4efee87$var$Hb() {}
var $a3a3deaca4efee87$var$Ib = !1;
function $a3a3deaca4efee87$var$Jb(a, b, c) {
    if ($a3a3deaca4efee87$var$Ib) return a(b, c);
    $a3a3deaca4efee87$var$Ib = !0;
    try {
        return $a3a3deaca4efee87$var$Gb(a, b, c);
    } finally{
        if ($a3a3deaca4efee87$var$Ib = !1, null !== $a3a3deaca4efee87$var$zb || null !== $a3a3deaca4efee87$var$Ab) $a3a3deaca4efee87$var$Hb(), $a3a3deaca4efee87$var$Fb();
    }
}
function $a3a3deaca4efee87$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $a3a3deaca4efee87$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($a3a3deaca4efee87$var$p(231, b, typeof c));
    return c;
}
var $a3a3deaca4efee87$var$Lb = !1;
if ($a3a3deaca4efee87$var$ia) try {
    var $a3a3deaca4efee87$var$Mb = {};
    Object.defineProperty($a3a3deaca4efee87$var$Mb, "passive", {
        get: function() {
            $a3a3deaca4efee87$var$Lb = !0;
        }
    });
    window.addEventListener("test", $a3a3deaca4efee87$var$Mb, $a3a3deaca4efee87$var$Mb);
    window.removeEventListener("test", $a3a3deaca4efee87$var$Mb, $a3a3deaca4efee87$var$Mb);
} catch (a) {
    $a3a3deaca4efee87$var$Lb = !1;
}
function $a3a3deaca4efee87$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $a3a3deaca4efee87$var$Ob = !1, $a3a3deaca4efee87$var$Pb = null, $a3a3deaca4efee87$var$Qb = !1, $a3a3deaca4efee87$var$Rb = null, $a3a3deaca4efee87$var$Sb = {
    onError: function(a) {
        $a3a3deaca4efee87$var$Ob = !0;
        $a3a3deaca4efee87$var$Pb = a;
    }
};
function $a3a3deaca4efee87$var$Tb(a, b, c, d, e, f, g, h, k) {
    $a3a3deaca4efee87$var$Ob = !1;
    $a3a3deaca4efee87$var$Pb = null;
    $a3a3deaca4efee87$var$Nb.apply($a3a3deaca4efee87$var$Sb, arguments);
}
function $a3a3deaca4efee87$var$Ub(a, b, c, d, e, f, g, h, k) {
    $a3a3deaca4efee87$var$Tb.apply(this, arguments);
    if ($a3a3deaca4efee87$var$Ob) {
        if ($a3a3deaca4efee87$var$Ob) {
            var l = $a3a3deaca4efee87$var$Pb;
            $a3a3deaca4efee87$var$Ob = !1;
            $a3a3deaca4efee87$var$Pb = null;
        } else throw Error($a3a3deaca4efee87$var$p(198));
        $a3a3deaca4efee87$var$Qb || ($a3a3deaca4efee87$var$Qb = !0, $a3a3deaca4efee87$var$Rb = l);
    }
}
function $a3a3deaca4efee87$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $a3a3deaca4efee87$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $a3a3deaca4efee87$var$Xb(a) {
    if ($a3a3deaca4efee87$var$Vb(a) !== a) throw Error($a3a3deaca4efee87$var$p(188));
}
function $a3a3deaca4efee87$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $a3a3deaca4efee87$var$Vb(a);
        if (null === b) throw Error($a3a3deaca4efee87$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $a3a3deaca4efee87$var$Xb(e), a;
                if (f === d) return $a3a3deaca4efee87$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($a3a3deaca4efee87$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($a3a3deaca4efee87$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($a3a3deaca4efee87$var$p(190));
    }
    if (3 !== c.tag) throw Error($a3a3deaca4efee87$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $a3a3deaca4efee87$var$Zb(a) {
    a = $a3a3deaca4efee87$var$Yb(a);
    return null !== a ? $a3a3deaca4efee87$var$$b(a) : null;
}
function $a3a3deaca4efee87$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $a3a3deaca4efee87$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $a3a3deaca4efee87$var$ac = $82Omh.unstable_scheduleCallback, $a3a3deaca4efee87$var$bc = $82Omh.unstable_cancelCallback, $a3a3deaca4efee87$var$cc = $82Omh.unstable_shouldYield, $a3a3deaca4efee87$var$dc = $82Omh.unstable_requestPaint, $a3a3deaca4efee87$var$B = $82Omh.unstable_now, $a3a3deaca4efee87$var$ec = $82Omh.unstable_getCurrentPriorityLevel, $a3a3deaca4efee87$var$fc = $82Omh.unstable_ImmediatePriority, $a3a3deaca4efee87$var$gc = $82Omh.unstable_UserBlockingPriority, $a3a3deaca4efee87$var$hc = $82Omh.unstable_NormalPriority, $a3a3deaca4efee87$var$ic = $82Omh.unstable_LowPriority, $a3a3deaca4efee87$var$jc = $82Omh.unstable_IdlePriority, $a3a3deaca4efee87$var$kc = null, $a3a3deaca4efee87$var$lc = null;
function $a3a3deaca4efee87$var$mc(a) {
    if ($a3a3deaca4efee87$var$lc && "function" === typeof $a3a3deaca4efee87$var$lc.onCommitFiberRoot) try {
        $a3a3deaca4efee87$var$lc.onCommitFiberRoot($a3a3deaca4efee87$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $a3a3deaca4efee87$var$oc = Math.clz32 ? Math.clz32 : $a3a3deaca4efee87$var$nc, $a3a3deaca4efee87$var$pc = Math.log, $a3a3deaca4efee87$var$qc = Math.LN2;
function $a3a3deaca4efee87$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($a3a3deaca4efee87$var$pc(a) / $a3a3deaca4efee87$var$qc | 0) | 0;
}
var $a3a3deaca4efee87$var$rc = 64, $a3a3deaca4efee87$var$sc = 4194304;
function $a3a3deaca4efee87$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $a3a3deaca4efee87$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $a3a3deaca4efee87$var$tc(h) : (f &= g, 0 !== f && (d = $a3a3deaca4efee87$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $a3a3deaca4efee87$var$tc(g) : 0 !== f && (d = $a3a3deaca4efee87$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $a3a3deaca4efee87$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $a3a3deaca4efee87$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $a3a3deaca4efee87$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $a3a3deaca4efee87$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $a3a3deaca4efee87$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $a3a3deaca4efee87$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $a3a3deaca4efee87$var$yc() {
    var a = $a3a3deaca4efee87$var$rc;
    $a3a3deaca4efee87$var$rc <<= 1;
    0 === ($a3a3deaca4efee87$var$rc & 4194240) && ($a3a3deaca4efee87$var$rc = 64);
    return a;
}
function $a3a3deaca4efee87$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $a3a3deaca4efee87$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $a3a3deaca4efee87$var$oc(b);
    a[b] = c;
}
function $a3a3deaca4efee87$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $a3a3deaca4efee87$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $a3a3deaca4efee87$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $a3a3deaca4efee87$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $a3a3deaca4efee87$var$C = 0;
function $a3a3deaca4efee87$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $a3a3deaca4efee87$var$Ec, $a3a3deaca4efee87$var$Fc, $a3a3deaca4efee87$var$Gc, $a3a3deaca4efee87$var$Hc, $a3a3deaca4efee87$var$Ic, $a3a3deaca4efee87$var$Jc = !1, $a3a3deaca4efee87$var$Kc = [], $a3a3deaca4efee87$var$Lc = null, $a3a3deaca4efee87$var$Mc = null, $a3a3deaca4efee87$var$Nc = null, $a3a3deaca4efee87$var$Oc = new Map, $a3a3deaca4efee87$var$Pc = new Map, $a3a3deaca4efee87$var$Qc = [], $a3a3deaca4efee87$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $a3a3deaca4efee87$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $a3a3deaca4efee87$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $a3a3deaca4efee87$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $a3a3deaca4efee87$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $a3a3deaca4efee87$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $a3a3deaca4efee87$var$Pc.delete(b.pointerId);
    }
}
function $a3a3deaca4efee87$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $a3a3deaca4efee87$var$Cb(b), null !== b && $a3a3deaca4efee87$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $a3a3deaca4efee87$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $a3a3deaca4efee87$var$Lc = $a3a3deaca4efee87$var$Tc($a3a3deaca4efee87$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $a3a3deaca4efee87$var$Mc = $a3a3deaca4efee87$var$Tc($a3a3deaca4efee87$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $a3a3deaca4efee87$var$Nc = $a3a3deaca4efee87$var$Tc($a3a3deaca4efee87$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $a3a3deaca4efee87$var$Oc.set(f, $a3a3deaca4efee87$var$Tc($a3a3deaca4efee87$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $a3a3deaca4efee87$var$Pc.set(f, $a3a3deaca4efee87$var$Tc($a3a3deaca4efee87$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $a3a3deaca4efee87$var$Vc(a) {
    var b = $a3a3deaca4efee87$var$Wc(a.target);
    if (null !== b) {
        var c = $a3a3deaca4efee87$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $a3a3deaca4efee87$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $a3a3deaca4efee87$var$Ic(a.priority, function() {
                        $a3a3deaca4efee87$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $a3a3deaca4efee87$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $a3a3deaca4efee87$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $a3a3deaca4efee87$var$wb = d;
            c.target.dispatchEvent(d);
            $a3a3deaca4efee87$var$wb = null;
        } else return b = $a3a3deaca4efee87$var$Cb(c), null !== b && $a3a3deaca4efee87$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $a3a3deaca4efee87$var$Zc(a, b, c) {
    $a3a3deaca4efee87$var$Xc(a) && c.delete(b);
}
function $a3a3deaca4efee87$var$$c() {
    $a3a3deaca4efee87$var$Jc = !1;
    null !== $a3a3deaca4efee87$var$Lc && $a3a3deaca4efee87$var$Xc($a3a3deaca4efee87$var$Lc) && ($a3a3deaca4efee87$var$Lc = null);
    null !== $a3a3deaca4efee87$var$Mc && $a3a3deaca4efee87$var$Xc($a3a3deaca4efee87$var$Mc) && ($a3a3deaca4efee87$var$Mc = null);
    null !== $a3a3deaca4efee87$var$Nc && $a3a3deaca4efee87$var$Xc($a3a3deaca4efee87$var$Nc) && ($a3a3deaca4efee87$var$Nc = null);
    $a3a3deaca4efee87$var$Oc.forEach($a3a3deaca4efee87$var$Zc);
    $a3a3deaca4efee87$var$Pc.forEach($a3a3deaca4efee87$var$Zc);
}
function $a3a3deaca4efee87$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $a3a3deaca4efee87$var$Jc || ($a3a3deaca4efee87$var$Jc = !0, $82Omh.unstable_scheduleCallback($82Omh.unstable_NormalPriority, $a3a3deaca4efee87$var$$c)));
}
function $a3a3deaca4efee87$var$bd(a) {
    function b(b) {
        return $a3a3deaca4efee87$var$ad(b, a);
    }
    if (0 < $a3a3deaca4efee87$var$Kc.length) {
        $a3a3deaca4efee87$var$ad($a3a3deaca4efee87$var$Kc[0], a);
        for(var c = 1; c < $a3a3deaca4efee87$var$Kc.length; c++){
            var d = $a3a3deaca4efee87$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $a3a3deaca4efee87$var$Lc && $a3a3deaca4efee87$var$ad($a3a3deaca4efee87$var$Lc, a);
    null !== $a3a3deaca4efee87$var$Mc && $a3a3deaca4efee87$var$ad($a3a3deaca4efee87$var$Mc, a);
    null !== $a3a3deaca4efee87$var$Nc && $a3a3deaca4efee87$var$ad($a3a3deaca4efee87$var$Nc, a);
    $a3a3deaca4efee87$var$Oc.forEach(b);
    $a3a3deaca4efee87$var$Pc.forEach(b);
    for(c = 0; c < $a3a3deaca4efee87$var$Qc.length; c++)d = $a3a3deaca4efee87$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $a3a3deaca4efee87$var$Qc.length && (c = $a3a3deaca4efee87$var$Qc[0], null === c.blockedOn);)$a3a3deaca4efee87$var$Vc(c), null === c.blockedOn && $a3a3deaca4efee87$var$Qc.shift();
}
var $a3a3deaca4efee87$var$cd = $a3a3deaca4efee87$var$ua.ReactCurrentBatchConfig, $a3a3deaca4efee87$var$dd = !0;
function $a3a3deaca4efee87$var$ed(a, b, c, d) {
    var e = $a3a3deaca4efee87$var$C, f = $a3a3deaca4efee87$var$cd.transition;
    $a3a3deaca4efee87$var$cd.transition = null;
    try {
        $a3a3deaca4efee87$var$C = 1, $a3a3deaca4efee87$var$fd(a, b, c, d);
    } finally{
        $a3a3deaca4efee87$var$C = e, $a3a3deaca4efee87$var$cd.transition = f;
    }
}
function $a3a3deaca4efee87$var$gd(a, b, c, d) {
    var e = $a3a3deaca4efee87$var$C, f = $a3a3deaca4efee87$var$cd.transition;
    $a3a3deaca4efee87$var$cd.transition = null;
    try {
        $a3a3deaca4efee87$var$C = 4, $a3a3deaca4efee87$var$fd(a, b, c, d);
    } finally{
        $a3a3deaca4efee87$var$C = e, $a3a3deaca4efee87$var$cd.transition = f;
    }
}
function $a3a3deaca4efee87$var$fd(a, b, c, d) {
    if ($a3a3deaca4efee87$var$dd) {
        var e = $a3a3deaca4efee87$var$Yc(a, b, c, d);
        if (null === e) $a3a3deaca4efee87$var$hd(a, b, d, $a3a3deaca4efee87$var$id, c), $a3a3deaca4efee87$var$Sc(a, d);
        else if ($a3a3deaca4efee87$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($a3a3deaca4efee87$var$Sc(a, d), b & 4 && -1 < $a3a3deaca4efee87$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $a3a3deaca4efee87$var$Cb(e);
                null !== f && $a3a3deaca4efee87$var$Ec(f);
                f = $a3a3deaca4efee87$var$Yc(a, b, c, d);
                null === f && $a3a3deaca4efee87$var$hd(a, b, d, $a3a3deaca4efee87$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $a3a3deaca4efee87$var$hd(a, b, d, null, c);
    }
}
var $a3a3deaca4efee87$var$id = null;
function $a3a3deaca4efee87$var$Yc(a, b, c, d) {
    $a3a3deaca4efee87$var$id = null;
    a = $a3a3deaca4efee87$var$xb(d);
    a = $a3a3deaca4efee87$var$Wc(a);
    if (null !== a) {
        if (b = $a3a3deaca4efee87$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $a3a3deaca4efee87$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $a3a3deaca4efee87$var$id = a;
    return null;
}
function $a3a3deaca4efee87$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($a3a3deaca4efee87$var$ec()){
                case $a3a3deaca4efee87$var$fc:
                    return 1;
                case $a3a3deaca4efee87$var$gc:
                    return 4;
                case $a3a3deaca4efee87$var$hc:
                case $a3a3deaca4efee87$var$ic:
                    return 16;
                case $a3a3deaca4efee87$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $a3a3deaca4efee87$var$kd = null, $a3a3deaca4efee87$var$ld = null, $a3a3deaca4efee87$var$md = null;
function $a3a3deaca4efee87$var$nd() {
    if ($a3a3deaca4efee87$var$md) return $a3a3deaca4efee87$var$md;
    var a, b = $a3a3deaca4efee87$var$ld, c = b.length, d, e = "value" in $a3a3deaca4efee87$var$kd ? $a3a3deaca4efee87$var$kd.value : $a3a3deaca4efee87$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $a3a3deaca4efee87$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $a3a3deaca4efee87$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $a3a3deaca4efee87$var$pd() {
    return !0;
}
function $a3a3deaca4efee87$var$qd() {
    return !1;
}
function $a3a3deaca4efee87$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $a3a3deaca4efee87$var$pd : $a3a3deaca4efee87$var$qd;
        this.isPropagationStopped = $a3a3deaca4efee87$var$qd;
        return this;
    }
    $a3a3deaca4efee87$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $a3a3deaca4efee87$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $a3a3deaca4efee87$var$pd);
        },
        persist: function() {},
        isPersistent: $a3a3deaca4efee87$var$pd
    });
    return b;
}
var $a3a3deaca4efee87$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $a3a3deaca4efee87$var$td = $a3a3deaca4efee87$var$rd($a3a3deaca4efee87$var$sd), $a3a3deaca4efee87$var$ud = $a3a3deaca4efee87$var$A({}, $a3a3deaca4efee87$var$sd, {
    view: 0,
    detail: 0
}), $a3a3deaca4efee87$var$vd = $a3a3deaca4efee87$var$rd($a3a3deaca4efee87$var$ud), $a3a3deaca4efee87$var$wd, $a3a3deaca4efee87$var$xd, $a3a3deaca4efee87$var$yd, $a3a3deaca4efee87$var$Ad = $a3a3deaca4efee87$var$A({}, $a3a3deaca4efee87$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $a3a3deaca4efee87$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $a3a3deaca4efee87$var$yd && ($a3a3deaca4efee87$var$yd && "mousemove" === a.type ? ($a3a3deaca4efee87$var$wd = a.screenX - $a3a3deaca4efee87$var$yd.screenX, $a3a3deaca4efee87$var$xd = a.screenY - $a3a3deaca4efee87$var$yd.screenY) : $a3a3deaca4efee87$var$xd = $a3a3deaca4efee87$var$wd = 0, $a3a3deaca4efee87$var$yd = a);
        return $a3a3deaca4efee87$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $a3a3deaca4efee87$var$xd;
    }
}), $a3a3deaca4efee87$var$Bd = $a3a3deaca4efee87$var$rd($a3a3deaca4efee87$var$Ad), $a3a3deaca4efee87$var$Cd = $a3a3deaca4efee87$var$A({}, $a3a3deaca4efee87$var$Ad, {
    dataTransfer: 0
}), $a3a3deaca4efee87$var$Dd = $a3a3deaca4efee87$var$rd($a3a3deaca4efee87$var$Cd), $a3a3deaca4efee87$var$Ed = $a3a3deaca4efee87$var$A({}, $a3a3deaca4efee87$var$ud, {
    relatedTarget: 0
}), $a3a3deaca4efee87$var$Fd = $a3a3deaca4efee87$var$rd($a3a3deaca4efee87$var$Ed), $a3a3deaca4efee87$var$Gd = $a3a3deaca4efee87$var$A({}, $a3a3deaca4efee87$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a3a3deaca4efee87$var$Hd = $a3a3deaca4efee87$var$rd($a3a3deaca4efee87$var$Gd), $a3a3deaca4efee87$var$Id = $a3a3deaca4efee87$var$A({}, $a3a3deaca4efee87$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $a3a3deaca4efee87$var$Jd = $a3a3deaca4efee87$var$rd($a3a3deaca4efee87$var$Id), $a3a3deaca4efee87$var$Kd = $a3a3deaca4efee87$var$A({}, $a3a3deaca4efee87$var$sd, {
    data: 0
}), $a3a3deaca4efee87$var$Ld = $a3a3deaca4efee87$var$rd($a3a3deaca4efee87$var$Kd), $a3a3deaca4efee87$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $a3a3deaca4efee87$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $a3a3deaca4efee87$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $a3a3deaca4efee87$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $a3a3deaca4efee87$var$Od[a]) ? !!b[a] : !1;
}
function $a3a3deaca4efee87$var$zd() {
    return $a3a3deaca4efee87$var$Pd;
}
var $a3a3deaca4efee87$var$Qd = $a3a3deaca4efee87$var$A({}, $a3a3deaca4efee87$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $a3a3deaca4efee87$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $a3a3deaca4efee87$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $a3a3deaca4efee87$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $a3a3deaca4efee87$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $a3a3deaca4efee87$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $a3a3deaca4efee87$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $a3a3deaca4efee87$var$Rd = $a3a3deaca4efee87$var$rd($a3a3deaca4efee87$var$Qd), $a3a3deaca4efee87$var$Sd = $a3a3deaca4efee87$var$A({}, $a3a3deaca4efee87$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $a3a3deaca4efee87$var$Td = $a3a3deaca4efee87$var$rd($a3a3deaca4efee87$var$Sd), $a3a3deaca4efee87$var$Ud = $a3a3deaca4efee87$var$A({}, $a3a3deaca4efee87$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $a3a3deaca4efee87$var$zd
}), $a3a3deaca4efee87$var$Vd = $a3a3deaca4efee87$var$rd($a3a3deaca4efee87$var$Ud), $a3a3deaca4efee87$var$Wd = $a3a3deaca4efee87$var$A({}, $a3a3deaca4efee87$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a3a3deaca4efee87$var$Xd = $a3a3deaca4efee87$var$rd($a3a3deaca4efee87$var$Wd), $a3a3deaca4efee87$var$Yd = $a3a3deaca4efee87$var$A({}, $a3a3deaca4efee87$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $a3a3deaca4efee87$var$Zd = $a3a3deaca4efee87$var$rd($a3a3deaca4efee87$var$Yd), $a3a3deaca4efee87$var$$d = [
    9,
    13,
    27,
    32
], $a3a3deaca4efee87$var$ae = $a3a3deaca4efee87$var$ia && "CompositionEvent" in window, $a3a3deaca4efee87$var$be = null;
$a3a3deaca4efee87$var$ia && "documentMode" in document && ($a3a3deaca4efee87$var$be = document.documentMode);
var $a3a3deaca4efee87$var$ce = $a3a3deaca4efee87$var$ia && "TextEvent" in window && !$a3a3deaca4efee87$var$be, $a3a3deaca4efee87$var$de = $a3a3deaca4efee87$var$ia && (!$a3a3deaca4efee87$var$ae || $a3a3deaca4efee87$var$be && 8 < $a3a3deaca4efee87$var$be && 11 >= $a3a3deaca4efee87$var$be), $a3a3deaca4efee87$var$ee = String.fromCharCode(32), $a3a3deaca4efee87$var$fe = !1;
function $a3a3deaca4efee87$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $a3a3deaca4efee87$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $a3a3deaca4efee87$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $a3a3deaca4efee87$var$ie = !1;
function $a3a3deaca4efee87$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $a3a3deaca4efee87$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $a3a3deaca4efee87$var$fe = !0;
            return $a3a3deaca4efee87$var$ee;
        case "textInput":
            return a = b.data, a === $a3a3deaca4efee87$var$ee && $a3a3deaca4efee87$var$fe ? null : a;
        default:
            return null;
    }
}
function $a3a3deaca4efee87$var$ke(a, b) {
    if ($a3a3deaca4efee87$var$ie) return "compositionend" === a || !$a3a3deaca4efee87$var$ae && $a3a3deaca4efee87$var$ge(a, b) ? (a = $a3a3deaca4efee87$var$nd(), $a3a3deaca4efee87$var$md = $a3a3deaca4efee87$var$ld = $a3a3deaca4efee87$var$kd = null, $a3a3deaca4efee87$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $a3a3deaca4efee87$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $a3a3deaca4efee87$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $a3a3deaca4efee87$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$a3a3deaca4efee87$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $a3a3deaca4efee87$var$ne(a, b, c, d) {
    $a3a3deaca4efee87$var$Eb(d);
    b = $a3a3deaca4efee87$var$oe(b, "onChange");
    0 < b.length && (c = new $a3a3deaca4efee87$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $a3a3deaca4efee87$var$pe = null, $a3a3deaca4efee87$var$qe = null;
function $a3a3deaca4efee87$var$re(a) {
    $a3a3deaca4efee87$var$se(a, 0);
}
function $a3a3deaca4efee87$var$te(a) {
    var b = $a3a3deaca4efee87$var$ue(a);
    if ($a3a3deaca4efee87$var$Wa(b)) return a;
}
function $a3a3deaca4efee87$var$ve(a, b) {
    if ("change" === a) return b;
}
var $a3a3deaca4efee87$var$we = !1;
if ($a3a3deaca4efee87$var$ia) {
    var $a3a3deaca4efee87$var$xe;
    if ($a3a3deaca4efee87$var$ia) {
        var $a3a3deaca4efee87$var$ye = "oninput" in document;
        if (!$a3a3deaca4efee87$var$ye) {
            var $a3a3deaca4efee87$var$ze = document.createElement("div");
            $a3a3deaca4efee87$var$ze.setAttribute("oninput", "return;");
            $a3a3deaca4efee87$var$ye = "function" === typeof $a3a3deaca4efee87$var$ze.oninput;
        }
        $a3a3deaca4efee87$var$xe = $a3a3deaca4efee87$var$ye;
    } else $a3a3deaca4efee87$var$xe = !1;
    $a3a3deaca4efee87$var$we = $a3a3deaca4efee87$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $a3a3deaca4efee87$var$Ae() {
    $a3a3deaca4efee87$var$pe && ($a3a3deaca4efee87$var$pe.detachEvent("onpropertychange", $a3a3deaca4efee87$var$Be), $a3a3deaca4efee87$var$qe = $a3a3deaca4efee87$var$pe = null);
}
function $a3a3deaca4efee87$var$Be(a) {
    if ("value" === a.propertyName && $a3a3deaca4efee87$var$te($a3a3deaca4efee87$var$qe)) {
        var b = [];
        $a3a3deaca4efee87$var$ne(b, $a3a3deaca4efee87$var$qe, a, $a3a3deaca4efee87$var$xb(a));
        $a3a3deaca4efee87$var$Jb($a3a3deaca4efee87$var$re, b);
    }
}
function $a3a3deaca4efee87$var$Ce(a, b, c) {
    "focusin" === a ? ($a3a3deaca4efee87$var$Ae(), $a3a3deaca4efee87$var$pe = b, $a3a3deaca4efee87$var$qe = c, $a3a3deaca4efee87$var$pe.attachEvent("onpropertychange", $a3a3deaca4efee87$var$Be)) : "focusout" === a && $a3a3deaca4efee87$var$Ae();
}
function $a3a3deaca4efee87$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $a3a3deaca4efee87$var$te($a3a3deaca4efee87$var$qe);
}
function $a3a3deaca4efee87$var$Ee(a, b) {
    if ("click" === a) return $a3a3deaca4efee87$var$te(b);
}
function $a3a3deaca4efee87$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $a3a3deaca4efee87$var$te(b);
}
function $a3a3deaca4efee87$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a3a3deaca4efee87$var$He = "function" === typeof Object.is ? Object.is : $a3a3deaca4efee87$var$Ge;
function $a3a3deaca4efee87$var$Ie(a, b) {
    if ($a3a3deaca4efee87$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$a3a3deaca4efee87$var$ja.call(b, e) || !$a3a3deaca4efee87$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $a3a3deaca4efee87$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $a3a3deaca4efee87$var$Ke(a, b) {
    var c = $a3a3deaca4efee87$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $a3a3deaca4efee87$var$Je(c);
    }
}
function $a3a3deaca4efee87$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $a3a3deaca4efee87$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $a3a3deaca4efee87$var$Me() {
    for(var a = window, b = $a3a3deaca4efee87$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $a3a3deaca4efee87$var$Xa(a.document);
    }
    return b;
}
function $a3a3deaca4efee87$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $a3a3deaca4efee87$var$Oe(a) {
    var b = $a3a3deaca4efee87$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $a3a3deaca4efee87$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $a3a3deaca4efee87$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $a3a3deaca4efee87$var$Ke(c, f);
                var g = $a3a3deaca4efee87$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $a3a3deaca4efee87$var$Pe = $a3a3deaca4efee87$var$ia && "documentMode" in document && 11 >= document.documentMode, $a3a3deaca4efee87$var$Qe = null, $a3a3deaca4efee87$var$Re = null, $a3a3deaca4efee87$var$Se = null, $a3a3deaca4efee87$var$Te = !1;
function $a3a3deaca4efee87$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $a3a3deaca4efee87$var$Te || null == $a3a3deaca4efee87$var$Qe || $a3a3deaca4efee87$var$Qe !== $a3a3deaca4efee87$var$Xa(d) || (d = $a3a3deaca4efee87$var$Qe, "selectionStart" in d && $a3a3deaca4efee87$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $a3a3deaca4efee87$var$Se && $a3a3deaca4efee87$var$Ie($a3a3deaca4efee87$var$Se, d) || ($a3a3deaca4efee87$var$Se = d, d = $a3a3deaca4efee87$var$oe($a3a3deaca4efee87$var$Re, "onSelect"), 0 < d.length && (b = new $a3a3deaca4efee87$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $a3a3deaca4efee87$var$Qe)));
}
function $a3a3deaca4efee87$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $a3a3deaca4efee87$var$We = {
    animationend: $a3a3deaca4efee87$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $a3a3deaca4efee87$var$Ve("Animation", "AnimationIteration"),
    animationstart: $a3a3deaca4efee87$var$Ve("Animation", "AnimationStart"),
    transitionend: $a3a3deaca4efee87$var$Ve("Transition", "TransitionEnd")
}, $a3a3deaca4efee87$var$Xe = {}, $a3a3deaca4efee87$var$Ye = {};
$a3a3deaca4efee87$var$ia && ($a3a3deaca4efee87$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $a3a3deaca4efee87$var$We.animationend.animation, delete $a3a3deaca4efee87$var$We.animationiteration.animation, delete $a3a3deaca4efee87$var$We.animationstart.animation), "TransitionEvent" in window || delete $a3a3deaca4efee87$var$We.transitionend.transition);
function $a3a3deaca4efee87$var$Ze(a) {
    if ($a3a3deaca4efee87$var$Xe[a]) return $a3a3deaca4efee87$var$Xe[a];
    if (!$a3a3deaca4efee87$var$We[a]) return a;
    var b = $a3a3deaca4efee87$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $a3a3deaca4efee87$var$Ye) return $a3a3deaca4efee87$var$Xe[a] = b[c];
    return a;
}
var $a3a3deaca4efee87$var$$e = $a3a3deaca4efee87$var$Ze("animationend"), $a3a3deaca4efee87$var$af = $a3a3deaca4efee87$var$Ze("animationiteration"), $a3a3deaca4efee87$var$bf = $a3a3deaca4efee87$var$Ze("animationstart"), $a3a3deaca4efee87$var$cf = $a3a3deaca4efee87$var$Ze("transitionend"), $a3a3deaca4efee87$var$df = new Map, $a3a3deaca4efee87$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $a3a3deaca4efee87$var$ff(a, b) {
    $a3a3deaca4efee87$var$df.set(a, b);
    $a3a3deaca4efee87$var$fa(b, [
        a
    ]);
}
for(var $a3a3deaca4efee87$var$gf = 0; $a3a3deaca4efee87$var$gf < $a3a3deaca4efee87$var$ef.length; $a3a3deaca4efee87$var$gf++){
    var $a3a3deaca4efee87$var$hf = $a3a3deaca4efee87$var$ef[$a3a3deaca4efee87$var$gf], $a3a3deaca4efee87$var$jf = $a3a3deaca4efee87$var$hf.toLowerCase(), $a3a3deaca4efee87$var$kf = $a3a3deaca4efee87$var$hf[0].toUpperCase() + $a3a3deaca4efee87$var$hf.slice(1);
    $a3a3deaca4efee87$var$ff($a3a3deaca4efee87$var$jf, "on" + $a3a3deaca4efee87$var$kf);
}
$a3a3deaca4efee87$var$ff($a3a3deaca4efee87$var$$e, "onAnimationEnd");
$a3a3deaca4efee87$var$ff($a3a3deaca4efee87$var$af, "onAnimationIteration");
$a3a3deaca4efee87$var$ff($a3a3deaca4efee87$var$bf, "onAnimationStart");
$a3a3deaca4efee87$var$ff("dblclick", "onDoubleClick");
$a3a3deaca4efee87$var$ff("focusin", "onFocus");
$a3a3deaca4efee87$var$ff("focusout", "onBlur");
$a3a3deaca4efee87$var$ff($a3a3deaca4efee87$var$cf, "onTransitionEnd");
$a3a3deaca4efee87$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$a3a3deaca4efee87$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$a3a3deaca4efee87$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$a3a3deaca4efee87$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$a3a3deaca4efee87$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$a3a3deaca4efee87$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$a3a3deaca4efee87$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$a3a3deaca4efee87$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$a3a3deaca4efee87$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$a3a3deaca4efee87$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $a3a3deaca4efee87$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $a3a3deaca4efee87$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($a3a3deaca4efee87$var$lf));
function $a3a3deaca4efee87$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $a3a3deaca4efee87$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $a3a3deaca4efee87$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a3a3deaca4efee87$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a3a3deaca4efee87$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($a3a3deaca4efee87$var$Qb) throw a = $a3a3deaca4efee87$var$Rb, $a3a3deaca4efee87$var$Qb = !1, $a3a3deaca4efee87$var$Rb = null, a;
}
function $a3a3deaca4efee87$var$D(a, b) {
    var c = b[$a3a3deaca4efee87$var$of];
    void 0 === c && (c = b[$a3a3deaca4efee87$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($a3a3deaca4efee87$var$pf(b, a, 2, !1), c.add(d));
}
function $a3a3deaca4efee87$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $a3a3deaca4efee87$var$pf(c, a, d, b);
}
var $a3a3deaca4efee87$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $a3a3deaca4efee87$var$sf(a) {
    if (!a[$a3a3deaca4efee87$var$rf]) {
        a[$a3a3deaca4efee87$var$rf] = !0;
        $a3a3deaca4efee87$var$da.forEach(function(b) {
            "selectionchange" !== b && ($a3a3deaca4efee87$var$mf.has(b) || $a3a3deaca4efee87$var$qf(b, !1, a), $a3a3deaca4efee87$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$a3a3deaca4efee87$var$rf] || (b[$a3a3deaca4efee87$var$rf] = !0, $a3a3deaca4efee87$var$qf("selectionchange", !1, b));
    }
}
function $a3a3deaca4efee87$var$pf(a, b, c, d) {
    switch($a3a3deaca4efee87$var$jd(b)){
        case 1:
            var e = $a3a3deaca4efee87$var$ed;
            break;
        case 4:
            e = $a3a3deaca4efee87$var$gd;
            break;
        default:
            e = $a3a3deaca4efee87$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$a3a3deaca4efee87$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $a3a3deaca4efee87$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $a3a3deaca4efee87$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $a3a3deaca4efee87$var$Jb(function() {
        var d = f, e = $a3a3deaca4efee87$var$xb(c), g = [];
        a: {
            var h = $a3a3deaca4efee87$var$df.get(a);
            if (void 0 !== h) {
                var k = $a3a3deaca4efee87$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $a3a3deaca4efee87$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $a3a3deaca4efee87$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $a3a3deaca4efee87$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $a3a3deaca4efee87$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $a3a3deaca4efee87$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $a3a3deaca4efee87$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $a3a3deaca4efee87$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $a3a3deaca4efee87$var$Vd;
                        break;
                    case $a3a3deaca4efee87$var$$e:
                    case $a3a3deaca4efee87$var$af:
                    case $a3a3deaca4efee87$var$bf:
                        k = $a3a3deaca4efee87$var$Hd;
                        break;
                    case $a3a3deaca4efee87$var$cf:
                        k = $a3a3deaca4efee87$var$Xd;
                        break;
                    case "scroll":
                        k = $a3a3deaca4efee87$var$vd;
                        break;
                    case "wheel":
                        k = $a3a3deaca4efee87$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $a3a3deaca4efee87$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $a3a3deaca4efee87$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $a3a3deaca4efee87$var$Kb(w, x), null != F && t.push($a3a3deaca4efee87$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $a3a3deaca4efee87$var$wb && (n = c.relatedTarget || c.fromElement) && ($a3a3deaca4efee87$var$Wc(n) || n[$a3a3deaca4efee87$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $a3a3deaca4efee87$var$Wc(n) : null, null !== n && (J = $a3a3deaca4efee87$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $a3a3deaca4efee87$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $a3a3deaca4efee87$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $a3a3deaca4efee87$var$ue(k);
                        u = null == n ? h : $a3a3deaca4efee87$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $a3a3deaca4efee87$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $a3a3deaca4efee87$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $a3a3deaca4efee87$var$vf(F))u++;
                            for(; 0 < w - u;)t = $a3a3deaca4efee87$var$vf(t), w--;
                            for(; 0 < u - w;)x = $a3a3deaca4efee87$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $a3a3deaca4efee87$var$vf(t);
                                x = $a3a3deaca4efee87$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $a3a3deaca4efee87$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $a3a3deaca4efee87$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $a3a3deaca4efee87$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $a3a3deaca4efee87$var$ve;
                else if ($a3a3deaca4efee87$var$me(h)) {
                    if ($a3a3deaca4efee87$var$we) na = $a3a3deaca4efee87$var$Fe;
                    else {
                        na = $a3a3deaca4efee87$var$De;
                        var xa = $a3a3deaca4efee87$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $a3a3deaca4efee87$var$Ee);
                if (na && (na = na(a, d))) {
                    $a3a3deaca4efee87$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $a3a3deaca4efee87$var$cb(h, "number", h.value);
            }
            xa = d ? $a3a3deaca4efee87$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($a3a3deaca4efee87$var$me(xa) || "true" === xa.contentEditable) $a3a3deaca4efee87$var$Qe = xa, $a3a3deaca4efee87$var$Re = d, $a3a3deaca4efee87$var$Se = null;
                    break;
                case "focusout":
                    $a3a3deaca4efee87$var$Se = $a3a3deaca4efee87$var$Re = $a3a3deaca4efee87$var$Qe = null;
                    break;
                case "mousedown":
                    $a3a3deaca4efee87$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $a3a3deaca4efee87$var$Te = !1;
                    $a3a3deaca4efee87$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($a3a3deaca4efee87$var$Pe) break;
                case "keydown":
                case "keyup":
                    $a3a3deaca4efee87$var$Ue(g, c, e);
            }
            var $a;
            if ($a3a3deaca4efee87$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $a3a3deaca4efee87$var$ie ? $a3a3deaca4efee87$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($a3a3deaca4efee87$var$de && "ko" !== c.locale && ($a3a3deaca4efee87$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $a3a3deaca4efee87$var$ie && ($a = $a3a3deaca4efee87$var$nd()) : ($a3a3deaca4efee87$var$kd = e, $a3a3deaca4efee87$var$ld = "value" in $a3a3deaca4efee87$var$kd ? $a3a3deaca4efee87$var$kd.value : $a3a3deaca4efee87$var$kd.textContent, $a3a3deaca4efee87$var$ie = !0)), xa = $a3a3deaca4efee87$var$oe(d, ba), 0 < xa.length && (ba = new $a3a3deaca4efee87$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $a3a3deaca4efee87$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $a3a3deaca4efee87$var$ce ? $a3a3deaca4efee87$var$je(a, c) : $a3a3deaca4efee87$var$ke(a, c)) d = $a3a3deaca4efee87$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $a3a3deaca4efee87$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $a3a3deaca4efee87$var$se(g, b);
    });
}
function $a3a3deaca4efee87$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $a3a3deaca4efee87$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $a3a3deaca4efee87$var$Kb(a, c), null != f && d.unshift($a3a3deaca4efee87$var$tf(a, f, e)), f = $a3a3deaca4efee87$var$Kb(a, b), null != f && d.push($a3a3deaca4efee87$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $a3a3deaca4efee87$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $a3a3deaca4efee87$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $a3a3deaca4efee87$var$Kb(c, f), null != k && g.unshift($a3a3deaca4efee87$var$tf(c, k, h))) : e || (k = $a3a3deaca4efee87$var$Kb(c, f), null != k && g.push($a3a3deaca4efee87$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $a3a3deaca4efee87$var$xf = /\r\n?/g, $a3a3deaca4efee87$var$yf = /\u0000|\uFFFD/g;
function $a3a3deaca4efee87$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($a3a3deaca4efee87$var$xf, "\n").replace($a3a3deaca4efee87$var$yf, "");
}
function $a3a3deaca4efee87$var$Af(a, b, c) {
    b = $a3a3deaca4efee87$var$zf(b);
    if ($a3a3deaca4efee87$var$zf(a) !== b && c) throw Error($a3a3deaca4efee87$var$p(425));
}
function $a3a3deaca4efee87$var$Bf() {}
var $a3a3deaca4efee87$var$Cf = null, $a3a3deaca4efee87$var$Df = null;
function $a3a3deaca4efee87$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $a3a3deaca4efee87$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $a3a3deaca4efee87$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $a3a3deaca4efee87$var$Hf = "function" === typeof Promise ? Promise : void 0, $a3a3deaca4efee87$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $a3a3deaca4efee87$var$Hf ? function(a) {
    return $a3a3deaca4efee87$var$Hf.resolve(null).then(a).catch($a3a3deaca4efee87$var$If);
} : $a3a3deaca4efee87$var$Ff;
function $a3a3deaca4efee87$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $a3a3deaca4efee87$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $a3a3deaca4efee87$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $a3a3deaca4efee87$var$bd(b);
}
function $a3a3deaca4efee87$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $a3a3deaca4efee87$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $a3a3deaca4efee87$var$Nf = Math.random().toString(36).slice(2), $a3a3deaca4efee87$var$Of = "__reactFiber$" + $a3a3deaca4efee87$var$Nf, $a3a3deaca4efee87$var$Pf = "__reactProps$" + $a3a3deaca4efee87$var$Nf, $a3a3deaca4efee87$var$uf = "__reactContainer$" + $a3a3deaca4efee87$var$Nf, $a3a3deaca4efee87$var$of = "__reactEvents$" + $a3a3deaca4efee87$var$Nf, $a3a3deaca4efee87$var$Qf = "__reactListeners$" + $a3a3deaca4efee87$var$Nf, $a3a3deaca4efee87$var$Rf = "__reactHandles$" + $a3a3deaca4efee87$var$Nf;
function $a3a3deaca4efee87$var$Wc(a) {
    var b = a[$a3a3deaca4efee87$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$a3a3deaca4efee87$var$uf] || c[$a3a3deaca4efee87$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $a3a3deaca4efee87$var$Mf(a); null !== a;){
                if (c = a[$a3a3deaca4efee87$var$Of]) return c;
                a = $a3a3deaca4efee87$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $a3a3deaca4efee87$var$Cb(a) {
    a = a[$a3a3deaca4efee87$var$Of] || a[$a3a3deaca4efee87$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $a3a3deaca4efee87$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($a3a3deaca4efee87$var$p(33));
}
function $a3a3deaca4efee87$var$Db(a) {
    return a[$a3a3deaca4efee87$var$Pf] || null;
}
var $a3a3deaca4efee87$var$Sf = [], $a3a3deaca4efee87$var$Tf = -1;
function $a3a3deaca4efee87$var$Uf(a) {
    return {
        current: a
    };
}
function $a3a3deaca4efee87$var$E(a) {
    0 > $a3a3deaca4efee87$var$Tf || (a.current = $a3a3deaca4efee87$var$Sf[$a3a3deaca4efee87$var$Tf], $a3a3deaca4efee87$var$Sf[$a3a3deaca4efee87$var$Tf] = null, $a3a3deaca4efee87$var$Tf--);
}
function $a3a3deaca4efee87$var$G(a, b) {
    $a3a3deaca4efee87$var$Tf++;
    $a3a3deaca4efee87$var$Sf[$a3a3deaca4efee87$var$Tf] = a.current;
    a.current = b;
}
var $a3a3deaca4efee87$var$Vf = {}, $a3a3deaca4efee87$var$H = $a3a3deaca4efee87$var$Uf($a3a3deaca4efee87$var$Vf), $a3a3deaca4efee87$var$Wf = $a3a3deaca4efee87$var$Uf(!1), $a3a3deaca4efee87$var$Xf = $a3a3deaca4efee87$var$Vf;
function $a3a3deaca4efee87$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $a3a3deaca4efee87$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $a3a3deaca4efee87$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $a3a3deaca4efee87$var$$f() {
    $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$Wf);
    $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$H);
}
function $a3a3deaca4efee87$var$ag(a, b, c) {
    if ($a3a3deaca4efee87$var$H.current !== $a3a3deaca4efee87$var$Vf) throw Error($a3a3deaca4efee87$var$p(168));
    $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$H, b);
    $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$Wf, c);
}
function $a3a3deaca4efee87$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($a3a3deaca4efee87$var$p(108, $a3a3deaca4efee87$var$Ra(a) || "Unknown", e));
    return $a3a3deaca4efee87$var$A({}, c, d);
}
function $a3a3deaca4efee87$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $a3a3deaca4efee87$var$Vf;
    $a3a3deaca4efee87$var$Xf = $a3a3deaca4efee87$var$H.current;
    $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$H, a);
    $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$Wf, $a3a3deaca4efee87$var$Wf.current);
    return !0;
}
function $a3a3deaca4efee87$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($a3a3deaca4efee87$var$p(169));
    c ? (a = $a3a3deaca4efee87$var$bg(a, b, $a3a3deaca4efee87$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$Wf), $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$H), $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$H, a)) : $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$Wf);
    $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$Wf, c);
}
var $a3a3deaca4efee87$var$eg = null, $a3a3deaca4efee87$var$fg = !1, $a3a3deaca4efee87$var$gg = !1;
function $a3a3deaca4efee87$var$hg(a) {
    null === $a3a3deaca4efee87$var$eg ? $a3a3deaca4efee87$var$eg = [
        a
    ] : $a3a3deaca4efee87$var$eg.push(a);
}
function $a3a3deaca4efee87$var$ig(a) {
    $a3a3deaca4efee87$var$fg = !0;
    $a3a3deaca4efee87$var$hg(a);
}
function $a3a3deaca4efee87$var$jg() {
    if (!$a3a3deaca4efee87$var$gg && null !== $a3a3deaca4efee87$var$eg) {
        $a3a3deaca4efee87$var$gg = !0;
        var a = 0, b = $a3a3deaca4efee87$var$C;
        try {
            var c = $a3a3deaca4efee87$var$eg;
            for($a3a3deaca4efee87$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $a3a3deaca4efee87$var$eg = null;
            $a3a3deaca4efee87$var$fg = !1;
        } catch (e) {
            throw null !== $a3a3deaca4efee87$var$eg && ($a3a3deaca4efee87$var$eg = $a3a3deaca4efee87$var$eg.slice(a + 1)), $a3a3deaca4efee87$var$ac($a3a3deaca4efee87$var$fc, $a3a3deaca4efee87$var$jg), e;
        } finally{
            $a3a3deaca4efee87$var$C = b, $a3a3deaca4efee87$var$gg = !1;
        }
    }
    return null;
}
var $a3a3deaca4efee87$var$kg = [], $a3a3deaca4efee87$var$lg = 0, $a3a3deaca4efee87$var$mg = null, $a3a3deaca4efee87$var$ng = 0, $a3a3deaca4efee87$var$og = [], $a3a3deaca4efee87$var$pg = 0, $a3a3deaca4efee87$var$qg = null, $a3a3deaca4efee87$var$rg = 1, $a3a3deaca4efee87$var$sg = "";
function $a3a3deaca4efee87$var$tg(a, b) {
    $a3a3deaca4efee87$var$kg[$a3a3deaca4efee87$var$lg++] = $a3a3deaca4efee87$var$ng;
    $a3a3deaca4efee87$var$kg[$a3a3deaca4efee87$var$lg++] = $a3a3deaca4efee87$var$mg;
    $a3a3deaca4efee87$var$mg = a;
    $a3a3deaca4efee87$var$ng = b;
}
function $a3a3deaca4efee87$var$ug(a, b, c) {
    $a3a3deaca4efee87$var$og[$a3a3deaca4efee87$var$pg++] = $a3a3deaca4efee87$var$rg;
    $a3a3deaca4efee87$var$og[$a3a3deaca4efee87$var$pg++] = $a3a3deaca4efee87$var$sg;
    $a3a3deaca4efee87$var$og[$a3a3deaca4efee87$var$pg++] = $a3a3deaca4efee87$var$qg;
    $a3a3deaca4efee87$var$qg = a;
    var d = $a3a3deaca4efee87$var$rg;
    a = $a3a3deaca4efee87$var$sg;
    var e = 32 - $a3a3deaca4efee87$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $a3a3deaca4efee87$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $a3a3deaca4efee87$var$rg = 1 << 32 - $a3a3deaca4efee87$var$oc(b) + e | c << e | d;
        $a3a3deaca4efee87$var$sg = f + a;
    } else $a3a3deaca4efee87$var$rg = 1 << f | c << e | d, $a3a3deaca4efee87$var$sg = a;
}
function $a3a3deaca4efee87$var$vg(a) {
    null !== a.return && ($a3a3deaca4efee87$var$tg(a, 1), $a3a3deaca4efee87$var$ug(a, 1, 0));
}
function $a3a3deaca4efee87$var$wg(a) {
    for(; a === $a3a3deaca4efee87$var$mg;)$a3a3deaca4efee87$var$mg = $a3a3deaca4efee87$var$kg[--$a3a3deaca4efee87$var$lg], $a3a3deaca4efee87$var$kg[$a3a3deaca4efee87$var$lg] = null, $a3a3deaca4efee87$var$ng = $a3a3deaca4efee87$var$kg[--$a3a3deaca4efee87$var$lg], $a3a3deaca4efee87$var$kg[$a3a3deaca4efee87$var$lg] = null;
    for(; a === $a3a3deaca4efee87$var$qg;)$a3a3deaca4efee87$var$qg = $a3a3deaca4efee87$var$og[--$a3a3deaca4efee87$var$pg], $a3a3deaca4efee87$var$og[$a3a3deaca4efee87$var$pg] = null, $a3a3deaca4efee87$var$sg = $a3a3deaca4efee87$var$og[--$a3a3deaca4efee87$var$pg], $a3a3deaca4efee87$var$og[$a3a3deaca4efee87$var$pg] = null, $a3a3deaca4efee87$var$rg = $a3a3deaca4efee87$var$og[--$a3a3deaca4efee87$var$pg], $a3a3deaca4efee87$var$og[$a3a3deaca4efee87$var$pg] = null;
}
var $a3a3deaca4efee87$var$xg = null, $a3a3deaca4efee87$var$yg = null, $a3a3deaca4efee87$var$I = !1, $a3a3deaca4efee87$var$zg = null;
function $a3a3deaca4efee87$var$Ag(a, b) {
    var c = $a3a3deaca4efee87$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $a3a3deaca4efee87$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $a3a3deaca4efee87$var$xg = a, $a3a3deaca4efee87$var$yg = $a3a3deaca4efee87$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $a3a3deaca4efee87$var$xg = a, $a3a3deaca4efee87$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $a3a3deaca4efee87$var$qg ? {
                id: $a3a3deaca4efee87$var$rg,
                overflow: $a3a3deaca4efee87$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $a3a3deaca4efee87$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $a3a3deaca4efee87$var$xg = a, $a3a3deaca4efee87$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $a3a3deaca4efee87$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $a3a3deaca4efee87$var$Eg(a) {
    if ($a3a3deaca4efee87$var$I) {
        var b = $a3a3deaca4efee87$var$yg;
        if (b) {
            var c = b;
            if (!$a3a3deaca4efee87$var$Cg(a, b)) {
                if ($a3a3deaca4efee87$var$Dg(a)) throw Error($a3a3deaca4efee87$var$p(418));
                b = $a3a3deaca4efee87$var$Lf(c.nextSibling);
                var d = $a3a3deaca4efee87$var$xg;
                b && $a3a3deaca4efee87$var$Cg(a, b) ? $a3a3deaca4efee87$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $a3a3deaca4efee87$var$I = !1, $a3a3deaca4efee87$var$xg = a);
            }
        } else {
            if ($a3a3deaca4efee87$var$Dg(a)) throw Error($a3a3deaca4efee87$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $a3a3deaca4efee87$var$I = !1;
            $a3a3deaca4efee87$var$xg = a;
        }
    }
}
function $a3a3deaca4efee87$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $a3a3deaca4efee87$var$xg = a;
}
function $a3a3deaca4efee87$var$Gg(a) {
    if (a !== $a3a3deaca4efee87$var$xg) return !1;
    if (!$a3a3deaca4efee87$var$I) return $a3a3deaca4efee87$var$Fg(a), $a3a3deaca4efee87$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$a3a3deaca4efee87$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $a3a3deaca4efee87$var$yg)) {
        if ($a3a3deaca4efee87$var$Dg(a)) throw $a3a3deaca4efee87$var$Hg(), Error($a3a3deaca4efee87$var$p(418));
        for(; b;)$a3a3deaca4efee87$var$Ag(a, b), b = $a3a3deaca4efee87$var$Lf(b.nextSibling);
    }
    $a3a3deaca4efee87$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($a3a3deaca4efee87$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $a3a3deaca4efee87$var$yg = $a3a3deaca4efee87$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $a3a3deaca4efee87$var$yg = null;
        }
    } else $a3a3deaca4efee87$var$yg = $a3a3deaca4efee87$var$xg ? $a3a3deaca4efee87$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $a3a3deaca4efee87$var$Hg() {
    for(var a = $a3a3deaca4efee87$var$yg; a;)a = $a3a3deaca4efee87$var$Lf(a.nextSibling);
}
function $a3a3deaca4efee87$var$Ig() {
    $a3a3deaca4efee87$var$yg = $a3a3deaca4efee87$var$xg = null;
    $a3a3deaca4efee87$var$I = !1;
}
function $a3a3deaca4efee87$var$Jg(a) {
    null === $a3a3deaca4efee87$var$zg ? $a3a3deaca4efee87$var$zg = [
        a
    ] : $a3a3deaca4efee87$var$zg.push(a);
}
var $a3a3deaca4efee87$var$Kg = $a3a3deaca4efee87$var$ua.ReactCurrentBatchConfig;
function $a3a3deaca4efee87$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($a3a3deaca4efee87$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($a3a3deaca4efee87$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($a3a3deaca4efee87$var$p(284));
        if (!c._owner) throw Error($a3a3deaca4efee87$var$p(290, a));
    }
    return a;
}
function $a3a3deaca4efee87$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($a3a3deaca4efee87$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $a3a3deaca4efee87$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $a3a3deaca4efee87$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $a3a3deaca4efee87$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $a3a3deaca4efee87$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $a3a3deaca4efee87$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $a3a3deaca4efee87$var$Ha && $a3a3deaca4efee87$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $a3a3deaca4efee87$var$Lg(a, b, c), d.return = a, d;
        d = $a3a3deaca4efee87$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $a3a3deaca4efee87$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $a3a3deaca4efee87$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $a3a3deaca4efee87$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $a3a3deaca4efee87$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $a3a3deaca4efee87$var$va:
                    return c = $a3a3deaca4efee87$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $a3a3deaca4efee87$var$Lg(a, null, b), c.return = a, c;
                case $a3a3deaca4efee87$var$wa:
                    return b = $a3a3deaca4efee87$var$Sg(b, a.mode, c), b.return = a, b;
                case $a3a3deaca4efee87$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($a3a3deaca4efee87$var$eb(b) || $a3a3deaca4efee87$var$Ka(b)) return b = $a3a3deaca4efee87$var$Tg(b, a.mode, c, null), b.return = a, b;
            $a3a3deaca4efee87$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $a3a3deaca4efee87$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $a3a3deaca4efee87$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $a3a3deaca4efee87$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($a3a3deaca4efee87$var$eb(c) || $a3a3deaca4efee87$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $a3a3deaca4efee87$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $a3a3deaca4efee87$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $a3a3deaca4efee87$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $a3a3deaca4efee87$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($a3a3deaca4efee87$var$eb(d) || $a3a3deaca4efee87$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $a3a3deaca4efee87$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $a3a3deaca4efee87$var$I && $a3a3deaca4efee87$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $a3a3deaca4efee87$var$I && $a3a3deaca4efee87$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $a3a3deaca4efee87$var$I && $a3a3deaca4efee87$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $a3a3deaca4efee87$var$Ka(h);
        if ("function" !== typeof l) throw Error($a3a3deaca4efee87$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($a3a3deaca4efee87$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $a3a3deaca4efee87$var$I && $a3a3deaca4efee87$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $a3a3deaca4efee87$var$I && $a3a3deaca4efee87$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $a3a3deaca4efee87$var$I && $a3a3deaca4efee87$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $a3a3deaca4efee87$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $a3a3deaca4efee87$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $a3a3deaca4efee87$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $a3a3deaca4efee87$var$Ha && $a3a3deaca4efee87$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $a3a3deaca4efee87$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $a3a3deaca4efee87$var$ya ? (d = $a3a3deaca4efee87$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $a3a3deaca4efee87$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $a3a3deaca4efee87$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $a3a3deaca4efee87$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $a3a3deaca4efee87$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $a3a3deaca4efee87$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($a3a3deaca4efee87$var$eb(f)) return n(a, d, f, h);
            if ($a3a3deaca4efee87$var$Ka(f)) return t(a, d, f, h);
            $a3a3deaca4efee87$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $a3a3deaca4efee87$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $a3a3deaca4efee87$var$Ug = $a3a3deaca4efee87$var$Og(!0), $a3a3deaca4efee87$var$Vg = $a3a3deaca4efee87$var$Og(!1), $a3a3deaca4efee87$var$Wg = $a3a3deaca4efee87$var$Uf(null), $a3a3deaca4efee87$var$Xg = null, $a3a3deaca4efee87$var$Yg = null, $a3a3deaca4efee87$var$Zg = null;
function $a3a3deaca4efee87$var$$g() {
    $a3a3deaca4efee87$var$Zg = $a3a3deaca4efee87$var$Yg = $a3a3deaca4efee87$var$Xg = null;
}
function $a3a3deaca4efee87$var$ah(a) {
    var b = $a3a3deaca4efee87$var$Wg.current;
    $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$Wg);
    a._currentValue = b;
}
function $a3a3deaca4efee87$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $a3a3deaca4efee87$var$ch(a, b) {
    $a3a3deaca4efee87$var$Xg = a;
    $a3a3deaca4efee87$var$Zg = $a3a3deaca4efee87$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($a3a3deaca4efee87$var$dh = !0), a.firstContext = null);
}
function $a3a3deaca4efee87$var$eh(a) {
    var b = a._currentValue;
    if ($a3a3deaca4efee87$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $a3a3deaca4efee87$var$Yg) {
            if (null === $a3a3deaca4efee87$var$Xg) throw Error($a3a3deaca4efee87$var$p(308));
            $a3a3deaca4efee87$var$Yg = a;
            $a3a3deaca4efee87$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $a3a3deaca4efee87$var$Yg = $a3a3deaca4efee87$var$Yg.next = a;
    }
    return b;
}
var $a3a3deaca4efee87$var$fh = null;
function $a3a3deaca4efee87$var$gh(a) {
    null === $a3a3deaca4efee87$var$fh ? $a3a3deaca4efee87$var$fh = [
        a
    ] : $a3a3deaca4efee87$var$fh.push(a);
}
function $a3a3deaca4efee87$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $a3a3deaca4efee87$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $a3a3deaca4efee87$var$ih(a, d);
}
function $a3a3deaca4efee87$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $a3a3deaca4efee87$var$jh = !1;
function $a3a3deaca4efee87$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $a3a3deaca4efee87$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $a3a3deaca4efee87$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $a3a3deaca4efee87$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($a3a3deaca4efee87$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $a3a3deaca4efee87$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $a3a3deaca4efee87$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $a3a3deaca4efee87$var$ih(a, c);
}
function $a3a3deaca4efee87$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a3a3deaca4efee87$var$Cc(a, c);
    }
}
function $a3a3deaca4efee87$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $a3a3deaca4efee87$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $a3a3deaca4efee87$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $a3a3deaca4efee87$var$A({}, q, r);
                            break a;
                        case 2:
                            $a3a3deaca4efee87$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $a3a3deaca4efee87$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $a3a3deaca4efee87$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($a3a3deaca4efee87$var$p(191, e));
            e.call(d);
        }
    }
}
var $a3a3deaca4efee87$var$th = {}, $a3a3deaca4efee87$var$uh = $a3a3deaca4efee87$var$Uf($a3a3deaca4efee87$var$th), $a3a3deaca4efee87$var$vh = $a3a3deaca4efee87$var$Uf($a3a3deaca4efee87$var$th), $a3a3deaca4efee87$var$wh = $a3a3deaca4efee87$var$Uf($a3a3deaca4efee87$var$th);
function $a3a3deaca4efee87$var$xh(a) {
    if (a === $a3a3deaca4efee87$var$th) throw Error($a3a3deaca4efee87$var$p(174));
    return a;
}
function $a3a3deaca4efee87$var$yh(a, b) {
    $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$wh, b);
    $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$vh, a);
    $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$uh, $a3a3deaca4efee87$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $a3a3deaca4efee87$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $a3a3deaca4efee87$var$lb(b, a);
    }
    $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$uh);
    $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$uh, b);
}
function $a3a3deaca4efee87$var$zh() {
    $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$uh);
    $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$vh);
    $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$wh);
}
function $a3a3deaca4efee87$var$Ah(a) {
    $a3a3deaca4efee87$var$xh($a3a3deaca4efee87$var$wh.current);
    var b = $a3a3deaca4efee87$var$xh($a3a3deaca4efee87$var$uh.current);
    var c = $a3a3deaca4efee87$var$lb(b, a.type);
    b !== c && ($a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$vh, a), $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$uh, c));
}
function $a3a3deaca4efee87$var$Bh(a) {
    $a3a3deaca4efee87$var$vh.current === a && ($a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$uh), $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$vh));
}
var $a3a3deaca4efee87$var$L = $a3a3deaca4efee87$var$Uf(0);
function $a3a3deaca4efee87$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $a3a3deaca4efee87$var$Dh = [];
function $a3a3deaca4efee87$var$Eh() {
    for(var a = 0; a < $a3a3deaca4efee87$var$Dh.length; a++)$a3a3deaca4efee87$var$Dh[a]._workInProgressVersionPrimary = null;
    $a3a3deaca4efee87$var$Dh.length = 0;
}
var $a3a3deaca4efee87$var$Fh = $a3a3deaca4efee87$var$ua.ReactCurrentDispatcher, $a3a3deaca4efee87$var$Gh = $a3a3deaca4efee87$var$ua.ReactCurrentBatchConfig, $a3a3deaca4efee87$var$Hh = 0, $a3a3deaca4efee87$var$M = null, $a3a3deaca4efee87$var$N = null, $a3a3deaca4efee87$var$O = null, $a3a3deaca4efee87$var$Ih = !1, $a3a3deaca4efee87$var$Jh = !1, $a3a3deaca4efee87$var$Kh = 0, $a3a3deaca4efee87$var$Lh = 0;
function $a3a3deaca4efee87$var$P() {
    throw Error($a3a3deaca4efee87$var$p(321));
}
function $a3a3deaca4efee87$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$a3a3deaca4efee87$var$He(a[c], b[c])) return !1;
    return !0;
}
function $a3a3deaca4efee87$var$Nh(a, b, c, d, e, f) {
    $a3a3deaca4efee87$var$Hh = f;
    $a3a3deaca4efee87$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $a3a3deaca4efee87$var$Fh.current = null === a || null === a.memoizedState ? $a3a3deaca4efee87$var$Oh : $a3a3deaca4efee87$var$Ph;
    a = c(d, e);
    if ($a3a3deaca4efee87$var$Jh) {
        f = 0;
        do {
            $a3a3deaca4efee87$var$Jh = !1;
            $a3a3deaca4efee87$var$Kh = 0;
            if (25 <= f) throw Error($a3a3deaca4efee87$var$p(301));
            f += 1;
            $a3a3deaca4efee87$var$O = $a3a3deaca4efee87$var$N = null;
            b.updateQueue = null;
            $a3a3deaca4efee87$var$Fh.current = $a3a3deaca4efee87$var$Qh;
            a = c(d, e);
        }while ($a3a3deaca4efee87$var$Jh);
    }
    $a3a3deaca4efee87$var$Fh.current = $a3a3deaca4efee87$var$Rh;
    b = null !== $a3a3deaca4efee87$var$N && null !== $a3a3deaca4efee87$var$N.next;
    $a3a3deaca4efee87$var$Hh = 0;
    $a3a3deaca4efee87$var$O = $a3a3deaca4efee87$var$N = $a3a3deaca4efee87$var$M = null;
    $a3a3deaca4efee87$var$Ih = !1;
    if (b) throw Error($a3a3deaca4efee87$var$p(300));
    return a;
}
function $a3a3deaca4efee87$var$Sh() {
    var a = 0 !== $a3a3deaca4efee87$var$Kh;
    $a3a3deaca4efee87$var$Kh = 0;
    return a;
}
function $a3a3deaca4efee87$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $a3a3deaca4efee87$var$O ? $a3a3deaca4efee87$var$M.memoizedState = $a3a3deaca4efee87$var$O = a : $a3a3deaca4efee87$var$O = $a3a3deaca4efee87$var$O.next = a;
    return $a3a3deaca4efee87$var$O;
}
function $a3a3deaca4efee87$var$Uh() {
    if (null === $a3a3deaca4efee87$var$N) {
        var a = $a3a3deaca4efee87$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $a3a3deaca4efee87$var$N.next;
    var b = null === $a3a3deaca4efee87$var$O ? $a3a3deaca4efee87$var$M.memoizedState : $a3a3deaca4efee87$var$O.next;
    if (null !== b) $a3a3deaca4efee87$var$O = b, $a3a3deaca4efee87$var$N = a;
    else {
        if (null === a) throw Error($a3a3deaca4efee87$var$p(310));
        $a3a3deaca4efee87$var$N = a;
        a = {
            memoizedState: $a3a3deaca4efee87$var$N.memoizedState,
            baseState: $a3a3deaca4efee87$var$N.baseState,
            baseQueue: $a3a3deaca4efee87$var$N.baseQueue,
            queue: $a3a3deaca4efee87$var$N.queue,
            next: null
        };
        null === $a3a3deaca4efee87$var$O ? $a3a3deaca4efee87$var$M.memoizedState = $a3a3deaca4efee87$var$O = a : $a3a3deaca4efee87$var$O = $a3a3deaca4efee87$var$O.next = a;
    }
    return $a3a3deaca4efee87$var$O;
}
function $a3a3deaca4efee87$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $a3a3deaca4efee87$var$Wh(a) {
    var b = $a3a3deaca4efee87$var$Uh(), c = b.queue;
    if (null === c) throw Error($a3a3deaca4efee87$var$p(311));
    c.lastRenderedReducer = a;
    var d = $a3a3deaca4efee87$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($a3a3deaca4efee87$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $a3a3deaca4efee87$var$M.lanes |= m;
                $a3a3deaca4efee87$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $a3a3deaca4efee87$var$He(d, b.memoizedState) || ($a3a3deaca4efee87$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $a3a3deaca4efee87$var$M.lanes |= f, $a3a3deaca4efee87$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $a3a3deaca4efee87$var$Xh(a) {
    var b = $a3a3deaca4efee87$var$Uh(), c = b.queue;
    if (null === c) throw Error($a3a3deaca4efee87$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $a3a3deaca4efee87$var$He(f, b.memoizedState) || ($a3a3deaca4efee87$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $a3a3deaca4efee87$var$Yh() {}
function $a3a3deaca4efee87$var$Zh(a, b) {
    var c = $a3a3deaca4efee87$var$M, d = $a3a3deaca4efee87$var$Uh(), e = b(), f = !$a3a3deaca4efee87$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $a3a3deaca4efee87$var$dh = !0);
    d = d.queue;
    $a3a3deaca4efee87$var$$h($a3a3deaca4efee87$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $a3a3deaca4efee87$var$O && $a3a3deaca4efee87$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $a3a3deaca4efee87$var$bi(9, $a3a3deaca4efee87$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $a3a3deaca4efee87$var$Q) throw Error($a3a3deaca4efee87$var$p(349));
        0 !== ($a3a3deaca4efee87$var$Hh & 30) || $a3a3deaca4efee87$var$di(c, b, e);
    }
    return e;
}
function $a3a3deaca4efee87$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $a3a3deaca4efee87$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a3a3deaca4efee87$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $a3a3deaca4efee87$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $a3a3deaca4efee87$var$ei(b) && $a3a3deaca4efee87$var$fi(a);
}
function $a3a3deaca4efee87$var$ai(a, b, c) {
    return c(function() {
        $a3a3deaca4efee87$var$ei(b) && $a3a3deaca4efee87$var$fi(a);
    });
}
function $a3a3deaca4efee87$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$a3a3deaca4efee87$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $a3a3deaca4efee87$var$fi(a) {
    var b = $a3a3deaca4efee87$var$ih(a, 1);
    null !== b && $a3a3deaca4efee87$var$gi(b, a, 1, -1);
}
function $a3a3deaca4efee87$var$hi(a) {
    var b = $a3a3deaca4efee87$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $a3a3deaca4efee87$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $a3a3deaca4efee87$var$ii.bind(null, $a3a3deaca4efee87$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $a3a3deaca4efee87$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $a3a3deaca4efee87$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a3a3deaca4efee87$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $a3a3deaca4efee87$var$ji() {
    return $a3a3deaca4efee87$var$Uh().memoizedState;
}
function $a3a3deaca4efee87$var$ki(a, b, c, d) {
    var e = $a3a3deaca4efee87$var$Th();
    $a3a3deaca4efee87$var$M.flags |= a;
    e.memoizedState = $a3a3deaca4efee87$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $a3a3deaca4efee87$var$li(a, b, c, d) {
    var e = $a3a3deaca4efee87$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $a3a3deaca4efee87$var$N) {
        var g = $a3a3deaca4efee87$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $a3a3deaca4efee87$var$Mh(d, g.deps)) {
            e.memoizedState = $a3a3deaca4efee87$var$bi(b, c, f, d);
            return;
        }
    }
    $a3a3deaca4efee87$var$M.flags |= a;
    e.memoizedState = $a3a3deaca4efee87$var$bi(1 | b, c, f, d);
}
function $a3a3deaca4efee87$var$mi(a, b) {
    return $a3a3deaca4efee87$var$ki(8390656, 8, a, b);
}
function $a3a3deaca4efee87$var$$h(a, b) {
    return $a3a3deaca4efee87$var$li(2048, 8, a, b);
}
function $a3a3deaca4efee87$var$ni(a, b) {
    return $a3a3deaca4efee87$var$li(4, 2, a, b);
}
function $a3a3deaca4efee87$var$oi(a, b) {
    return $a3a3deaca4efee87$var$li(4, 4, a, b);
}
function $a3a3deaca4efee87$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $a3a3deaca4efee87$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $a3a3deaca4efee87$var$li(4, 4, $a3a3deaca4efee87$var$pi.bind(null, b, a), c);
}
function $a3a3deaca4efee87$var$ri() {}
function $a3a3deaca4efee87$var$si(a, b) {
    var c = $a3a3deaca4efee87$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a3a3deaca4efee87$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a3a3deaca4efee87$var$ti(a, b) {
    var c = $a3a3deaca4efee87$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a3a3deaca4efee87$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a3a3deaca4efee87$var$ui(a, b, c) {
    if (0 === ($a3a3deaca4efee87$var$Hh & 21)) return a.baseState && (a.baseState = !1, $a3a3deaca4efee87$var$dh = !0), a.memoizedState = c;
    $a3a3deaca4efee87$var$He(c, b) || (c = $a3a3deaca4efee87$var$yc(), $a3a3deaca4efee87$var$M.lanes |= c, $a3a3deaca4efee87$var$rh |= c, a.baseState = !0);
    return b;
}
function $a3a3deaca4efee87$var$vi(a, b) {
    var c = $a3a3deaca4efee87$var$C;
    $a3a3deaca4efee87$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $a3a3deaca4efee87$var$Gh.transition;
    $a3a3deaca4efee87$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $a3a3deaca4efee87$var$C = c, $a3a3deaca4efee87$var$Gh.transition = d;
    }
}
function $a3a3deaca4efee87$var$wi() {
    return $a3a3deaca4efee87$var$Uh().memoizedState;
}
function $a3a3deaca4efee87$var$xi(a, b, c) {
    var d = $a3a3deaca4efee87$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a3a3deaca4efee87$var$zi(a)) $a3a3deaca4efee87$var$Ai(b, c);
    else if (c = $a3a3deaca4efee87$var$hh(a, b, c, d), null !== c) {
        var e = $a3a3deaca4efee87$var$R();
        $a3a3deaca4efee87$var$gi(c, a, d, e);
        $a3a3deaca4efee87$var$Bi(c, b, d);
    }
}
function $a3a3deaca4efee87$var$ii(a, b, c) {
    var d = $a3a3deaca4efee87$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a3a3deaca4efee87$var$zi(a)) $a3a3deaca4efee87$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($a3a3deaca4efee87$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $a3a3deaca4efee87$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $a3a3deaca4efee87$var$hh(a, b, e, d);
        null !== c && (e = $a3a3deaca4efee87$var$R(), $a3a3deaca4efee87$var$gi(c, a, d, e), $a3a3deaca4efee87$var$Bi(c, b, d));
    }
}
function $a3a3deaca4efee87$var$zi(a) {
    var b = a.alternate;
    return a === $a3a3deaca4efee87$var$M || null !== b && b === $a3a3deaca4efee87$var$M;
}
function $a3a3deaca4efee87$var$Ai(a, b) {
    $a3a3deaca4efee87$var$Jh = $a3a3deaca4efee87$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $a3a3deaca4efee87$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a3a3deaca4efee87$var$Cc(a, c);
    }
}
var $a3a3deaca4efee87$var$Rh = {
    readContext: $a3a3deaca4efee87$var$eh,
    useCallback: $a3a3deaca4efee87$var$P,
    useContext: $a3a3deaca4efee87$var$P,
    useEffect: $a3a3deaca4efee87$var$P,
    useImperativeHandle: $a3a3deaca4efee87$var$P,
    useInsertionEffect: $a3a3deaca4efee87$var$P,
    useLayoutEffect: $a3a3deaca4efee87$var$P,
    useMemo: $a3a3deaca4efee87$var$P,
    useReducer: $a3a3deaca4efee87$var$P,
    useRef: $a3a3deaca4efee87$var$P,
    useState: $a3a3deaca4efee87$var$P,
    useDebugValue: $a3a3deaca4efee87$var$P,
    useDeferredValue: $a3a3deaca4efee87$var$P,
    useTransition: $a3a3deaca4efee87$var$P,
    useMutableSource: $a3a3deaca4efee87$var$P,
    useSyncExternalStore: $a3a3deaca4efee87$var$P,
    useId: $a3a3deaca4efee87$var$P,
    unstable_isNewReconciler: !1
}, $a3a3deaca4efee87$var$Oh = {
    readContext: $a3a3deaca4efee87$var$eh,
    useCallback: function(a, b) {
        $a3a3deaca4efee87$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $a3a3deaca4efee87$var$eh,
    useEffect: $a3a3deaca4efee87$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $a3a3deaca4efee87$var$ki(4194308, 4, $a3a3deaca4efee87$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $a3a3deaca4efee87$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $a3a3deaca4efee87$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $a3a3deaca4efee87$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $a3a3deaca4efee87$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $a3a3deaca4efee87$var$xi.bind(null, $a3a3deaca4efee87$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $a3a3deaca4efee87$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $a3a3deaca4efee87$var$hi,
    useDebugValue: $a3a3deaca4efee87$var$ri,
    useDeferredValue: function(a) {
        return $a3a3deaca4efee87$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $a3a3deaca4efee87$var$hi(!1), b = a[0];
        a = $a3a3deaca4efee87$var$vi.bind(null, a[1]);
        $a3a3deaca4efee87$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $a3a3deaca4efee87$var$M, e = $a3a3deaca4efee87$var$Th();
        if ($a3a3deaca4efee87$var$I) {
            if (void 0 === c) throw Error($a3a3deaca4efee87$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $a3a3deaca4efee87$var$Q) throw Error($a3a3deaca4efee87$var$p(349));
            0 !== ($a3a3deaca4efee87$var$Hh & 30) || $a3a3deaca4efee87$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $a3a3deaca4efee87$var$mi($a3a3deaca4efee87$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $a3a3deaca4efee87$var$bi(9, $a3a3deaca4efee87$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $a3a3deaca4efee87$var$Th(), b = $a3a3deaca4efee87$var$Q.identifierPrefix;
        if ($a3a3deaca4efee87$var$I) {
            var c = $a3a3deaca4efee87$var$sg;
            var d = $a3a3deaca4efee87$var$rg;
            c = (d & ~(1 << 32 - $a3a3deaca4efee87$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $a3a3deaca4efee87$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $a3a3deaca4efee87$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $a3a3deaca4efee87$var$Ph = {
    readContext: $a3a3deaca4efee87$var$eh,
    useCallback: $a3a3deaca4efee87$var$si,
    useContext: $a3a3deaca4efee87$var$eh,
    useEffect: $a3a3deaca4efee87$var$$h,
    useImperativeHandle: $a3a3deaca4efee87$var$qi,
    useInsertionEffect: $a3a3deaca4efee87$var$ni,
    useLayoutEffect: $a3a3deaca4efee87$var$oi,
    useMemo: $a3a3deaca4efee87$var$ti,
    useReducer: $a3a3deaca4efee87$var$Wh,
    useRef: $a3a3deaca4efee87$var$ji,
    useState: function() {
        return $a3a3deaca4efee87$var$Wh($a3a3deaca4efee87$var$Vh);
    },
    useDebugValue: $a3a3deaca4efee87$var$ri,
    useDeferredValue: function(a) {
        var b = $a3a3deaca4efee87$var$Uh();
        return $a3a3deaca4efee87$var$ui(b, $a3a3deaca4efee87$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $a3a3deaca4efee87$var$Wh($a3a3deaca4efee87$var$Vh)[0], b = $a3a3deaca4efee87$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a3a3deaca4efee87$var$Yh,
    useSyncExternalStore: $a3a3deaca4efee87$var$Zh,
    useId: $a3a3deaca4efee87$var$wi,
    unstable_isNewReconciler: !1
}, $a3a3deaca4efee87$var$Qh = {
    readContext: $a3a3deaca4efee87$var$eh,
    useCallback: $a3a3deaca4efee87$var$si,
    useContext: $a3a3deaca4efee87$var$eh,
    useEffect: $a3a3deaca4efee87$var$$h,
    useImperativeHandle: $a3a3deaca4efee87$var$qi,
    useInsertionEffect: $a3a3deaca4efee87$var$ni,
    useLayoutEffect: $a3a3deaca4efee87$var$oi,
    useMemo: $a3a3deaca4efee87$var$ti,
    useReducer: $a3a3deaca4efee87$var$Xh,
    useRef: $a3a3deaca4efee87$var$ji,
    useState: function() {
        return $a3a3deaca4efee87$var$Xh($a3a3deaca4efee87$var$Vh);
    },
    useDebugValue: $a3a3deaca4efee87$var$ri,
    useDeferredValue: function(a) {
        var b = $a3a3deaca4efee87$var$Uh();
        return null === $a3a3deaca4efee87$var$N ? b.memoizedState = a : $a3a3deaca4efee87$var$ui(b, $a3a3deaca4efee87$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $a3a3deaca4efee87$var$Xh($a3a3deaca4efee87$var$Vh)[0], b = $a3a3deaca4efee87$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a3a3deaca4efee87$var$Yh,
    useSyncExternalStore: $a3a3deaca4efee87$var$Zh,
    useId: $a3a3deaca4efee87$var$wi,
    unstable_isNewReconciler: !1
};
function $a3a3deaca4efee87$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $a3a3deaca4efee87$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $a3a3deaca4efee87$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $a3a3deaca4efee87$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $a3a3deaca4efee87$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $a3a3deaca4efee87$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a3a3deaca4efee87$var$R(), e = $a3a3deaca4efee87$var$yi(a), f = $a3a3deaca4efee87$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a3a3deaca4efee87$var$nh(a, f, e);
        null !== b && ($a3a3deaca4efee87$var$gi(b, a, e, d), $a3a3deaca4efee87$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a3a3deaca4efee87$var$R(), e = $a3a3deaca4efee87$var$yi(a), f = $a3a3deaca4efee87$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a3a3deaca4efee87$var$nh(a, f, e);
        null !== b && ($a3a3deaca4efee87$var$gi(b, a, e, d), $a3a3deaca4efee87$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $a3a3deaca4efee87$var$R(), d = $a3a3deaca4efee87$var$yi(a), e = $a3a3deaca4efee87$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $a3a3deaca4efee87$var$nh(a, e, d);
        null !== b && ($a3a3deaca4efee87$var$gi(b, a, d, c), $a3a3deaca4efee87$var$oh(b, a, d));
    }
};
function $a3a3deaca4efee87$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$a3a3deaca4efee87$var$Ie(c, d) || !$a3a3deaca4efee87$var$Ie(e, f) : !0;
}
function $a3a3deaca4efee87$var$Gi(a, b, c) {
    var d = !1, e = $a3a3deaca4efee87$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $a3a3deaca4efee87$var$eh(f) : (e = $a3a3deaca4efee87$var$Zf(b) ? $a3a3deaca4efee87$var$Xf : $a3a3deaca4efee87$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $a3a3deaca4efee87$var$Yf(a, e) : $a3a3deaca4efee87$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $a3a3deaca4efee87$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $a3a3deaca4efee87$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $a3a3deaca4efee87$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $a3a3deaca4efee87$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $a3a3deaca4efee87$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $a3a3deaca4efee87$var$eh(f) : (f = $a3a3deaca4efee87$var$Zf(b) ? $a3a3deaca4efee87$var$Xf : $a3a3deaca4efee87$var$H.current, e.context = $a3a3deaca4efee87$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($a3a3deaca4efee87$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $a3a3deaca4efee87$var$Ei.enqueueReplaceState(e, e.state, null), $a3a3deaca4efee87$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $a3a3deaca4efee87$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $a3a3deaca4efee87$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $a3a3deaca4efee87$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $a3a3deaca4efee87$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $a3a3deaca4efee87$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $a3a3deaca4efee87$var$Ni(a, b, c) {
    c = $a3a3deaca4efee87$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $a3a3deaca4efee87$var$Oi || ($a3a3deaca4efee87$var$Oi = !0, $a3a3deaca4efee87$var$Pi = d);
        $a3a3deaca4efee87$var$Li(a, b);
    };
    return c;
}
function $a3a3deaca4efee87$var$Qi(a, b, c) {
    c = $a3a3deaca4efee87$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $a3a3deaca4efee87$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $a3a3deaca4efee87$var$Li(a, b);
        "function" !== typeof d && (null === $a3a3deaca4efee87$var$Ri ? $a3a3deaca4efee87$var$Ri = new Set([
            this
        ]) : $a3a3deaca4efee87$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $a3a3deaca4efee87$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $a3a3deaca4efee87$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $a3a3deaca4efee87$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $a3a3deaca4efee87$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $a3a3deaca4efee87$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $a3a3deaca4efee87$var$mh(-1, 1), b.tag = 2, $a3a3deaca4efee87$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $a3a3deaca4efee87$var$Wi = $a3a3deaca4efee87$var$ua.ReactCurrentOwner, $a3a3deaca4efee87$var$dh = !1;
function $a3a3deaca4efee87$var$Xi(a, b, c, d) {
    b.child = null === a ? $a3a3deaca4efee87$var$Vg(b, null, c, d) : $a3a3deaca4efee87$var$Ug(b, a.child, c, d);
}
function $a3a3deaca4efee87$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $a3a3deaca4efee87$var$ch(b, e);
    d = $a3a3deaca4efee87$var$Nh(a, b, c, d, f, e);
    c = $a3a3deaca4efee87$var$Sh();
    if (null !== a && !$a3a3deaca4efee87$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a3a3deaca4efee87$var$Zi(a, b, e);
    $a3a3deaca4efee87$var$I && c && $a3a3deaca4efee87$var$vg(b);
    b.flags |= 1;
    $a3a3deaca4efee87$var$Xi(a, b, d, e);
    return b.child;
}
function $a3a3deaca4efee87$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$a3a3deaca4efee87$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $a3a3deaca4efee87$var$bj(a, b, f, d, e);
        a = $a3a3deaca4efee87$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $a3a3deaca4efee87$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $a3a3deaca4efee87$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $a3a3deaca4efee87$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $a3a3deaca4efee87$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($a3a3deaca4efee87$var$Ie(f, d) && a.ref === b.ref) {
            if ($a3a3deaca4efee87$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($a3a3deaca4efee87$var$dh = !0);
            else return b.lanes = a.lanes, $a3a3deaca4efee87$var$Zi(a, b, e);
        }
    }
    return $a3a3deaca4efee87$var$cj(a, b, c, d, e);
}
function $a3a3deaca4efee87$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$ej, $a3a3deaca4efee87$var$fj), $a3a3deaca4efee87$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$ej, $a3a3deaca4efee87$var$fj), $a3a3deaca4efee87$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$ej, $a3a3deaca4efee87$var$fj);
            $a3a3deaca4efee87$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$ej, $a3a3deaca4efee87$var$fj), $a3a3deaca4efee87$var$fj |= d;
    $a3a3deaca4efee87$var$Xi(a, b, e, c);
    return b.child;
}
function $a3a3deaca4efee87$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $a3a3deaca4efee87$var$cj(a, b, c, d, e) {
    var f = $a3a3deaca4efee87$var$Zf(c) ? $a3a3deaca4efee87$var$Xf : $a3a3deaca4efee87$var$H.current;
    f = $a3a3deaca4efee87$var$Yf(b, f);
    $a3a3deaca4efee87$var$ch(b, e);
    c = $a3a3deaca4efee87$var$Nh(a, b, c, d, f, e);
    d = $a3a3deaca4efee87$var$Sh();
    if (null !== a && !$a3a3deaca4efee87$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a3a3deaca4efee87$var$Zi(a, b, e);
    $a3a3deaca4efee87$var$I && d && $a3a3deaca4efee87$var$vg(b);
    b.flags |= 1;
    $a3a3deaca4efee87$var$Xi(a, b, c, e);
    return b.child;
}
function $a3a3deaca4efee87$var$hj(a, b, c, d, e) {
    if ($a3a3deaca4efee87$var$Zf(c)) {
        var f = !0;
        $a3a3deaca4efee87$var$cg(b);
    } else f = !1;
    $a3a3deaca4efee87$var$ch(b, e);
    if (null === b.stateNode) $a3a3deaca4efee87$var$ij(a, b), $a3a3deaca4efee87$var$Gi(b, c, d), $a3a3deaca4efee87$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $a3a3deaca4efee87$var$eh(l) : (l = $a3a3deaca4efee87$var$Zf(c) ? $a3a3deaca4efee87$var$Xf : $a3a3deaca4efee87$var$H.current, l = $a3a3deaca4efee87$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $a3a3deaca4efee87$var$Hi(b, g, d, l);
        $a3a3deaca4efee87$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $a3a3deaca4efee87$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $a3a3deaca4efee87$var$Wf.current || $a3a3deaca4efee87$var$jh ? ("function" === typeof m && ($a3a3deaca4efee87$var$Di(b, c, m, d), k = b.memoizedState), (h = $a3a3deaca4efee87$var$jh || $a3a3deaca4efee87$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $a3a3deaca4efee87$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $a3a3deaca4efee87$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $a3a3deaca4efee87$var$eh(k) : (k = $a3a3deaca4efee87$var$Zf(c) ? $a3a3deaca4efee87$var$Xf : $a3a3deaca4efee87$var$H.current, k = $a3a3deaca4efee87$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $a3a3deaca4efee87$var$Hi(b, g, d, k);
        $a3a3deaca4efee87$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $a3a3deaca4efee87$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $a3a3deaca4efee87$var$Wf.current || $a3a3deaca4efee87$var$jh ? ("function" === typeof y && ($a3a3deaca4efee87$var$Di(b, c, y, d), n = b.memoizedState), (l = $a3a3deaca4efee87$var$jh || $a3a3deaca4efee87$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $a3a3deaca4efee87$var$jj(a, b, c, d, f, e);
}
function $a3a3deaca4efee87$var$jj(a, b, c, d, e, f) {
    $a3a3deaca4efee87$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $a3a3deaca4efee87$var$dg(b, c, !1), $a3a3deaca4efee87$var$Zi(a, b, f);
    d = b.stateNode;
    $a3a3deaca4efee87$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $a3a3deaca4efee87$var$Ug(b, a.child, null, f), b.child = $a3a3deaca4efee87$var$Ug(b, null, h, f)) : $a3a3deaca4efee87$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $a3a3deaca4efee87$var$dg(b, c, !0);
    return b.child;
}
function $a3a3deaca4efee87$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $a3a3deaca4efee87$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $a3a3deaca4efee87$var$ag(a, b.context, !1);
    $a3a3deaca4efee87$var$yh(a, b.containerInfo);
}
function $a3a3deaca4efee87$var$lj(a, b, c, d, e) {
    $a3a3deaca4efee87$var$Ig();
    $a3a3deaca4efee87$var$Jg(e);
    b.flags |= 256;
    $a3a3deaca4efee87$var$Xi(a, b, c, d);
    return b.child;
}
var $a3a3deaca4efee87$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $a3a3deaca4efee87$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $a3a3deaca4efee87$var$oj(a, b, c) {
    var d = b.pendingProps, e = $a3a3deaca4efee87$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$L, e & 1);
    if (null === a) {
        $a3a3deaca4efee87$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $a3a3deaca4efee87$var$pj(g, d, 0, null), a = $a3a3deaca4efee87$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $a3a3deaca4efee87$var$nj(c), b.memoizedState = $a3a3deaca4efee87$var$mj, a) : $a3a3deaca4efee87$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $a3a3deaca4efee87$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $a3a3deaca4efee87$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $a3a3deaca4efee87$var$Pg(h, f) : (f = $a3a3deaca4efee87$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $a3a3deaca4efee87$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $a3a3deaca4efee87$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $a3a3deaca4efee87$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $a3a3deaca4efee87$var$qj(a, b) {
    b = $a3a3deaca4efee87$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $a3a3deaca4efee87$var$sj(a, b, c, d) {
    null !== d && $a3a3deaca4efee87$var$Jg(d);
    $a3a3deaca4efee87$var$Ug(b, a.child, null, c);
    a = $a3a3deaca4efee87$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $a3a3deaca4efee87$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $a3a3deaca4efee87$var$Ki(Error($a3a3deaca4efee87$var$p(422))), $a3a3deaca4efee87$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $a3a3deaca4efee87$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $a3a3deaca4efee87$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $a3a3deaca4efee87$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $a3a3deaca4efee87$var$nj(g);
        b.memoizedState = $a3a3deaca4efee87$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $a3a3deaca4efee87$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($a3a3deaca4efee87$var$p(419));
        d = $a3a3deaca4efee87$var$Ki(f, d, void 0);
        return $a3a3deaca4efee87$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($a3a3deaca4efee87$var$dh || h) {
        d = $a3a3deaca4efee87$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $a3a3deaca4efee87$var$ih(a, e), $a3a3deaca4efee87$var$gi(d, a, e, -1));
        }
        $a3a3deaca4efee87$var$tj();
        d = $a3a3deaca4efee87$var$Ki(Error($a3a3deaca4efee87$var$p(421)));
        return $a3a3deaca4efee87$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $a3a3deaca4efee87$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $a3a3deaca4efee87$var$yg = $a3a3deaca4efee87$var$Lf(e.nextSibling);
    $a3a3deaca4efee87$var$xg = b;
    $a3a3deaca4efee87$var$I = !0;
    $a3a3deaca4efee87$var$zg = null;
    null !== a && ($a3a3deaca4efee87$var$og[$a3a3deaca4efee87$var$pg++] = $a3a3deaca4efee87$var$rg, $a3a3deaca4efee87$var$og[$a3a3deaca4efee87$var$pg++] = $a3a3deaca4efee87$var$sg, $a3a3deaca4efee87$var$og[$a3a3deaca4efee87$var$pg++] = $a3a3deaca4efee87$var$qg, $a3a3deaca4efee87$var$rg = a.id, $a3a3deaca4efee87$var$sg = a.overflow, $a3a3deaca4efee87$var$qg = b);
    b = $a3a3deaca4efee87$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $a3a3deaca4efee87$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $a3a3deaca4efee87$var$bh(a.return, b, c);
}
function $a3a3deaca4efee87$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $a3a3deaca4efee87$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $a3a3deaca4efee87$var$Xi(a, b, d.children, c);
    d = $a3a3deaca4efee87$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $a3a3deaca4efee87$var$vj(a, c, b);
            else if (19 === a.tag) $a3a3deaca4efee87$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $a3a3deaca4efee87$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $a3a3deaca4efee87$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $a3a3deaca4efee87$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $a3a3deaca4efee87$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $a3a3deaca4efee87$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $a3a3deaca4efee87$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $a3a3deaca4efee87$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $a3a3deaca4efee87$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($a3a3deaca4efee87$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $a3a3deaca4efee87$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $a3a3deaca4efee87$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $a3a3deaca4efee87$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $a3a3deaca4efee87$var$kj(b);
            $a3a3deaca4efee87$var$Ig();
            break;
        case 5:
            $a3a3deaca4efee87$var$Ah(b);
            break;
        case 1:
            $a3a3deaca4efee87$var$Zf(b.type) && $a3a3deaca4efee87$var$cg(b);
            break;
        case 4:
            $a3a3deaca4efee87$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$L, $a3a3deaca4efee87$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $a3a3deaca4efee87$var$oj(a, b, c);
                $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$L, $a3a3deaca4efee87$var$L.current & 1);
                a = $a3a3deaca4efee87$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$L, $a3a3deaca4efee87$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $a3a3deaca4efee87$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$L, $a3a3deaca4efee87$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $a3a3deaca4efee87$var$dj(a, b, c);
    }
    return $a3a3deaca4efee87$var$Zi(a, b, c);
}
var $a3a3deaca4efee87$var$zj, $a3a3deaca4efee87$var$Aj, $a3a3deaca4efee87$var$Bj, $a3a3deaca4efee87$var$Cj;
$a3a3deaca4efee87$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$a3a3deaca4efee87$var$Aj = function() {};
$a3a3deaca4efee87$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $a3a3deaca4efee87$var$xh($a3a3deaca4efee87$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $a3a3deaca4efee87$var$Ya(a, e);
                d = $a3a3deaca4efee87$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $a3a3deaca4efee87$var$A({}, e, {
                    value: void 0
                });
                d = $a3a3deaca4efee87$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $a3a3deaca4efee87$var$gb(a, e);
                d = $a3a3deaca4efee87$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $a3a3deaca4efee87$var$Bf);
        }
        $a3a3deaca4efee87$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($a3a3deaca4efee87$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($a3a3deaca4efee87$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $a3a3deaca4efee87$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$a3a3deaca4efee87$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $a3a3deaca4efee87$var$Dj(a, b) {
    if (!$a3a3deaca4efee87$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $a3a3deaca4efee87$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $a3a3deaca4efee87$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $a3a3deaca4efee87$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $a3a3deaca4efee87$var$S(b), null;
        case 1:
            return $a3a3deaca4efee87$var$Zf(b.type) && $a3a3deaca4efee87$var$$f(), $a3a3deaca4efee87$var$S(b), null;
        case 3:
            d = b.stateNode;
            $a3a3deaca4efee87$var$zh();
            $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$Wf);
            $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$H);
            $a3a3deaca4efee87$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $a3a3deaca4efee87$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $a3a3deaca4efee87$var$zg && ($a3a3deaca4efee87$var$Fj($a3a3deaca4efee87$var$zg), $a3a3deaca4efee87$var$zg = null));
            $a3a3deaca4efee87$var$Aj(a, b);
            $a3a3deaca4efee87$var$S(b);
            return null;
        case 5:
            $a3a3deaca4efee87$var$Bh(b);
            var e = $a3a3deaca4efee87$var$xh($a3a3deaca4efee87$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $a3a3deaca4efee87$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($a3a3deaca4efee87$var$p(166));
                    $a3a3deaca4efee87$var$S(b);
                    return null;
                }
                a = $a3a3deaca4efee87$var$xh($a3a3deaca4efee87$var$uh.current);
                if ($a3a3deaca4efee87$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$a3a3deaca4efee87$var$Of] = b;
                    d[$a3a3deaca4efee87$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $a3a3deaca4efee87$var$D("cancel", d);
                            $a3a3deaca4efee87$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $a3a3deaca4efee87$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $a3a3deaca4efee87$var$lf.length; e++)$a3a3deaca4efee87$var$D($a3a3deaca4efee87$var$lf[e], d);
                            break;
                        case "source":
                            $a3a3deaca4efee87$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $a3a3deaca4efee87$var$D("error", d);
                            $a3a3deaca4efee87$var$D("load", d);
                            break;
                        case "details":
                            $a3a3deaca4efee87$var$D("toggle", d);
                            break;
                        case "input":
                            $a3a3deaca4efee87$var$Za(d, f);
                            $a3a3deaca4efee87$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $a3a3deaca4efee87$var$D("invalid", d);
                            break;
                        case "textarea":
                            $a3a3deaca4efee87$var$hb(d, f), $a3a3deaca4efee87$var$D("invalid", d);
                    }
                    $a3a3deaca4efee87$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $a3a3deaca4efee87$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $a3a3deaca4efee87$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $a3a3deaca4efee87$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $a3a3deaca4efee87$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $a3a3deaca4efee87$var$Va(d);
                            $a3a3deaca4efee87$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $a3a3deaca4efee87$var$Va(d);
                            $a3a3deaca4efee87$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $a3a3deaca4efee87$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $a3a3deaca4efee87$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$a3a3deaca4efee87$var$Of] = b;
                    a[$a3a3deaca4efee87$var$Pf] = d;
                    $a3a3deaca4efee87$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $a3a3deaca4efee87$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $a3a3deaca4efee87$var$D("cancel", a);
                                $a3a3deaca4efee87$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $a3a3deaca4efee87$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $a3a3deaca4efee87$var$lf.length; e++)$a3a3deaca4efee87$var$D($a3a3deaca4efee87$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $a3a3deaca4efee87$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $a3a3deaca4efee87$var$D("error", a);
                                $a3a3deaca4efee87$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $a3a3deaca4efee87$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $a3a3deaca4efee87$var$Za(a, d);
                                e = $a3a3deaca4efee87$var$Ya(a, d);
                                $a3a3deaca4efee87$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $a3a3deaca4efee87$var$A({}, d, {
                                    value: void 0
                                });
                                $a3a3deaca4efee87$var$D("invalid", a);
                                break;
                            case "textarea":
                                $a3a3deaca4efee87$var$hb(a, d);
                                e = $a3a3deaca4efee87$var$gb(a, d);
                                $a3a3deaca4efee87$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $a3a3deaca4efee87$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $a3a3deaca4efee87$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $a3a3deaca4efee87$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $a3a3deaca4efee87$var$ob(a, k) : "number" === typeof k && $a3a3deaca4efee87$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($a3a3deaca4efee87$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $a3a3deaca4efee87$var$D("scroll", a) : null != k && $a3a3deaca4efee87$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $a3a3deaca4efee87$var$Va(a);
                                $a3a3deaca4efee87$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $a3a3deaca4efee87$var$Va(a);
                                $a3a3deaca4efee87$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $a3a3deaca4efee87$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $a3a3deaca4efee87$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $a3a3deaca4efee87$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $a3a3deaca4efee87$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $a3a3deaca4efee87$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $a3a3deaca4efee87$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($a3a3deaca4efee87$var$p(166));
                c = $a3a3deaca4efee87$var$xh($a3a3deaca4efee87$var$wh.current);
                $a3a3deaca4efee87$var$xh($a3a3deaca4efee87$var$uh.current);
                if ($a3a3deaca4efee87$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$a3a3deaca4efee87$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $a3a3deaca4efee87$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $a3a3deaca4efee87$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $a3a3deaca4efee87$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$a3a3deaca4efee87$var$Of] = b, b.stateNode = d;
            }
            $a3a3deaca4efee87$var$S(b);
            return null;
        case 13:
            $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($a3a3deaca4efee87$var$I && null !== $a3a3deaca4efee87$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $a3a3deaca4efee87$var$Hg(), $a3a3deaca4efee87$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $a3a3deaca4efee87$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($a3a3deaca4efee87$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($a3a3deaca4efee87$var$p(317));
                        f[$a3a3deaca4efee87$var$Of] = b;
                    } else $a3a3deaca4efee87$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $a3a3deaca4efee87$var$S(b);
                    f = !1;
                } else null !== $a3a3deaca4efee87$var$zg && ($a3a3deaca4efee87$var$Fj($a3a3deaca4efee87$var$zg), $a3a3deaca4efee87$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($a3a3deaca4efee87$var$L.current & 1) ? 0 === $a3a3deaca4efee87$var$T && ($a3a3deaca4efee87$var$T = 3) : $a3a3deaca4efee87$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $a3a3deaca4efee87$var$S(b);
            return null;
        case 4:
            return $a3a3deaca4efee87$var$zh(), $a3a3deaca4efee87$var$Aj(a, b), null === a && $a3a3deaca4efee87$var$sf(b.stateNode.containerInfo), $a3a3deaca4efee87$var$S(b), null;
        case 10:
            return $a3a3deaca4efee87$var$ah(b.type._context), $a3a3deaca4efee87$var$S(b), null;
        case 17:
            return $a3a3deaca4efee87$var$Zf(b.type) && $a3a3deaca4efee87$var$$f(), $a3a3deaca4efee87$var$S(b), null;
        case 19:
            $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$L);
            f = b.memoizedState;
            if (null === f) return $a3a3deaca4efee87$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $a3a3deaca4efee87$var$Dj(f, !1);
                else {
                    if (0 !== $a3a3deaca4efee87$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $a3a3deaca4efee87$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $a3a3deaca4efee87$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$L, $a3a3deaca4efee87$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $a3a3deaca4efee87$var$B() > $a3a3deaca4efee87$var$Gj && (b.flags |= 128, d = !0, $a3a3deaca4efee87$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $a3a3deaca4efee87$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $a3a3deaca4efee87$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$a3a3deaca4efee87$var$I) return $a3a3deaca4efee87$var$S(b), null;
                    } else 2 * $a3a3deaca4efee87$var$B() - f.renderingStartTime > $a3a3deaca4efee87$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $a3a3deaca4efee87$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $a3a3deaca4efee87$var$B(), b.sibling = null, c = $a3a3deaca4efee87$var$L.current, $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$L, d ? c & 1 | 2 : c & 1), b;
            $a3a3deaca4efee87$var$S(b);
            return null;
        case 22:
        case 23:
            return $a3a3deaca4efee87$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($a3a3deaca4efee87$var$fj & 1073741824) && ($a3a3deaca4efee87$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $a3a3deaca4efee87$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($a3a3deaca4efee87$var$p(156, b.tag));
}
function $a3a3deaca4efee87$var$Ij(a, b) {
    $a3a3deaca4efee87$var$wg(b);
    switch(b.tag){
        case 1:
            return $a3a3deaca4efee87$var$Zf(b.type) && $a3a3deaca4efee87$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $a3a3deaca4efee87$var$zh(), $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$Wf), $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$H), $a3a3deaca4efee87$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $a3a3deaca4efee87$var$Bh(b), null;
        case 13:
            $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($a3a3deaca4efee87$var$p(340));
                $a3a3deaca4efee87$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$L), null;
        case 4:
            return $a3a3deaca4efee87$var$zh(), null;
        case 10:
            return $a3a3deaca4efee87$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $a3a3deaca4efee87$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $a3a3deaca4efee87$var$Jj = !1, $a3a3deaca4efee87$var$U = !1, $a3a3deaca4efee87$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $a3a3deaca4efee87$var$V = null;
function $a3a3deaca4efee87$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $a3a3deaca4efee87$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $a3a3deaca4efee87$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $a3a3deaca4efee87$var$W(a, b, d);
    }
}
var $a3a3deaca4efee87$var$Nj = !1;
function $a3a3deaca4efee87$var$Oj(a, b) {
    $a3a3deaca4efee87$var$Cf = $a3a3deaca4efee87$var$dd;
    a = $a3a3deaca4efee87$var$Me();
    if ($a3a3deaca4efee87$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $a3a3deaca4efee87$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $a3a3deaca4efee87$var$dd = !1;
    for($a3a3deaca4efee87$var$V = b; null !== $a3a3deaca4efee87$var$V;)if (b = $a3a3deaca4efee87$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $a3a3deaca4efee87$var$V = a;
    else for(; null !== $a3a3deaca4efee87$var$V;){
        b = $a3a3deaca4efee87$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $a3a3deaca4efee87$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($a3a3deaca4efee87$var$p(163));
            }
        } catch (F) {
            $a3a3deaca4efee87$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $a3a3deaca4efee87$var$V = a;
            break;
        }
        $a3a3deaca4efee87$var$V = b.return;
    }
    n = $a3a3deaca4efee87$var$Nj;
    $a3a3deaca4efee87$var$Nj = !1;
    return n;
}
function $a3a3deaca4efee87$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $a3a3deaca4efee87$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $a3a3deaca4efee87$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $a3a3deaca4efee87$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $a3a3deaca4efee87$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $a3a3deaca4efee87$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$a3a3deaca4efee87$var$Of], delete b[$a3a3deaca4efee87$var$Pf], delete b[$a3a3deaca4efee87$var$of], delete b[$a3a3deaca4efee87$var$Qf], delete b[$a3a3deaca4efee87$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $a3a3deaca4efee87$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $a3a3deaca4efee87$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $a3a3deaca4efee87$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $a3a3deaca4efee87$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $a3a3deaca4efee87$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($a3a3deaca4efee87$var$Vj(a, b, c), a = a.sibling; null !== a;)$a3a3deaca4efee87$var$Vj(a, b, c), a = a.sibling;
}
function $a3a3deaca4efee87$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($a3a3deaca4efee87$var$Wj(a, b, c), a = a.sibling; null !== a;)$a3a3deaca4efee87$var$Wj(a, b, c), a = a.sibling;
}
var $a3a3deaca4efee87$var$X = null, $a3a3deaca4efee87$var$Xj = !1;
function $a3a3deaca4efee87$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$a3a3deaca4efee87$var$Zj(a, b, c), c = c.sibling;
}
function $a3a3deaca4efee87$var$Zj(a, b, c) {
    if ($a3a3deaca4efee87$var$lc && "function" === typeof $a3a3deaca4efee87$var$lc.onCommitFiberUnmount) try {
        $a3a3deaca4efee87$var$lc.onCommitFiberUnmount($a3a3deaca4efee87$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $a3a3deaca4efee87$var$U || $a3a3deaca4efee87$var$Lj(c, b);
        case 6:
            var d = $a3a3deaca4efee87$var$X, e = $a3a3deaca4efee87$var$Xj;
            $a3a3deaca4efee87$var$X = null;
            $a3a3deaca4efee87$var$Yj(a, b, c);
            $a3a3deaca4efee87$var$X = d;
            $a3a3deaca4efee87$var$Xj = e;
            null !== $a3a3deaca4efee87$var$X && ($a3a3deaca4efee87$var$Xj ? (a = $a3a3deaca4efee87$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $a3a3deaca4efee87$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $a3a3deaca4efee87$var$X && ($a3a3deaca4efee87$var$Xj ? (a = $a3a3deaca4efee87$var$X, c = c.stateNode, 8 === a.nodeType ? $a3a3deaca4efee87$var$Kf(a.parentNode, c) : 1 === a.nodeType && $a3a3deaca4efee87$var$Kf(a, c), $a3a3deaca4efee87$var$bd(a)) : $a3a3deaca4efee87$var$Kf($a3a3deaca4efee87$var$X, c.stateNode));
            break;
        case 4:
            d = $a3a3deaca4efee87$var$X;
            e = $a3a3deaca4efee87$var$Xj;
            $a3a3deaca4efee87$var$X = c.stateNode.containerInfo;
            $a3a3deaca4efee87$var$Xj = !0;
            $a3a3deaca4efee87$var$Yj(a, b, c);
            $a3a3deaca4efee87$var$X = d;
            $a3a3deaca4efee87$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$a3a3deaca4efee87$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $a3a3deaca4efee87$var$Mj(c, b, g) : 0 !== (f & 4) && $a3a3deaca4efee87$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $a3a3deaca4efee87$var$Yj(a, b, c);
            break;
        case 1:
            if (!$a3a3deaca4efee87$var$U && ($a3a3deaca4efee87$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $a3a3deaca4efee87$var$W(c, b, h);
            }
            $a3a3deaca4efee87$var$Yj(a, b, c);
            break;
        case 21:
            $a3a3deaca4efee87$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($a3a3deaca4efee87$var$U = (d = $a3a3deaca4efee87$var$U) || null !== c.memoizedState, $a3a3deaca4efee87$var$Yj(a, b, c), $a3a3deaca4efee87$var$U = d) : $a3a3deaca4efee87$var$Yj(a, b, c);
            break;
        default:
            $a3a3deaca4efee87$var$Yj(a, b, c);
    }
}
function $a3a3deaca4efee87$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $a3a3deaca4efee87$var$Kj);
        b.forEach(function(b) {
            var d = $a3a3deaca4efee87$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $a3a3deaca4efee87$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $a3a3deaca4efee87$var$X = h.stateNode;
                        $a3a3deaca4efee87$var$Xj = !1;
                        break a;
                    case 3:
                        $a3a3deaca4efee87$var$X = h.stateNode.containerInfo;
                        $a3a3deaca4efee87$var$Xj = !0;
                        break a;
                    case 4:
                        $a3a3deaca4efee87$var$X = h.stateNode.containerInfo;
                        $a3a3deaca4efee87$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $a3a3deaca4efee87$var$X) throw Error($a3a3deaca4efee87$var$p(160));
            $a3a3deaca4efee87$var$Zj(f, g, e);
            $a3a3deaca4efee87$var$X = null;
            $a3a3deaca4efee87$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $a3a3deaca4efee87$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$a3a3deaca4efee87$var$dk(b, a), b = b.sibling;
}
function $a3a3deaca4efee87$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $a3a3deaca4efee87$var$ck(b, a);
            $a3a3deaca4efee87$var$ek(a);
            if (d & 4) {
                try {
                    $a3a3deaca4efee87$var$Pj(3, a, a.return), $a3a3deaca4efee87$var$Qj(3, a);
                } catch (t) {
                    $a3a3deaca4efee87$var$W(a, a.return, t);
                }
                try {
                    $a3a3deaca4efee87$var$Pj(5, a, a.return);
                } catch (t) {
                    $a3a3deaca4efee87$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $a3a3deaca4efee87$var$ck(b, a);
            $a3a3deaca4efee87$var$ek(a);
            d & 512 && null !== c && $a3a3deaca4efee87$var$Lj(c, c.return);
            break;
        case 5:
            $a3a3deaca4efee87$var$ck(b, a);
            $a3a3deaca4efee87$var$ek(a);
            d & 512 && null !== c && $a3a3deaca4efee87$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $a3a3deaca4efee87$var$ob(e, "");
                } catch (t) {
                    $a3a3deaca4efee87$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $a3a3deaca4efee87$var$ab(e, f);
                    $a3a3deaca4efee87$var$vb(h, g);
                    var l = $a3a3deaca4efee87$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $a3a3deaca4efee87$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $a3a3deaca4efee87$var$nb(e, q) : "children" === m ? $a3a3deaca4efee87$var$ob(e, q) : $a3a3deaca4efee87$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $a3a3deaca4efee87$var$bb(e, f);
                            break;
                        case "textarea":
                            $a3a3deaca4efee87$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $a3a3deaca4efee87$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $a3a3deaca4efee87$var$fb(e, !!f.multiple, f.defaultValue, !0) : $a3a3deaca4efee87$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$a3a3deaca4efee87$var$Pf] = f;
                } catch (t) {
                    $a3a3deaca4efee87$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $a3a3deaca4efee87$var$ck(b, a);
            $a3a3deaca4efee87$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($a3a3deaca4efee87$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $a3a3deaca4efee87$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $a3a3deaca4efee87$var$ck(b, a);
            $a3a3deaca4efee87$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $a3a3deaca4efee87$var$bd(b.containerInfo);
            } catch (t) {
                $a3a3deaca4efee87$var$W(a, a.return, t);
            }
            break;
        case 4:
            $a3a3deaca4efee87$var$ck(b, a);
            $a3a3deaca4efee87$var$ek(a);
            break;
        case 13:
            $a3a3deaca4efee87$var$ck(b, a);
            $a3a3deaca4efee87$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($a3a3deaca4efee87$var$fk = $a3a3deaca4efee87$var$B()));
            d & 4 && $a3a3deaca4efee87$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($a3a3deaca4efee87$var$U = (l = $a3a3deaca4efee87$var$U) || m, $a3a3deaca4efee87$var$ck(b, a), $a3a3deaca4efee87$var$U = l) : $a3a3deaca4efee87$var$ck(b, a);
            $a3a3deaca4efee87$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($a3a3deaca4efee87$var$V = a, m = a.child; null !== m;){
                    for(q = $a3a3deaca4efee87$var$V = m; null !== $a3a3deaca4efee87$var$V;){
                        r = $a3a3deaca4efee87$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $a3a3deaca4efee87$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $a3a3deaca4efee87$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $a3a3deaca4efee87$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $a3a3deaca4efee87$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $a3a3deaca4efee87$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $a3a3deaca4efee87$var$V = y) : $a3a3deaca4efee87$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $a3a3deaca4efee87$var$rb("display", g));
                            } catch (t) {
                                $a3a3deaca4efee87$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $a3a3deaca4efee87$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $a3a3deaca4efee87$var$ck(b, a);
            $a3a3deaca4efee87$var$ek(a);
            d & 4 && $a3a3deaca4efee87$var$ak(a);
            break;
        case 21:
            break;
        default:
            $a3a3deaca4efee87$var$ck(b, a), $a3a3deaca4efee87$var$ek(a);
    }
}
function $a3a3deaca4efee87$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($a3a3deaca4efee87$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($a3a3deaca4efee87$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($a3a3deaca4efee87$var$ob(e, ""), d.flags &= -33);
                    var f = $a3a3deaca4efee87$var$Uj(a);
                    $a3a3deaca4efee87$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $a3a3deaca4efee87$var$Uj(a);
                    $a3a3deaca4efee87$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($a3a3deaca4efee87$var$p(161));
            }
        } catch (k) {
            $a3a3deaca4efee87$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $a3a3deaca4efee87$var$hk(a, b, c) {
    $a3a3deaca4efee87$var$V = a;
    $a3a3deaca4efee87$var$ik(a, b, c);
}
function $a3a3deaca4efee87$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $a3a3deaca4efee87$var$V;){
        var e = $a3a3deaca4efee87$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $a3a3deaca4efee87$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $a3a3deaca4efee87$var$U;
                h = $a3a3deaca4efee87$var$Jj;
                var l = $a3a3deaca4efee87$var$U;
                $a3a3deaca4efee87$var$Jj = g;
                if (($a3a3deaca4efee87$var$U = k) && !l) for($a3a3deaca4efee87$var$V = e; null !== $a3a3deaca4efee87$var$V;)g = $a3a3deaca4efee87$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $a3a3deaca4efee87$var$jk(e) : null !== k ? (k.return = g, $a3a3deaca4efee87$var$V = k) : $a3a3deaca4efee87$var$jk(e);
                for(; null !== f;)$a3a3deaca4efee87$var$V = f, $a3a3deaca4efee87$var$ik(f, b, c), f = f.sibling;
                $a3a3deaca4efee87$var$V = e;
                $a3a3deaca4efee87$var$Jj = h;
                $a3a3deaca4efee87$var$U = l;
            }
            $a3a3deaca4efee87$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $a3a3deaca4efee87$var$V = f) : $a3a3deaca4efee87$var$kk(a, b, c);
    }
}
function $a3a3deaca4efee87$var$kk(a) {
    for(; null !== $a3a3deaca4efee87$var$V;){
        var b = $a3a3deaca4efee87$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $a3a3deaca4efee87$var$U || $a3a3deaca4efee87$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$a3a3deaca4efee87$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $a3a3deaca4efee87$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $a3a3deaca4efee87$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $a3a3deaca4efee87$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $a3a3deaca4efee87$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($a3a3deaca4efee87$var$p(163));
                }
                $a3a3deaca4efee87$var$U || b.flags & 512 && $a3a3deaca4efee87$var$Rj(b);
            } catch (r) {
                $a3a3deaca4efee87$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $a3a3deaca4efee87$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a3a3deaca4efee87$var$V = c;
            break;
        }
        $a3a3deaca4efee87$var$V = b.return;
    }
}
function $a3a3deaca4efee87$var$gk(a) {
    for(; null !== $a3a3deaca4efee87$var$V;){
        var b = $a3a3deaca4efee87$var$V;
        if (b === a) {
            $a3a3deaca4efee87$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a3a3deaca4efee87$var$V = c;
            break;
        }
        $a3a3deaca4efee87$var$V = b.return;
    }
}
function $a3a3deaca4efee87$var$jk(a) {
    for(; null !== $a3a3deaca4efee87$var$V;){
        var b = $a3a3deaca4efee87$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $a3a3deaca4efee87$var$Qj(4, b);
                    } catch (k) {
                        $a3a3deaca4efee87$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $a3a3deaca4efee87$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $a3a3deaca4efee87$var$Rj(b);
                    } catch (k) {
                        $a3a3deaca4efee87$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $a3a3deaca4efee87$var$Rj(b);
                    } catch (k) {
                        $a3a3deaca4efee87$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $a3a3deaca4efee87$var$W(b, b.return, k);
        }
        if (b === a) {
            $a3a3deaca4efee87$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $a3a3deaca4efee87$var$V = h;
            break;
        }
        $a3a3deaca4efee87$var$V = b.return;
    }
}
var $a3a3deaca4efee87$var$lk = Math.ceil, $a3a3deaca4efee87$var$mk = $a3a3deaca4efee87$var$ua.ReactCurrentDispatcher, $a3a3deaca4efee87$var$nk = $a3a3deaca4efee87$var$ua.ReactCurrentOwner, $a3a3deaca4efee87$var$ok = $a3a3deaca4efee87$var$ua.ReactCurrentBatchConfig, $a3a3deaca4efee87$var$K = 0, $a3a3deaca4efee87$var$Q = null, $a3a3deaca4efee87$var$Y = null, $a3a3deaca4efee87$var$Z = 0, $a3a3deaca4efee87$var$fj = 0, $a3a3deaca4efee87$var$ej = $a3a3deaca4efee87$var$Uf(0), $a3a3deaca4efee87$var$T = 0, $a3a3deaca4efee87$var$pk = null, $a3a3deaca4efee87$var$rh = 0, $a3a3deaca4efee87$var$qk = 0, $a3a3deaca4efee87$var$rk = 0, $a3a3deaca4efee87$var$sk = null, $a3a3deaca4efee87$var$tk = null, $a3a3deaca4efee87$var$fk = 0, $a3a3deaca4efee87$var$Gj = Infinity, $a3a3deaca4efee87$var$uk = null, $a3a3deaca4efee87$var$Oi = !1, $a3a3deaca4efee87$var$Pi = null, $a3a3deaca4efee87$var$Ri = null, $a3a3deaca4efee87$var$vk = !1, $a3a3deaca4efee87$var$wk = null, $a3a3deaca4efee87$var$xk = 0, $a3a3deaca4efee87$var$yk = 0, $a3a3deaca4efee87$var$zk = null, $a3a3deaca4efee87$var$Ak = -1, $a3a3deaca4efee87$var$Bk = 0;
function $a3a3deaca4efee87$var$R() {
    return 0 !== ($a3a3deaca4efee87$var$K & 6) ? $a3a3deaca4efee87$var$B() : -1 !== $a3a3deaca4efee87$var$Ak ? $a3a3deaca4efee87$var$Ak : $a3a3deaca4efee87$var$Ak = $a3a3deaca4efee87$var$B();
}
function $a3a3deaca4efee87$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($a3a3deaca4efee87$var$K & 2) && 0 !== $a3a3deaca4efee87$var$Z) return $a3a3deaca4efee87$var$Z & -$a3a3deaca4efee87$var$Z;
    if (null !== $a3a3deaca4efee87$var$Kg.transition) return 0 === $a3a3deaca4efee87$var$Bk && ($a3a3deaca4efee87$var$Bk = $a3a3deaca4efee87$var$yc()), $a3a3deaca4efee87$var$Bk;
    a = $a3a3deaca4efee87$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $a3a3deaca4efee87$var$jd(a.type);
    return a;
}
function $a3a3deaca4efee87$var$gi(a, b, c, d) {
    if (50 < $a3a3deaca4efee87$var$yk) throw $a3a3deaca4efee87$var$yk = 0, $a3a3deaca4efee87$var$zk = null, Error($a3a3deaca4efee87$var$p(185));
    $a3a3deaca4efee87$var$Ac(a, c, d);
    if (0 === ($a3a3deaca4efee87$var$K & 2) || a !== $a3a3deaca4efee87$var$Q) a === $a3a3deaca4efee87$var$Q && (0 === ($a3a3deaca4efee87$var$K & 2) && ($a3a3deaca4efee87$var$qk |= c), 4 === $a3a3deaca4efee87$var$T && $a3a3deaca4efee87$var$Ck(a, $a3a3deaca4efee87$var$Z)), $a3a3deaca4efee87$var$Dk(a, d), 1 === c && 0 === $a3a3deaca4efee87$var$K && 0 === (b.mode & 1) && ($a3a3deaca4efee87$var$Gj = $a3a3deaca4efee87$var$B() + 500, $a3a3deaca4efee87$var$fg && $a3a3deaca4efee87$var$jg());
}
function $a3a3deaca4efee87$var$Dk(a, b) {
    var c = a.callbackNode;
    $a3a3deaca4efee87$var$wc(a, b);
    var d = $a3a3deaca4efee87$var$uc(a, a === $a3a3deaca4efee87$var$Q ? $a3a3deaca4efee87$var$Z : 0);
    if (0 === d) null !== c && $a3a3deaca4efee87$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $a3a3deaca4efee87$var$bc(c);
        if (1 === b) 0 === a.tag ? $a3a3deaca4efee87$var$ig($a3a3deaca4efee87$var$Ek.bind(null, a)) : $a3a3deaca4efee87$var$hg($a3a3deaca4efee87$var$Ek.bind(null, a)), $a3a3deaca4efee87$var$Jf(function() {
            0 === ($a3a3deaca4efee87$var$K & 6) && $a3a3deaca4efee87$var$jg();
        }), c = null;
        else {
            switch($a3a3deaca4efee87$var$Dc(d)){
                case 1:
                    c = $a3a3deaca4efee87$var$fc;
                    break;
                case 4:
                    c = $a3a3deaca4efee87$var$gc;
                    break;
                case 16:
                    c = $a3a3deaca4efee87$var$hc;
                    break;
                case 536870912:
                    c = $a3a3deaca4efee87$var$jc;
                    break;
                default:
                    c = $a3a3deaca4efee87$var$hc;
            }
            c = $a3a3deaca4efee87$var$Fk(c, $a3a3deaca4efee87$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $a3a3deaca4efee87$var$Gk(a, b) {
    $a3a3deaca4efee87$var$Ak = -1;
    $a3a3deaca4efee87$var$Bk = 0;
    if (0 !== ($a3a3deaca4efee87$var$K & 6)) throw Error($a3a3deaca4efee87$var$p(327));
    var c = a.callbackNode;
    if ($a3a3deaca4efee87$var$Hk() && a.callbackNode !== c) return null;
    var d = $a3a3deaca4efee87$var$uc(a, a === $a3a3deaca4efee87$var$Q ? $a3a3deaca4efee87$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $a3a3deaca4efee87$var$Ik(a, d);
    else {
        b = d;
        var e = $a3a3deaca4efee87$var$K;
        $a3a3deaca4efee87$var$K |= 2;
        var f = $a3a3deaca4efee87$var$Jk();
        if ($a3a3deaca4efee87$var$Q !== a || $a3a3deaca4efee87$var$Z !== b) $a3a3deaca4efee87$var$uk = null, $a3a3deaca4efee87$var$Gj = $a3a3deaca4efee87$var$B() + 500, $a3a3deaca4efee87$var$Kk(a, b);
        for(;;)try {
            $a3a3deaca4efee87$var$Lk();
            break;
        } catch (h) {
            $a3a3deaca4efee87$var$Mk(a, h);
        }
        $a3a3deaca4efee87$var$$g();
        $a3a3deaca4efee87$var$mk.current = f;
        $a3a3deaca4efee87$var$K = e;
        null !== $a3a3deaca4efee87$var$Y ? b = 0 : ($a3a3deaca4efee87$var$Q = null, $a3a3deaca4efee87$var$Z = 0, b = $a3a3deaca4efee87$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $a3a3deaca4efee87$var$xc(a), 0 !== e && (d = e, b = $a3a3deaca4efee87$var$Nk(a, e)));
        if (1 === b) throw c = $a3a3deaca4efee87$var$pk, $a3a3deaca4efee87$var$Kk(a, 0), $a3a3deaca4efee87$var$Ck(a, d), $a3a3deaca4efee87$var$Dk(a, $a3a3deaca4efee87$var$B()), c;
        if (6 === b) $a3a3deaca4efee87$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$a3a3deaca4efee87$var$Ok(e) && (b = $a3a3deaca4efee87$var$Ik(a, d), 2 === b && (f = $a3a3deaca4efee87$var$xc(a), 0 !== f && (d = f, b = $a3a3deaca4efee87$var$Nk(a, f))), 1 === b)) throw c = $a3a3deaca4efee87$var$pk, $a3a3deaca4efee87$var$Kk(a, 0), $a3a3deaca4efee87$var$Ck(a, d), $a3a3deaca4efee87$var$Dk(a, $a3a3deaca4efee87$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($a3a3deaca4efee87$var$p(345));
                case 2:
                    $a3a3deaca4efee87$var$Pk(a, $a3a3deaca4efee87$var$tk, $a3a3deaca4efee87$var$uk);
                    break;
                case 3:
                    $a3a3deaca4efee87$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $a3a3deaca4efee87$var$fk + 500 - $a3a3deaca4efee87$var$B(), 10 < b)) {
                        if (0 !== $a3a3deaca4efee87$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $a3a3deaca4efee87$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $a3a3deaca4efee87$var$Ff($a3a3deaca4efee87$var$Pk.bind(null, a, $a3a3deaca4efee87$var$tk, $a3a3deaca4efee87$var$uk), b);
                        break;
                    }
                    $a3a3deaca4efee87$var$Pk(a, $a3a3deaca4efee87$var$tk, $a3a3deaca4efee87$var$uk);
                    break;
                case 4:
                    $a3a3deaca4efee87$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $a3a3deaca4efee87$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $a3a3deaca4efee87$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $a3a3deaca4efee87$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $a3a3deaca4efee87$var$Ff($a3a3deaca4efee87$var$Pk.bind(null, a, $a3a3deaca4efee87$var$tk, $a3a3deaca4efee87$var$uk), d);
                        break;
                    }
                    $a3a3deaca4efee87$var$Pk(a, $a3a3deaca4efee87$var$tk, $a3a3deaca4efee87$var$uk);
                    break;
                case 5:
                    $a3a3deaca4efee87$var$Pk(a, $a3a3deaca4efee87$var$tk, $a3a3deaca4efee87$var$uk);
                    break;
                default:
                    throw Error($a3a3deaca4efee87$var$p(329));
            }
        }
    }
    $a3a3deaca4efee87$var$Dk(a, $a3a3deaca4efee87$var$B());
    return a.callbackNode === c ? $a3a3deaca4efee87$var$Gk.bind(null, a) : null;
}
function $a3a3deaca4efee87$var$Nk(a, b) {
    var c = $a3a3deaca4efee87$var$sk;
    a.current.memoizedState.isDehydrated && ($a3a3deaca4efee87$var$Kk(a, b).flags |= 256);
    a = $a3a3deaca4efee87$var$Ik(a, b);
    2 !== a && (b = $a3a3deaca4efee87$var$tk, $a3a3deaca4efee87$var$tk = c, null !== b && $a3a3deaca4efee87$var$Fj(b));
    return a;
}
function $a3a3deaca4efee87$var$Fj(a) {
    null === $a3a3deaca4efee87$var$tk ? $a3a3deaca4efee87$var$tk = a : $a3a3deaca4efee87$var$tk.push.apply($a3a3deaca4efee87$var$tk, a);
}
function $a3a3deaca4efee87$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$a3a3deaca4efee87$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $a3a3deaca4efee87$var$Ck(a, b) {
    b &= ~$a3a3deaca4efee87$var$rk;
    b &= ~$a3a3deaca4efee87$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $a3a3deaca4efee87$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $a3a3deaca4efee87$var$Ek(a) {
    if (0 !== ($a3a3deaca4efee87$var$K & 6)) throw Error($a3a3deaca4efee87$var$p(327));
    $a3a3deaca4efee87$var$Hk();
    var b = $a3a3deaca4efee87$var$uc(a, 0);
    if (0 === (b & 1)) return $a3a3deaca4efee87$var$Dk(a, $a3a3deaca4efee87$var$B()), null;
    var c = $a3a3deaca4efee87$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $a3a3deaca4efee87$var$xc(a);
        0 !== d && (b = d, c = $a3a3deaca4efee87$var$Nk(a, d));
    }
    if (1 === c) throw c = $a3a3deaca4efee87$var$pk, $a3a3deaca4efee87$var$Kk(a, 0), $a3a3deaca4efee87$var$Ck(a, b), $a3a3deaca4efee87$var$Dk(a, $a3a3deaca4efee87$var$B()), c;
    if (6 === c) throw Error($a3a3deaca4efee87$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $a3a3deaca4efee87$var$Pk(a, $a3a3deaca4efee87$var$tk, $a3a3deaca4efee87$var$uk);
    $a3a3deaca4efee87$var$Dk(a, $a3a3deaca4efee87$var$B());
    return null;
}
function $a3a3deaca4efee87$var$Qk(a, b) {
    var c = $a3a3deaca4efee87$var$K;
    $a3a3deaca4efee87$var$K |= 1;
    try {
        return a(b);
    } finally{
        $a3a3deaca4efee87$var$K = c, 0 === $a3a3deaca4efee87$var$K && ($a3a3deaca4efee87$var$Gj = $a3a3deaca4efee87$var$B() + 500, $a3a3deaca4efee87$var$fg && $a3a3deaca4efee87$var$jg());
    }
}
function $a3a3deaca4efee87$var$Rk(a) {
    null !== $a3a3deaca4efee87$var$wk && 0 === $a3a3deaca4efee87$var$wk.tag && 0 === ($a3a3deaca4efee87$var$K & 6) && $a3a3deaca4efee87$var$Hk();
    var b = $a3a3deaca4efee87$var$K;
    $a3a3deaca4efee87$var$K |= 1;
    var c = $a3a3deaca4efee87$var$ok.transition, d = $a3a3deaca4efee87$var$C;
    try {
        if ($a3a3deaca4efee87$var$ok.transition = null, $a3a3deaca4efee87$var$C = 1, a) return a();
    } finally{
        $a3a3deaca4efee87$var$C = d, $a3a3deaca4efee87$var$ok.transition = c, $a3a3deaca4efee87$var$K = b, 0 === ($a3a3deaca4efee87$var$K & 6) && $a3a3deaca4efee87$var$jg();
    }
}
function $a3a3deaca4efee87$var$Hj() {
    $a3a3deaca4efee87$var$fj = $a3a3deaca4efee87$var$ej.current;
    $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$ej);
}
function $a3a3deaca4efee87$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $a3a3deaca4efee87$var$Gf(c));
    if (null !== $a3a3deaca4efee87$var$Y) for(c = $a3a3deaca4efee87$var$Y.return; null !== c;){
        var d = c;
        $a3a3deaca4efee87$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $a3a3deaca4efee87$var$$f();
                break;
            case 3:
                $a3a3deaca4efee87$var$zh();
                $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$Wf);
                $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$H);
                $a3a3deaca4efee87$var$Eh();
                break;
            case 5:
                $a3a3deaca4efee87$var$Bh(d);
                break;
            case 4:
                $a3a3deaca4efee87$var$zh();
                break;
            case 13:
                $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$L);
                break;
            case 19:
                $a3a3deaca4efee87$var$E($a3a3deaca4efee87$var$L);
                break;
            case 10:
                $a3a3deaca4efee87$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $a3a3deaca4efee87$var$Hj();
        }
        c = c.return;
    }
    $a3a3deaca4efee87$var$Q = a;
    $a3a3deaca4efee87$var$Y = a = $a3a3deaca4efee87$var$Pg(a.current, null);
    $a3a3deaca4efee87$var$Z = $a3a3deaca4efee87$var$fj = b;
    $a3a3deaca4efee87$var$T = 0;
    $a3a3deaca4efee87$var$pk = null;
    $a3a3deaca4efee87$var$rk = $a3a3deaca4efee87$var$qk = $a3a3deaca4efee87$var$rh = 0;
    $a3a3deaca4efee87$var$tk = $a3a3deaca4efee87$var$sk = null;
    if (null !== $a3a3deaca4efee87$var$fh) {
        for(b = 0; b < $a3a3deaca4efee87$var$fh.length; b++)if (c = $a3a3deaca4efee87$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $a3a3deaca4efee87$var$fh = null;
    }
    return a;
}
function $a3a3deaca4efee87$var$Mk(a, b) {
    do {
        var c = $a3a3deaca4efee87$var$Y;
        try {
            $a3a3deaca4efee87$var$$g();
            $a3a3deaca4efee87$var$Fh.current = $a3a3deaca4efee87$var$Rh;
            if ($a3a3deaca4efee87$var$Ih) {
                for(var d = $a3a3deaca4efee87$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $a3a3deaca4efee87$var$Ih = !1;
            }
            $a3a3deaca4efee87$var$Hh = 0;
            $a3a3deaca4efee87$var$O = $a3a3deaca4efee87$var$N = $a3a3deaca4efee87$var$M = null;
            $a3a3deaca4efee87$var$Jh = !1;
            $a3a3deaca4efee87$var$Kh = 0;
            $a3a3deaca4efee87$var$nk.current = null;
            if (null === c || null === c.return) {
                $a3a3deaca4efee87$var$T = 1;
                $a3a3deaca4efee87$var$pk = b;
                $a3a3deaca4efee87$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $a3a3deaca4efee87$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $a3a3deaca4efee87$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $a3a3deaca4efee87$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $a3a3deaca4efee87$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $a3a3deaca4efee87$var$Si(f, l, b);
                            $a3a3deaca4efee87$var$tj();
                            break a;
                        }
                        k = Error($a3a3deaca4efee87$var$p(426));
                    }
                } else if ($a3a3deaca4efee87$var$I && h.mode & 1) {
                    var J = $a3a3deaca4efee87$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $a3a3deaca4efee87$var$Vi(J, g, h, f, b);
                        $a3a3deaca4efee87$var$Jg($a3a3deaca4efee87$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $a3a3deaca4efee87$var$Ji(k, h);
                4 !== $a3a3deaca4efee87$var$T && ($a3a3deaca4efee87$var$T = 2);
                null === $a3a3deaca4efee87$var$sk ? $a3a3deaca4efee87$var$sk = [
                    f
                ] : $a3a3deaca4efee87$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $a3a3deaca4efee87$var$Ni(f, k, b);
                            $a3a3deaca4efee87$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $a3a3deaca4efee87$var$Ri || !$a3a3deaca4efee87$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $a3a3deaca4efee87$var$Qi(f, h, b);
                                $a3a3deaca4efee87$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $a3a3deaca4efee87$var$Sk(c);
        } catch (na) {
            b = na;
            $a3a3deaca4efee87$var$Y === c && null !== c && ($a3a3deaca4efee87$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $a3a3deaca4efee87$var$Jk() {
    var a = $a3a3deaca4efee87$var$mk.current;
    $a3a3deaca4efee87$var$mk.current = $a3a3deaca4efee87$var$Rh;
    return null === a ? $a3a3deaca4efee87$var$Rh : a;
}
function $a3a3deaca4efee87$var$tj() {
    if (0 === $a3a3deaca4efee87$var$T || 3 === $a3a3deaca4efee87$var$T || 2 === $a3a3deaca4efee87$var$T) $a3a3deaca4efee87$var$T = 4;
    null === $a3a3deaca4efee87$var$Q || 0 === ($a3a3deaca4efee87$var$rh & 268435455) && 0 === ($a3a3deaca4efee87$var$qk & 268435455) || $a3a3deaca4efee87$var$Ck($a3a3deaca4efee87$var$Q, $a3a3deaca4efee87$var$Z);
}
function $a3a3deaca4efee87$var$Ik(a, b) {
    var c = $a3a3deaca4efee87$var$K;
    $a3a3deaca4efee87$var$K |= 2;
    var d = $a3a3deaca4efee87$var$Jk();
    if ($a3a3deaca4efee87$var$Q !== a || $a3a3deaca4efee87$var$Z !== b) $a3a3deaca4efee87$var$uk = null, $a3a3deaca4efee87$var$Kk(a, b);
    for(;;)try {
        $a3a3deaca4efee87$var$Tk();
        break;
    } catch (e) {
        $a3a3deaca4efee87$var$Mk(a, e);
    }
    $a3a3deaca4efee87$var$$g();
    $a3a3deaca4efee87$var$K = c;
    $a3a3deaca4efee87$var$mk.current = d;
    if (null !== $a3a3deaca4efee87$var$Y) throw Error($a3a3deaca4efee87$var$p(261));
    $a3a3deaca4efee87$var$Q = null;
    $a3a3deaca4efee87$var$Z = 0;
    return $a3a3deaca4efee87$var$T;
}
function $a3a3deaca4efee87$var$Tk() {
    for(; null !== $a3a3deaca4efee87$var$Y;)$a3a3deaca4efee87$var$Uk($a3a3deaca4efee87$var$Y);
}
function $a3a3deaca4efee87$var$Lk() {
    for(; null !== $a3a3deaca4efee87$var$Y && !$a3a3deaca4efee87$var$cc();)$a3a3deaca4efee87$var$Uk($a3a3deaca4efee87$var$Y);
}
function $a3a3deaca4efee87$var$Uk(a) {
    var b = $a3a3deaca4efee87$var$Vk(a.alternate, a, $a3a3deaca4efee87$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $a3a3deaca4efee87$var$Sk(a) : $a3a3deaca4efee87$var$Y = b;
    $a3a3deaca4efee87$var$nk.current = null;
}
function $a3a3deaca4efee87$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $a3a3deaca4efee87$var$Ej(c, b, $a3a3deaca4efee87$var$fj), null !== c) {
                $a3a3deaca4efee87$var$Y = c;
                return;
            }
        } else {
            c = $a3a3deaca4efee87$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $a3a3deaca4efee87$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $a3a3deaca4efee87$var$T = 6;
                $a3a3deaca4efee87$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $a3a3deaca4efee87$var$Y = b;
            return;
        }
        $a3a3deaca4efee87$var$Y = b = a;
    }while (null !== b);
    0 === $a3a3deaca4efee87$var$T && ($a3a3deaca4efee87$var$T = 5);
}
function $a3a3deaca4efee87$var$Pk(a, b, c) {
    var d = $a3a3deaca4efee87$var$C, e = $a3a3deaca4efee87$var$ok.transition;
    try {
        $a3a3deaca4efee87$var$ok.transition = null, $a3a3deaca4efee87$var$C = 1, $a3a3deaca4efee87$var$Wk(a, b, c, d);
    } finally{
        $a3a3deaca4efee87$var$ok.transition = e, $a3a3deaca4efee87$var$C = d;
    }
    return null;
}
function $a3a3deaca4efee87$var$Wk(a, b, c, d) {
    do $a3a3deaca4efee87$var$Hk();
    while (null !== $a3a3deaca4efee87$var$wk);
    if (0 !== ($a3a3deaca4efee87$var$K & 6)) throw Error($a3a3deaca4efee87$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($a3a3deaca4efee87$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $a3a3deaca4efee87$var$Bc(a, f);
    a === $a3a3deaca4efee87$var$Q && ($a3a3deaca4efee87$var$Y = $a3a3deaca4efee87$var$Q = null, $a3a3deaca4efee87$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $a3a3deaca4efee87$var$vk || ($a3a3deaca4efee87$var$vk = !0, $a3a3deaca4efee87$var$Fk($a3a3deaca4efee87$var$hc, function() {
        $a3a3deaca4efee87$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $a3a3deaca4efee87$var$ok.transition;
        $a3a3deaca4efee87$var$ok.transition = null;
        var g = $a3a3deaca4efee87$var$C;
        $a3a3deaca4efee87$var$C = 1;
        var h = $a3a3deaca4efee87$var$K;
        $a3a3deaca4efee87$var$K |= 4;
        $a3a3deaca4efee87$var$nk.current = null;
        $a3a3deaca4efee87$var$Oj(a, c);
        $a3a3deaca4efee87$var$dk(c, a);
        $a3a3deaca4efee87$var$Oe($a3a3deaca4efee87$var$Df);
        $a3a3deaca4efee87$var$dd = !!$a3a3deaca4efee87$var$Cf;
        $a3a3deaca4efee87$var$Df = $a3a3deaca4efee87$var$Cf = null;
        a.current = c;
        $a3a3deaca4efee87$var$hk(c, a, e);
        $a3a3deaca4efee87$var$dc();
        $a3a3deaca4efee87$var$K = h;
        $a3a3deaca4efee87$var$C = g;
        $a3a3deaca4efee87$var$ok.transition = f;
    } else a.current = c;
    $a3a3deaca4efee87$var$vk && ($a3a3deaca4efee87$var$vk = !1, $a3a3deaca4efee87$var$wk = a, $a3a3deaca4efee87$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($a3a3deaca4efee87$var$Ri = null);
    $a3a3deaca4efee87$var$mc(c.stateNode, d);
    $a3a3deaca4efee87$var$Dk(a, $a3a3deaca4efee87$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($a3a3deaca4efee87$var$Oi) throw $a3a3deaca4efee87$var$Oi = !1, a = $a3a3deaca4efee87$var$Pi, $a3a3deaca4efee87$var$Pi = null, a;
    0 !== ($a3a3deaca4efee87$var$xk & 1) && 0 !== a.tag && $a3a3deaca4efee87$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $a3a3deaca4efee87$var$zk ? $a3a3deaca4efee87$var$yk++ : ($a3a3deaca4efee87$var$yk = 0, $a3a3deaca4efee87$var$zk = a) : $a3a3deaca4efee87$var$yk = 0;
    $a3a3deaca4efee87$var$jg();
    return null;
}
function $a3a3deaca4efee87$var$Hk() {
    if (null !== $a3a3deaca4efee87$var$wk) {
        var a = $a3a3deaca4efee87$var$Dc($a3a3deaca4efee87$var$xk), b = $a3a3deaca4efee87$var$ok.transition, c = $a3a3deaca4efee87$var$C;
        try {
            $a3a3deaca4efee87$var$ok.transition = null;
            $a3a3deaca4efee87$var$C = 16 > a ? 16 : a;
            if (null === $a3a3deaca4efee87$var$wk) var d = !1;
            else {
                a = $a3a3deaca4efee87$var$wk;
                $a3a3deaca4efee87$var$wk = null;
                $a3a3deaca4efee87$var$xk = 0;
                if (0 !== ($a3a3deaca4efee87$var$K & 6)) throw Error($a3a3deaca4efee87$var$p(331));
                var e = $a3a3deaca4efee87$var$K;
                $a3a3deaca4efee87$var$K |= 4;
                for($a3a3deaca4efee87$var$V = a.current; null !== $a3a3deaca4efee87$var$V;){
                    var f = $a3a3deaca4efee87$var$V, g = f.child;
                    if (0 !== ($a3a3deaca4efee87$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($a3a3deaca4efee87$var$V = l; null !== $a3a3deaca4efee87$var$V;){
                                    var m = $a3a3deaca4efee87$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $a3a3deaca4efee87$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $a3a3deaca4efee87$var$V = q;
                                    else for(; null !== $a3a3deaca4efee87$var$V;){
                                        m = $a3a3deaca4efee87$var$V;
                                        var r = m.sibling, y = m.return;
                                        $a3a3deaca4efee87$var$Sj(m);
                                        if (m === l) {
                                            $a3a3deaca4efee87$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $a3a3deaca4efee87$var$V = r;
                                            break;
                                        }
                                        $a3a3deaca4efee87$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $a3a3deaca4efee87$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $a3a3deaca4efee87$var$V = g;
                    else b: for(; null !== $a3a3deaca4efee87$var$V;){
                        f = $a3a3deaca4efee87$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $a3a3deaca4efee87$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $a3a3deaca4efee87$var$V = x;
                            break b;
                        }
                        $a3a3deaca4efee87$var$V = f.return;
                    }
                }
                var w = a.current;
                for($a3a3deaca4efee87$var$V = w; null !== $a3a3deaca4efee87$var$V;){
                    g = $a3a3deaca4efee87$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $a3a3deaca4efee87$var$V = u;
                    else b: for(g = w; null !== $a3a3deaca4efee87$var$V;){
                        h = $a3a3deaca4efee87$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $a3a3deaca4efee87$var$Qj(9, h);
                            }
                        } catch (na) {
                            $a3a3deaca4efee87$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $a3a3deaca4efee87$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $a3a3deaca4efee87$var$V = F;
                            break b;
                        }
                        $a3a3deaca4efee87$var$V = h.return;
                    }
                }
                $a3a3deaca4efee87$var$K = e;
                $a3a3deaca4efee87$var$jg();
                if ($a3a3deaca4efee87$var$lc && "function" === typeof $a3a3deaca4efee87$var$lc.onPostCommitFiberRoot) try {
                    $a3a3deaca4efee87$var$lc.onPostCommitFiberRoot($a3a3deaca4efee87$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $a3a3deaca4efee87$var$C = c, $a3a3deaca4efee87$var$ok.transition = b;
        }
    }
    return !1;
}
function $a3a3deaca4efee87$var$Xk(a, b, c) {
    b = $a3a3deaca4efee87$var$Ji(c, b);
    b = $a3a3deaca4efee87$var$Ni(a, b, 1);
    a = $a3a3deaca4efee87$var$nh(a, b, 1);
    b = $a3a3deaca4efee87$var$R();
    null !== a && ($a3a3deaca4efee87$var$Ac(a, 1, b), $a3a3deaca4efee87$var$Dk(a, b));
}
function $a3a3deaca4efee87$var$W(a, b, c) {
    if (3 === a.tag) $a3a3deaca4efee87$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $a3a3deaca4efee87$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $a3a3deaca4efee87$var$Ri || !$a3a3deaca4efee87$var$Ri.has(d))) {
                a = $a3a3deaca4efee87$var$Ji(c, a);
                a = $a3a3deaca4efee87$var$Qi(b, a, 1);
                b = $a3a3deaca4efee87$var$nh(b, a, 1);
                a = $a3a3deaca4efee87$var$R();
                null !== b && ($a3a3deaca4efee87$var$Ac(b, 1, a), $a3a3deaca4efee87$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $a3a3deaca4efee87$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $a3a3deaca4efee87$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $a3a3deaca4efee87$var$Q === a && ($a3a3deaca4efee87$var$Z & c) === c && (4 === $a3a3deaca4efee87$var$T || 3 === $a3a3deaca4efee87$var$T && ($a3a3deaca4efee87$var$Z & 130023424) === $a3a3deaca4efee87$var$Z && 500 > $a3a3deaca4efee87$var$B() - $a3a3deaca4efee87$var$fk ? $a3a3deaca4efee87$var$Kk(a, 0) : $a3a3deaca4efee87$var$rk |= c);
    $a3a3deaca4efee87$var$Dk(a, b);
}
function $a3a3deaca4efee87$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $a3a3deaca4efee87$var$sc, $a3a3deaca4efee87$var$sc <<= 1, 0 === ($a3a3deaca4efee87$var$sc & 130023424) && ($a3a3deaca4efee87$var$sc = 4194304)));
    var c = $a3a3deaca4efee87$var$R();
    a = $a3a3deaca4efee87$var$ih(a, b);
    null !== a && ($a3a3deaca4efee87$var$Ac(a, b, c), $a3a3deaca4efee87$var$Dk(a, c));
}
function $a3a3deaca4efee87$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $a3a3deaca4efee87$var$Yk(a, c);
}
function $a3a3deaca4efee87$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($a3a3deaca4efee87$var$p(314));
    }
    null !== d && d.delete(b);
    $a3a3deaca4efee87$var$Yk(a, c);
}
var $a3a3deaca4efee87$var$Vk;
$a3a3deaca4efee87$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $a3a3deaca4efee87$var$Wf.current) $a3a3deaca4efee87$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $a3a3deaca4efee87$var$dh = !1, $a3a3deaca4efee87$var$yj(a, b, c);
            $a3a3deaca4efee87$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $a3a3deaca4efee87$var$dh = !1, $a3a3deaca4efee87$var$I && 0 !== (b.flags & 1048576) && $a3a3deaca4efee87$var$ug(b, $a3a3deaca4efee87$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $a3a3deaca4efee87$var$ij(a, b);
            a = b.pendingProps;
            var e = $a3a3deaca4efee87$var$Yf(b, $a3a3deaca4efee87$var$H.current);
            $a3a3deaca4efee87$var$ch(b, c);
            e = $a3a3deaca4efee87$var$Nh(null, b, d, a, e, c);
            var f = $a3a3deaca4efee87$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $a3a3deaca4efee87$var$Zf(d) ? (f = !0, $a3a3deaca4efee87$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $a3a3deaca4efee87$var$kh(b), e.updater = $a3a3deaca4efee87$var$Ei, b.stateNode = e, e._reactInternals = b, $a3a3deaca4efee87$var$Ii(b, d, a, c), b = $a3a3deaca4efee87$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $a3a3deaca4efee87$var$I && f && $a3a3deaca4efee87$var$vg(b), $a3a3deaca4efee87$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $a3a3deaca4efee87$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $a3a3deaca4efee87$var$Zk(d);
                a = $a3a3deaca4efee87$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $a3a3deaca4efee87$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $a3a3deaca4efee87$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $a3a3deaca4efee87$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $a3a3deaca4efee87$var$$i(null, b, d, $a3a3deaca4efee87$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($a3a3deaca4efee87$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a3a3deaca4efee87$var$Ci(d, e), $a3a3deaca4efee87$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a3a3deaca4efee87$var$Ci(d, e), $a3a3deaca4efee87$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $a3a3deaca4efee87$var$kj(b);
                if (null === a) throw Error($a3a3deaca4efee87$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $a3a3deaca4efee87$var$lh(a, b);
                $a3a3deaca4efee87$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $a3a3deaca4efee87$var$Ji(Error($a3a3deaca4efee87$var$p(423)), b);
                        b = $a3a3deaca4efee87$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $a3a3deaca4efee87$var$Ji(Error($a3a3deaca4efee87$var$p(424)), b);
                        b = $a3a3deaca4efee87$var$lj(a, b, d, c, e);
                        break a;
                    } else for($a3a3deaca4efee87$var$yg = $a3a3deaca4efee87$var$Lf(b.stateNode.containerInfo.firstChild), $a3a3deaca4efee87$var$xg = b, $a3a3deaca4efee87$var$I = !0, $a3a3deaca4efee87$var$zg = null, c = $a3a3deaca4efee87$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $a3a3deaca4efee87$var$Ig();
                    if (d === e) {
                        b = $a3a3deaca4efee87$var$Zi(a, b, c);
                        break a;
                    }
                    $a3a3deaca4efee87$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $a3a3deaca4efee87$var$Ah(b), null === a && $a3a3deaca4efee87$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $a3a3deaca4efee87$var$Ef(d, e) ? g = null : null !== f && $a3a3deaca4efee87$var$Ef(d, f) && (b.flags |= 32), $a3a3deaca4efee87$var$gj(a, b), $a3a3deaca4efee87$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $a3a3deaca4efee87$var$Eg(b), null;
        case 13:
            return $a3a3deaca4efee87$var$oj(a, b, c);
        case 4:
            return $a3a3deaca4efee87$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $a3a3deaca4efee87$var$Ug(b, null, d, c) : $a3a3deaca4efee87$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a3a3deaca4efee87$var$Ci(d, e), $a3a3deaca4efee87$var$Yi(a, b, d, e, c);
        case 7:
            return $a3a3deaca4efee87$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $a3a3deaca4efee87$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $a3a3deaca4efee87$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $a3a3deaca4efee87$var$G($a3a3deaca4efee87$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($a3a3deaca4efee87$var$He(f.value, g)) {
                        if (f.children === e.children && !$a3a3deaca4efee87$var$Wf.current) {
                            b = $a3a3deaca4efee87$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $a3a3deaca4efee87$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $a3a3deaca4efee87$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($a3a3deaca4efee87$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $a3a3deaca4efee87$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $a3a3deaca4efee87$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $a3a3deaca4efee87$var$ch(b, c), e = $a3a3deaca4efee87$var$eh(e), d = d(e), b.flags |= 1, $a3a3deaca4efee87$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $a3a3deaca4efee87$var$Ci(d, b.pendingProps), e = $a3a3deaca4efee87$var$Ci(d.type, e), $a3a3deaca4efee87$var$$i(a, b, d, e, c);
        case 15:
            return $a3a3deaca4efee87$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a3a3deaca4efee87$var$Ci(d, e), $a3a3deaca4efee87$var$ij(a, b), b.tag = 1, $a3a3deaca4efee87$var$Zf(d) ? (a = !0, $a3a3deaca4efee87$var$cg(b)) : a = !1, $a3a3deaca4efee87$var$ch(b, c), $a3a3deaca4efee87$var$Gi(b, d, e), $a3a3deaca4efee87$var$Ii(b, d, e, c), $a3a3deaca4efee87$var$jj(null, b, d, !0, a, c);
        case 19:
            return $a3a3deaca4efee87$var$xj(a, b, c);
        case 22:
            return $a3a3deaca4efee87$var$dj(a, b, c);
    }
    throw Error($a3a3deaca4efee87$var$p(156, b.tag));
};
function $a3a3deaca4efee87$var$Fk(a, b) {
    return $a3a3deaca4efee87$var$ac(a, b);
}
function $a3a3deaca4efee87$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $a3a3deaca4efee87$var$Bg(a, b, c, d) {
    return new $a3a3deaca4efee87$var$$k(a, b, c, d);
}
function $a3a3deaca4efee87$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $a3a3deaca4efee87$var$Zk(a) {
    if ("function" === typeof a) return $a3a3deaca4efee87$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $a3a3deaca4efee87$var$Da) return 11;
        if (a === $a3a3deaca4efee87$var$Ga) return 14;
    }
    return 2;
}
function $a3a3deaca4efee87$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $a3a3deaca4efee87$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $a3a3deaca4efee87$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $a3a3deaca4efee87$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $a3a3deaca4efee87$var$ya:
            return $a3a3deaca4efee87$var$Tg(c.children, e, f, b);
        case $a3a3deaca4efee87$var$za:
            g = 8;
            e |= 8;
            break;
        case $a3a3deaca4efee87$var$Aa:
            return a = $a3a3deaca4efee87$var$Bg(12, c, b, e | 2), a.elementType = $a3a3deaca4efee87$var$Aa, a.lanes = f, a;
        case $a3a3deaca4efee87$var$Ea:
            return a = $a3a3deaca4efee87$var$Bg(13, c, b, e), a.elementType = $a3a3deaca4efee87$var$Ea, a.lanes = f, a;
        case $a3a3deaca4efee87$var$Fa:
            return a = $a3a3deaca4efee87$var$Bg(19, c, b, e), a.elementType = $a3a3deaca4efee87$var$Fa, a.lanes = f, a;
        case $a3a3deaca4efee87$var$Ia:
            return $a3a3deaca4efee87$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $a3a3deaca4efee87$var$Ba:
                    g = 10;
                    break a;
                case $a3a3deaca4efee87$var$Ca:
                    g = 9;
                    break a;
                case $a3a3deaca4efee87$var$Da:
                    g = 11;
                    break a;
                case $a3a3deaca4efee87$var$Ga:
                    g = 14;
                    break a;
                case $a3a3deaca4efee87$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($a3a3deaca4efee87$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $a3a3deaca4efee87$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $a3a3deaca4efee87$var$Tg(a, b, c, d) {
    a = $a3a3deaca4efee87$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $a3a3deaca4efee87$var$pj(a, b, c, d) {
    a = $a3a3deaca4efee87$var$Bg(22, a, d, b);
    a.elementType = $a3a3deaca4efee87$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $a3a3deaca4efee87$var$Qg(a, b, c) {
    a = $a3a3deaca4efee87$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $a3a3deaca4efee87$var$Sg(a, b, c) {
    b = $a3a3deaca4efee87$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $a3a3deaca4efee87$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $a3a3deaca4efee87$var$zc(0);
    this.expirationTimes = $a3a3deaca4efee87$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $a3a3deaca4efee87$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $a3a3deaca4efee87$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $a3a3deaca4efee87$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $a3a3deaca4efee87$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $a3a3deaca4efee87$var$kh(f);
    return a;
}
function $a3a3deaca4efee87$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a3a3deaca4efee87$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $a3a3deaca4efee87$var$dl(a) {
    if (!a) return $a3a3deaca4efee87$var$Vf;
    a = a._reactInternals;
    a: {
        if ($a3a3deaca4efee87$var$Vb(a) !== a || 1 !== a.tag) throw Error($a3a3deaca4efee87$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($a3a3deaca4efee87$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($a3a3deaca4efee87$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($a3a3deaca4efee87$var$Zf(c)) return $a3a3deaca4efee87$var$bg(a, c, b);
    }
    return b;
}
function $a3a3deaca4efee87$var$el(a, b, c, d, e, f, g, h, k) {
    a = $a3a3deaca4efee87$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $a3a3deaca4efee87$var$dl(null);
    c = a.current;
    d = $a3a3deaca4efee87$var$R();
    e = $a3a3deaca4efee87$var$yi(c);
    f = $a3a3deaca4efee87$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $a3a3deaca4efee87$var$nh(c, f, e);
    a.current.lanes = e;
    $a3a3deaca4efee87$var$Ac(a, e, d);
    $a3a3deaca4efee87$var$Dk(a, d);
    return a;
}
function $a3a3deaca4efee87$var$fl(a, b, c, d) {
    var e = b.current, f = $a3a3deaca4efee87$var$R(), g = $a3a3deaca4efee87$var$yi(e);
    c = $a3a3deaca4efee87$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $a3a3deaca4efee87$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $a3a3deaca4efee87$var$nh(e, b, g);
    null !== a && ($a3a3deaca4efee87$var$gi(a, e, g, f), $a3a3deaca4efee87$var$oh(a, e, g));
    return g;
}
function $a3a3deaca4efee87$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $a3a3deaca4efee87$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $a3a3deaca4efee87$var$il(a, b) {
    $a3a3deaca4efee87$var$hl(a, b);
    (a = a.alternate) && $a3a3deaca4efee87$var$hl(a, b);
}
function $a3a3deaca4efee87$var$jl() {
    return null;
}
var $a3a3deaca4efee87$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $a3a3deaca4efee87$var$ll(a) {
    this._internalRoot = a;
}
$a3a3deaca4efee87$var$ml.prototype.render = $a3a3deaca4efee87$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($a3a3deaca4efee87$var$p(409));
    $a3a3deaca4efee87$var$fl(a, b, null, null);
};
$a3a3deaca4efee87$var$ml.prototype.unmount = $a3a3deaca4efee87$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $a3a3deaca4efee87$var$Rk(function() {
            $a3a3deaca4efee87$var$fl(null, a, null, null);
        });
        b[$a3a3deaca4efee87$var$uf] = null;
    }
};
function $a3a3deaca4efee87$var$ml(a) {
    this._internalRoot = a;
}
$a3a3deaca4efee87$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $a3a3deaca4efee87$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $a3a3deaca4efee87$var$Qc.length && 0 !== b && b < $a3a3deaca4efee87$var$Qc[c].priority; c++);
        $a3a3deaca4efee87$var$Qc.splice(c, 0, a);
        0 === c && $a3a3deaca4efee87$var$Vc(a);
    }
};
function $a3a3deaca4efee87$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $a3a3deaca4efee87$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $a3a3deaca4efee87$var$pl() {}
function $a3a3deaca4efee87$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $a3a3deaca4efee87$var$gl(g);
                f.call(a);
            };
        }
        var g = $a3a3deaca4efee87$var$el(b, d, a, 0, null, !1, !1, "", $a3a3deaca4efee87$var$pl);
        a._reactRootContainer = g;
        a[$a3a3deaca4efee87$var$uf] = g.current;
        $a3a3deaca4efee87$var$sf(8 === a.nodeType ? a.parentNode : a);
        $a3a3deaca4efee87$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $a3a3deaca4efee87$var$gl(k);
            h.call(a);
        };
    }
    var k = $a3a3deaca4efee87$var$bl(a, 0, !1, null, null, !1, !1, "", $a3a3deaca4efee87$var$pl);
    a._reactRootContainer = k;
    a[$a3a3deaca4efee87$var$uf] = k.current;
    $a3a3deaca4efee87$var$sf(8 === a.nodeType ? a.parentNode : a);
    $a3a3deaca4efee87$var$Rk(function() {
        $a3a3deaca4efee87$var$fl(b, k, c, d);
    });
    return k;
}
function $a3a3deaca4efee87$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $a3a3deaca4efee87$var$gl(g);
                h.call(a);
            };
        }
        $a3a3deaca4efee87$var$fl(b, g, a, e);
    } else g = $a3a3deaca4efee87$var$ql(c, b, a, e, d);
    return $a3a3deaca4efee87$var$gl(g);
}
$a3a3deaca4efee87$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $a3a3deaca4efee87$var$tc(b.pendingLanes);
                0 !== c && ($a3a3deaca4efee87$var$Cc(b, c | 1), $a3a3deaca4efee87$var$Dk(b, $a3a3deaca4efee87$var$B()), 0 === ($a3a3deaca4efee87$var$K & 6) && ($a3a3deaca4efee87$var$Gj = $a3a3deaca4efee87$var$B() + 500, $a3a3deaca4efee87$var$jg()));
            }
            break;
        case 13:
            $a3a3deaca4efee87$var$Rk(function() {
                var b = $a3a3deaca4efee87$var$ih(a, 1);
                if (null !== b) {
                    var c = $a3a3deaca4efee87$var$R();
                    $a3a3deaca4efee87$var$gi(b, a, 1, c);
                }
            }), $a3a3deaca4efee87$var$il(a, 1);
    }
};
$a3a3deaca4efee87$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $a3a3deaca4efee87$var$ih(a, 134217728);
        if (null !== b) {
            var c = $a3a3deaca4efee87$var$R();
            $a3a3deaca4efee87$var$gi(b, a, 134217728, c);
        }
        $a3a3deaca4efee87$var$il(a, 134217728);
    }
};
$a3a3deaca4efee87$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $a3a3deaca4efee87$var$yi(a), c = $a3a3deaca4efee87$var$ih(a, b);
        if (null !== c) {
            var d = $a3a3deaca4efee87$var$R();
            $a3a3deaca4efee87$var$gi(c, a, b, d);
        }
        $a3a3deaca4efee87$var$il(a, b);
    }
};
$a3a3deaca4efee87$var$Hc = function() {
    return $a3a3deaca4efee87$var$C;
};
$a3a3deaca4efee87$var$Ic = function(a, b) {
    var c = $a3a3deaca4efee87$var$C;
    try {
        return $a3a3deaca4efee87$var$C = a, b();
    } finally{
        $a3a3deaca4efee87$var$C = c;
    }
};
$a3a3deaca4efee87$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $a3a3deaca4efee87$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $a3a3deaca4efee87$var$Db(d);
                        if (!e) throw Error($a3a3deaca4efee87$var$p(90));
                        $a3a3deaca4efee87$var$Wa(d);
                        $a3a3deaca4efee87$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $a3a3deaca4efee87$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $a3a3deaca4efee87$var$fb(a, !!c.multiple, b, !1);
    }
};
$a3a3deaca4efee87$var$Gb = $a3a3deaca4efee87$var$Qk;
$a3a3deaca4efee87$var$Hb = $a3a3deaca4efee87$var$Rk;
var $a3a3deaca4efee87$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $a3a3deaca4efee87$var$Cb,
        $a3a3deaca4efee87$var$ue,
        $a3a3deaca4efee87$var$Db,
        $a3a3deaca4efee87$var$Eb,
        $a3a3deaca4efee87$var$Fb,
        $a3a3deaca4efee87$var$Qk
    ]
}, $a3a3deaca4efee87$var$tl = {
    findFiberByHostInstance: $a3a3deaca4efee87$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $a3a3deaca4efee87$var$ul = {
    bundleType: $a3a3deaca4efee87$var$tl.bundleType,
    version: $a3a3deaca4efee87$var$tl.version,
    rendererPackageName: $a3a3deaca4efee87$var$tl.rendererPackageName,
    rendererConfig: $a3a3deaca4efee87$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $a3a3deaca4efee87$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $a3a3deaca4efee87$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $a3a3deaca4efee87$var$tl.findFiberByHostInstance || $a3a3deaca4efee87$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $a3a3deaca4efee87$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$a3a3deaca4efee87$var$vl.isDisabled && $a3a3deaca4efee87$var$vl.supportsFiber) try {
        $a3a3deaca4efee87$var$kc = $a3a3deaca4efee87$var$vl.inject($a3a3deaca4efee87$var$ul), $a3a3deaca4efee87$var$lc = $a3a3deaca4efee87$var$vl;
    } catch (a) {}
}
$a3a3deaca4efee87$export$ae55be85d98224ed = $a3a3deaca4efee87$var$sl;
$a3a3deaca4efee87$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$a3a3deaca4efee87$var$nl(b)) throw Error($a3a3deaca4efee87$var$p(200));
    return $a3a3deaca4efee87$var$cl(a, b, null, c);
};
$a3a3deaca4efee87$export$882461b6382ed46c = function(a, b) {
    if (!$a3a3deaca4efee87$var$nl(a)) throw Error($a3a3deaca4efee87$var$p(299));
    var c = !1, d = "", e = $a3a3deaca4efee87$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $a3a3deaca4efee87$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$a3a3deaca4efee87$var$uf] = b.current;
    $a3a3deaca4efee87$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $a3a3deaca4efee87$var$ll(b);
};
$a3a3deaca4efee87$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($a3a3deaca4efee87$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($a3a3deaca4efee87$var$p(268, a));
    }
    a = $a3a3deaca4efee87$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$a3a3deaca4efee87$export$cd75ccfd720a3cd4 = function(a) {
    return $a3a3deaca4efee87$var$Rk(a);
};
$a3a3deaca4efee87$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$a3a3deaca4efee87$var$ol(b)) throw Error($a3a3deaca4efee87$var$p(200));
    return $a3a3deaca4efee87$var$rl(null, a, b, !0, c);
};
$a3a3deaca4efee87$export$757ceba2d55c277e = function(a, b, c) {
    if (!$a3a3deaca4efee87$var$nl(a)) throw Error($a3a3deaca4efee87$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $a3a3deaca4efee87$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $a3a3deaca4efee87$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$a3a3deaca4efee87$var$uf] = b.current;
    $a3a3deaca4efee87$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $a3a3deaca4efee87$var$ml(b);
};
$a3a3deaca4efee87$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$a3a3deaca4efee87$var$ol(b)) throw Error($a3a3deaca4efee87$var$p(200));
    return $a3a3deaca4efee87$var$rl(null, a, b, !1, c);
};
$a3a3deaca4efee87$export$502457920280e6be = function(a) {
    if (!$a3a3deaca4efee87$var$ol(a)) throw Error($a3a3deaca4efee87$var$p(40));
    return a._reactRootContainer ? ($a3a3deaca4efee87$var$Rk(function() {
        $a3a3deaca4efee87$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$a3a3deaca4efee87$var$uf] = null;
        });
    }), !0) : !1;
};
$a3a3deaca4efee87$export$c78a37762a8d58e1 = $a3a3deaca4efee87$var$Qk;
$a3a3deaca4efee87$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$a3a3deaca4efee87$var$ol(c)) throw Error($a3a3deaca4efee87$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($a3a3deaca4efee87$var$p(38));
    return $a3a3deaca4efee87$var$rl(a, b, c, !1, d);
};
$a3a3deaca4efee87$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("82Omh", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jWNL2"));

});
parcelRegister("jWNL2", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $e85a07f21c9bd177$export$c4744153514ff05d; }, function (v) { return $e85a07f21c9bd177$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $e85a07f21c9bd177$export$3e506c1ccc9cc1a7; }, function (v) { return $e85a07f21c9bd177$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $e85a07f21c9bd177$export$e26fe2ed2fa76875; }, function (v) { return $e85a07f21c9bd177$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $e85a07f21c9bd177$export$502329bbf4b505b1; }, function (v) { return $e85a07f21c9bd177$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $e85a07f21c9bd177$export$6e3807111c4874c4; }, function (v) { return $e85a07f21c9bd177$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $e85a07f21c9bd177$export$c27134553091fb3a; }, function (v) { return $e85a07f21c9bd177$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $e85a07f21c9bd177$export$33ee1acdc04fd2a2; }, function (v) { return $e85a07f21c9bd177$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $e85a07f21c9bd177$export$b00a404bbd5edef2; }, function (v) { return $e85a07f21c9bd177$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $e85a07f21c9bd177$export$8352ce38b91d0c62; }, function (v) { return $e85a07f21c9bd177$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $e85a07f21c9bd177$export$d66a1c1c77bd778b; }, function (v) { return $e85a07f21c9bd177$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $e85a07f21c9bd177$export$d3dfb8e4810cb555; }, function (v) { return $e85a07f21c9bd177$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $e85a07f21c9bd177$export$839f9183b0465a69; }, function (v) { return $e85a07f21c9bd177$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $e85a07f21c9bd177$export$72fdf0e06517287b; }, function (v) { return $e85a07f21c9bd177$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $e85a07f21c9bd177$export$4b844e58a3e414b4; }, function (v) { return $e85a07f21c9bd177$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $e85a07f21c9bd177$export$816d2913ae6b83b1; }, function (v) { return $e85a07f21c9bd177$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $e85a07f21c9bd177$export$61bcfe829111a1d0; }, function (v) { return $e85a07f21c9bd177$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $e85a07f21c9bd177$export$7ee8c9beb337bc3f; }, function (v) { return $e85a07f21c9bd177$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $e85a07f21c9bd177$export$b5836b71941fa3ed; }, function (v) { return $e85a07f21c9bd177$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $e85a07f21c9bd177$export$cf845f2c119da08a; }, function (v) { return $e85a07f21c9bd177$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e85a07f21c9bd177$export$c4744153514ff05d;
var $e85a07f21c9bd177$export$3e506c1ccc9cc1a7;
var $e85a07f21c9bd177$export$e26fe2ed2fa76875;
var $e85a07f21c9bd177$export$502329bbf4b505b1;
var $e85a07f21c9bd177$export$6e3807111c4874c4;
var $e85a07f21c9bd177$export$c27134553091fb3a;
var $e85a07f21c9bd177$export$33ee1acdc04fd2a2;
var $e85a07f21c9bd177$export$b00a404bbd5edef2;
var $e85a07f21c9bd177$export$8352ce38b91d0c62;
var $e85a07f21c9bd177$export$d66a1c1c77bd778b;
var $e85a07f21c9bd177$export$d3dfb8e4810cb555;
var $e85a07f21c9bd177$export$839f9183b0465a69;
var $e85a07f21c9bd177$export$72fdf0e06517287b;
var $e85a07f21c9bd177$export$4b844e58a3e414b4;
var $e85a07f21c9bd177$export$816d2913ae6b83b1;
var $e85a07f21c9bd177$export$61bcfe829111a1d0;
var $e85a07f21c9bd177$export$7ee8c9beb337bc3f;
var $e85a07f21c9bd177$export$b5836b71941fa3ed;
var $e85a07f21c9bd177$export$cf845f2c119da08a;
"use strict";
function $e85a07f21c9bd177$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $e85a07f21c9bd177$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $e85a07f21c9bd177$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $e85a07f21c9bd177$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $e85a07f21c9bd177$var$g(C, c)) n < e && 0 > $e85a07f21c9bd177$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $e85a07f21c9bd177$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $e85a07f21c9bd177$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $e85a07f21c9bd177$var$l = performance;
    $e85a07f21c9bd177$export$c4744153514ff05d = function() {
        return $e85a07f21c9bd177$var$l.now();
    };
} else {
    var $e85a07f21c9bd177$var$p = Date, $e85a07f21c9bd177$var$q = $e85a07f21c9bd177$var$p.now();
    $e85a07f21c9bd177$export$c4744153514ff05d = function() {
        return $e85a07f21c9bd177$var$p.now() - $e85a07f21c9bd177$var$q;
    };
}
var $e85a07f21c9bd177$var$r = [], $e85a07f21c9bd177$var$t = [], $e85a07f21c9bd177$var$u = 1, $e85a07f21c9bd177$var$v = null, $e85a07f21c9bd177$var$y = 3, $e85a07f21c9bd177$var$z = !1, $e85a07f21c9bd177$var$A = !1, $e85a07f21c9bd177$var$B = !1, $e85a07f21c9bd177$var$D = "function" === typeof setTimeout ? setTimeout : null, $e85a07f21c9bd177$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $e85a07f21c9bd177$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $e85a07f21c9bd177$var$G(a) {
    for(var b = $e85a07f21c9bd177$var$h($e85a07f21c9bd177$var$t); null !== b;){
        if (null === b.callback) $e85a07f21c9bd177$var$k($e85a07f21c9bd177$var$t);
        else if (b.startTime <= a) $e85a07f21c9bd177$var$k($e85a07f21c9bd177$var$t), b.sortIndex = b.expirationTime, $e85a07f21c9bd177$var$f($e85a07f21c9bd177$var$r, b);
        else break;
        b = $e85a07f21c9bd177$var$h($e85a07f21c9bd177$var$t);
    }
}
function $e85a07f21c9bd177$var$H(a) {
    $e85a07f21c9bd177$var$B = !1;
    $e85a07f21c9bd177$var$G(a);
    if (!$e85a07f21c9bd177$var$A) {
        if (null !== $e85a07f21c9bd177$var$h($e85a07f21c9bd177$var$r)) $e85a07f21c9bd177$var$A = !0, $e85a07f21c9bd177$var$I($e85a07f21c9bd177$var$J);
        else {
            var b = $e85a07f21c9bd177$var$h($e85a07f21c9bd177$var$t);
            null !== b && $e85a07f21c9bd177$var$K($e85a07f21c9bd177$var$H, b.startTime - a);
        }
    }
}
function $e85a07f21c9bd177$var$J(a, b) {
    $e85a07f21c9bd177$var$A = !1;
    $e85a07f21c9bd177$var$B && ($e85a07f21c9bd177$var$B = !1, $e85a07f21c9bd177$var$E($e85a07f21c9bd177$var$L), $e85a07f21c9bd177$var$L = -1);
    $e85a07f21c9bd177$var$z = !0;
    var c = $e85a07f21c9bd177$var$y;
    try {
        $e85a07f21c9bd177$var$G(b);
        for($e85a07f21c9bd177$var$v = $e85a07f21c9bd177$var$h($e85a07f21c9bd177$var$r); null !== $e85a07f21c9bd177$var$v && (!($e85a07f21c9bd177$var$v.expirationTime > b) || a && !$e85a07f21c9bd177$var$M());){
            var d = $e85a07f21c9bd177$var$v.callback;
            if ("function" === typeof d) {
                $e85a07f21c9bd177$var$v.callback = null;
                $e85a07f21c9bd177$var$y = $e85a07f21c9bd177$var$v.priorityLevel;
                var e = d($e85a07f21c9bd177$var$v.expirationTime <= b);
                b = $e85a07f21c9bd177$export$c4744153514ff05d();
                "function" === typeof e ? $e85a07f21c9bd177$var$v.callback = e : $e85a07f21c9bd177$var$v === $e85a07f21c9bd177$var$h($e85a07f21c9bd177$var$r) && $e85a07f21c9bd177$var$k($e85a07f21c9bd177$var$r);
                $e85a07f21c9bd177$var$G(b);
            } else $e85a07f21c9bd177$var$k($e85a07f21c9bd177$var$r);
            $e85a07f21c9bd177$var$v = $e85a07f21c9bd177$var$h($e85a07f21c9bd177$var$r);
        }
        if (null !== $e85a07f21c9bd177$var$v) var w = !0;
        else {
            var m = $e85a07f21c9bd177$var$h($e85a07f21c9bd177$var$t);
            null !== m && $e85a07f21c9bd177$var$K($e85a07f21c9bd177$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $e85a07f21c9bd177$var$v = null, $e85a07f21c9bd177$var$y = c, $e85a07f21c9bd177$var$z = !1;
    }
}
var $e85a07f21c9bd177$var$N = !1, $e85a07f21c9bd177$var$O = null, $e85a07f21c9bd177$var$L = -1, $e85a07f21c9bd177$var$P = 5, $e85a07f21c9bd177$var$Q = -1;
function $e85a07f21c9bd177$var$M() {
    return $e85a07f21c9bd177$export$c4744153514ff05d() - $e85a07f21c9bd177$var$Q < $e85a07f21c9bd177$var$P ? !1 : !0;
}
function $e85a07f21c9bd177$var$R() {
    if (null !== $e85a07f21c9bd177$var$O) {
        var a = $e85a07f21c9bd177$export$c4744153514ff05d();
        $e85a07f21c9bd177$var$Q = a;
        var b = !0;
        try {
            b = $e85a07f21c9bd177$var$O(!0, a);
        } finally{
            b ? $e85a07f21c9bd177$var$S() : ($e85a07f21c9bd177$var$N = !1, $e85a07f21c9bd177$var$O = null);
        }
    } else $e85a07f21c9bd177$var$N = !1;
}
var $e85a07f21c9bd177$var$S;
if ("function" === typeof $e85a07f21c9bd177$var$F) $e85a07f21c9bd177$var$S = function() {
    $e85a07f21c9bd177$var$F($e85a07f21c9bd177$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $e85a07f21c9bd177$var$T = new MessageChannel, $e85a07f21c9bd177$var$U = $e85a07f21c9bd177$var$T.port2;
    $e85a07f21c9bd177$var$T.port1.onmessage = $e85a07f21c9bd177$var$R;
    $e85a07f21c9bd177$var$S = function() {
        $e85a07f21c9bd177$var$U.postMessage(null);
    };
} else $e85a07f21c9bd177$var$S = function() {
    $e85a07f21c9bd177$var$D($e85a07f21c9bd177$var$R, 0);
};
function $e85a07f21c9bd177$var$I(a) {
    $e85a07f21c9bd177$var$O = a;
    $e85a07f21c9bd177$var$N || ($e85a07f21c9bd177$var$N = !0, $e85a07f21c9bd177$var$S());
}
function $e85a07f21c9bd177$var$K(a, b) {
    $e85a07f21c9bd177$var$L = $e85a07f21c9bd177$var$D(function() {
        a($e85a07f21c9bd177$export$c4744153514ff05d());
    }, b);
}
$e85a07f21c9bd177$export$3e506c1ccc9cc1a7 = 5;
$e85a07f21c9bd177$export$e26fe2ed2fa76875 = 1;
$e85a07f21c9bd177$export$502329bbf4b505b1 = 4;
$e85a07f21c9bd177$export$6e3807111c4874c4 = 3;
$e85a07f21c9bd177$export$c27134553091fb3a = null;
$e85a07f21c9bd177$export$33ee1acdc04fd2a2 = 2;
$e85a07f21c9bd177$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$e85a07f21c9bd177$export$8352ce38b91d0c62 = function() {
    $e85a07f21c9bd177$var$A || $e85a07f21c9bd177$var$z || ($e85a07f21c9bd177$var$A = !0, $e85a07f21c9bd177$var$I($e85a07f21c9bd177$var$J));
};
$e85a07f21c9bd177$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $e85a07f21c9bd177$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$e85a07f21c9bd177$export$d3dfb8e4810cb555 = function() {
    return $e85a07f21c9bd177$var$y;
};
$e85a07f21c9bd177$export$839f9183b0465a69 = function() {
    return $e85a07f21c9bd177$var$h($e85a07f21c9bd177$var$r);
};
$e85a07f21c9bd177$export$72fdf0e06517287b = function(a) {
    switch($e85a07f21c9bd177$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $e85a07f21c9bd177$var$y;
    }
    var c = $e85a07f21c9bd177$var$y;
    $e85a07f21c9bd177$var$y = b;
    try {
        return a();
    } finally{
        $e85a07f21c9bd177$var$y = c;
    }
};
$e85a07f21c9bd177$export$4b844e58a3e414b4 = function() {};
$e85a07f21c9bd177$export$816d2913ae6b83b1 = function() {};
$e85a07f21c9bd177$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $e85a07f21c9bd177$var$y;
    $e85a07f21c9bd177$var$y = a;
    try {
        return b();
    } finally{
        $e85a07f21c9bd177$var$y = c;
    }
};
$e85a07f21c9bd177$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $e85a07f21c9bd177$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $e85a07f21c9bd177$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $e85a07f21c9bd177$var$f($e85a07f21c9bd177$var$t, a), null === $e85a07f21c9bd177$var$h($e85a07f21c9bd177$var$r) && a === $e85a07f21c9bd177$var$h($e85a07f21c9bd177$var$t) && ($e85a07f21c9bd177$var$B ? ($e85a07f21c9bd177$var$E($e85a07f21c9bd177$var$L), $e85a07f21c9bd177$var$L = -1) : $e85a07f21c9bd177$var$B = !0, $e85a07f21c9bd177$var$K($e85a07f21c9bd177$var$H, c - d))) : (a.sortIndex = e, $e85a07f21c9bd177$var$f($e85a07f21c9bd177$var$r, a), $e85a07f21c9bd177$var$A || $e85a07f21c9bd177$var$z || ($e85a07f21c9bd177$var$A = !0, $e85a07f21c9bd177$var$I($e85a07f21c9bd177$var$J)));
    return a;
};
$e85a07f21c9bd177$export$b5836b71941fa3ed = $e85a07f21c9bd177$var$M;
$e85a07f21c9bd177$export$cf845f2c119da08a = function(a) {
    var b = $e85a07f21c9bd177$var$y;
    return function() {
        var c = $e85a07f21c9bd177$var$y;
        $e85a07f21c9bd177$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $e85a07f21c9bd177$var$y = c;
        }
    };
};

});



var $9677d902f5c96280$exports = {};
"use strict";

$9677d902f5c96280$exports = (parcelRequire("9EfTK"));



var $1wHBI = parcelRequire("1wHBI");
var $988ab8cd0f14a6fc$exports = {};

$parcel$export($988ab8cd0f14a6fc$exports, "createRoot", function () { return $988ab8cd0f14a6fc$export$882461b6382ed46c; }, function (v) { return $988ab8cd0f14a6fc$export$882461b6382ed46c = v; });
$parcel$export($988ab8cd0f14a6fc$exports, "hydrateRoot", function () { return $988ab8cd0f14a6fc$export$757ceba2d55c277e; }, function (v) { return $988ab8cd0f14a6fc$export$757ceba2d55c277e = v; });
var $988ab8cd0f14a6fc$export$882461b6382ed46c;
var $988ab8cd0f14a6fc$export$757ceba2d55c277e;
"use strict";
var $8e64671e67d42b90$exports = {};
"use strict";
function $8e64671e67d42b90$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($8e64671e67d42b90$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$8e64671e67d42b90$var$checkDCE();

$8e64671e67d42b90$exports = (parcelRequire("e33fO"));


var $988ab8cd0f14a6fc$var$i;
$988ab8cd0f14a6fc$export$882461b6382ed46c = $8e64671e67d42b90$exports.createRoot;
$988ab8cd0f14a6fc$export$757ceba2d55c277e = $8e64671e67d42b90$exports.hydrateRoot;



/* eslint-disable react/no-unescaped-entities */ 
var $77458c27d140f8c4$export$38e42c68cf43b5d4;
var $77458c27d140f8c4$export$db3c28d99448dcff;
$77458c27d140f8c4$export$38e42c68cf43b5d4 = `gPMrEW_header`;
$77458c27d140f8c4$export$db3c28d99448dcff = `gPMrEW_logo`;



var $1wHBI = parcelRequire("1wHBI");
async function $473c30c918a6f195$var$call(endpoint, data, signal) {
    return await fetch(endpoint, {
        method: "POST",
        cache: "no-cache",
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify(data),
        signal: signal
    });
}
async function $473c30c918a6f195$export$8f24540c37096eb6(room, version, signal) {
    const resp = await $473c30c918a6f195$var$call("/list", {
        room: room,
        version: version
    }, signal);
    switch(resp.status){
        case 200:
            return await resp.json();
        case 204:
            return {
                timeout: true
            };
        case 404:
            return null;
        default:
            throw new Error(`/list returned unexpected status code ${resp.status}`);
    }
}
async function $473c30c918a6f195$export$254d8d9a9e824f11(room, version, data, signal) {
    return await (await $473c30c918a6f195$var$call("/commit", {
        room: room,
        version: version,
        data: data
    }, signal)).json();
}
async function $473c30c918a6f195$export$5ad94f5fb1ec657b(data, signal) {
    return await (await $473c30c918a6f195$var$call("/make_room", {
        data: data
    }, signal)).json();
}


var $0651f0d0ba30c08f$export$7cd7a93136e7148a;
(function(GameMode) {
    GameMode["TEXAS_HOLDEM"] = "texas_holdem";
    GameMode["OMAHA"] = "omaha";
})($0651f0d0ba30c08f$export$7cd7a93136e7148a || ($0651f0d0ba30c08f$export$7cd7a93136e7148a = {}));
var $0651f0d0ba30c08f$export$1179af6d199a01fa;
(function(RoomPhase) {
    RoomPhase["SETUP"] = "setup";
    RoomPhase["BIDDING"] = "bidding";
    RoomPhase["SCORING"] = "scoring";
})($0651f0d0ba30c08f$export$1179af6d199a01fa || ($0651f0d0ba30c08f$export$1179af6d199a01fa = {}));
const $0651f0d0ba30c08f$export$a0bea9b09a67f3da = {
    phase: "setup",
    players: [],
    config: {
        gameMode: "texas_holdem",
        withJokers: false,
        targetWins: 3,
        targetLosses: 3
    }
};




var $1wHBI = parcelRequire("1wHBI");
function $6c182388e9a195e9$export$1391212d75b2ee65(duration) {
    return new Promise((resolve)=>setTimeout(resolve, duration));
}
function $6c182388e9a195e9$export$bffa455ba8c619a6(list) {
    return [].concat(...list);
}
function $6c182388e9a195e9$export$448332262467e042(list) {
    const array = Array.from(list);
    for(let i = 1; i < array.length; i++){
        const j = Math.floor(Math.random() * (i + 1));
        if (i !== j) {
            const val = array[i];
            array[i] = array[j];
            array[j] = val;
        }
    }
    return array;
}
function $6c182388e9a195e9$export$9cb4719e2e525b7a(x, y) {
    if (x === y) return true;
    if (x == null || y == null) return false;
    if (typeof x == "object" && typeof y == "object") {
        if (Array.isArray(x) && Array.isArray(y)) {
            if (x.length !== y.length) return false;
            for(let i = 0; i < x.length; i++){
                if (!$6c182388e9a195e9$export$9cb4719e2e525b7a(x[i], y[i])) return false;
            }
            return true;
        } else if (!Array.isArray(x) && !Array.isArray(y)) {
            const xk = Object.keys(x);
            const yk = Object.keys(y);
            if (xk.length !== yk.length) return false;
            for (const key of xk){
                if (!Object.prototype.hasOwnProperty.call(y, key)) return false;
                if (!$6c182388e9a195e9$export$9cb4719e2e525b7a(x[key], y[key])) return false;
            }
            return true;
        }
    }
    return false;
}
function $6c182388e9a195e9$export$c9123f98506f8b3e(xs, index, f) {
    return xs.map((item, i)=>i === index ? f(item) : item);
}



const $1bfe83860855b64a$var$Operation = {
    Remove: "remove",
    Replace: "replace",
    Add: "add"
};
// Don't use `Symbol()` just for 3rd party access the draft
const $1bfe83860855b64a$var$PROXY_DRAFT = Symbol.for("__MUTATIVE_PROXY_DRAFT__");
const $1bfe83860855b64a$var$RAW_RETURN_SYMBOL = Symbol("__MUTATIVE_RAW_RETURN_SYMBOL__");
const $1bfe83860855b64a$var$iteratorSymbol = Symbol.iterator;
const $1bfe83860855b64a$var$dataTypes = {
    mutable: "mutable",
    immutable: "immutable"
};
const $1bfe83860855b64a$var$internal = {};
function $1bfe83860855b64a$var$latest(proxyDraft) {
    var _a;
    return (_a = proxyDraft.copy) !== null && _a !== void 0 ? _a : proxyDraft.original;
}
/**
 * Check if the value is a draft
 */ function $1bfe83860855b64a$export$541ac630993a4c84(target) {
    return !!$1bfe83860855b64a$var$getProxyDraft(target);
}
function $1bfe83860855b64a$var$getProxyDraft(value) {
    if (typeof value !== "object") return null;
    return value === null || value === void 0 ? void 0 : value[$1bfe83860855b64a$var$PROXY_DRAFT];
}
function $1bfe83860855b64a$var$getValue(value) {
    var _a;
    const proxyDraft = $1bfe83860855b64a$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy) !== null && _a !== void 0 ? _a : proxyDraft.original : value;
}
/**
 * Check if a value is draftable
 */ function $1bfe83860855b64a$export$16e3aed3edb85946(value, options) {
    if (!value || typeof value !== "object") return false;
    let markResult;
    return Object.getPrototypeOf(value) === Object.prototype || Array.isArray(value) || value instanceof Map || value instanceof Set || !!(options === null || options === void 0 ? void 0 : options.mark) && ((markResult = options.mark(value, $1bfe83860855b64a$var$dataTypes)) === $1bfe83860855b64a$var$dataTypes.immutable || typeof markResult === "function");
}
function $1bfe83860855b64a$var$getPath(target, path = []) {
    if (Object.hasOwnProperty.call(target, "key")) {
        // check if the parent is a draft and the original value is not equal to the current value
        const proxyDraft = $1bfe83860855b64a$var$getProxyDraft($1bfe83860855b64a$var$get(target.parent.copy, target.key));
        if (proxyDraft !== null && (proxyDraft === null || proxyDraft === void 0 ? void 0 : proxyDraft.original) !== target.original) return null;
        path.push(target.parent.type === 3 /* DraftType.Set */  ? Array.from(target.parent.setMap.keys()).indexOf(target.key) : target.key);
    }
    if (target.parent) return $1bfe83860855b64a$var$getPath(target.parent, path);
    // `target` is root draft.
    path.reverse();
    try {
        // check if the path is valid
        $1bfe83860855b64a$var$resolvePath(target.copy, path);
    } catch (e) {
        return null;
    }
    return path;
}
function $1bfe83860855b64a$var$getType(target) {
    if (Array.isArray(target)) return 1 /* DraftType.Array */ ;
    if (target instanceof Map) return 2 /* DraftType.Map */ ;
    if (target instanceof Set) return 3 /* DraftType.Set */ ;
    return 0 /* DraftType.Object */ ;
}
function $1bfe83860855b64a$var$get(target, key) {
    return $1bfe83860855b64a$var$getType(target) === 2 /* DraftType.Map */  ? target.get(key) : target[key];
}
function $1bfe83860855b64a$var$set(target, key, value) {
    const type = $1bfe83860855b64a$var$getType(target);
    if (type === 2 /* DraftType.Map */ ) target.set(key, value);
    else target[key] = value;
}
function $1bfe83860855b64a$var$peek(target, key) {
    const state = $1bfe83860855b64a$var$getProxyDraft(target);
    const source = state ? $1bfe83860855b64a$var$latest(state) : target;
    return source[key];
}
function $1bfe83860855b64a$var$isEqual(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $1bfe83860855b64a$var$revokeProxy(proxyDraft) {
    if (!proxyDraft) return;
    while(proxyDraft.finalities.revoke.length > 0){
        const revoke = proxyDraft.finalities.revoke.pop();
        revoke();
    }
}
// handle JSON Pointer path with spec https://www.rfc-editor.org/rfc/rfc6901
function $1bfe83860855b64a$var$escapePath(path, pathAsArray) {
    return pathAsArray ? path : [
        ""
    ].concat(path).map((_item)=>{
        const item = `${_item}`;
        if (item.indexOf("/") === -1 && item.indexOf("~") === -1) return item;
        return item.replace(/~/g, "~0").replace(/\//g, "~1");
    }).join("/");
}
function $1bfe83860855b64a$var$unescapePath(path) {
    if (Array.isArray(path)) return path;
    return path.split("/").map((_item)=>_item.replace(/~1/g, "/").replace(/~0/g, "~")).slice(1);
}
function $1bfe83860855b64a$var$resolvePath(base, path) {
    for(let index = 0; index < path.length - 1; index += 1){
        const key = path[index];
        // use `index` in Set draft
        base = $1bfe83860855b64a$var$get($1bfe83860855b64a$var$getType(base) === 3 /* DraftType.Set */  ? Array.from(base) : base, key);
        if (typeof base !== "object") throw new Error(`Cannot resolve patch at '${path.join("/")}'.`);
    }
    return base;
}
function $1bfe83860855b64a$var$strictCopy(target) {
    const copy = Object.create(Object.getPrototypeOf(target));
    Reflect.ownKeys(target).forEach((key)=>{
        let desc = Reflect.getOwnPropertyDescriptor(target, key);
        if (desc.enumerable && desc.configurable && desc.writable) {
            copy[key] = target[key];
            return;
        }
        // for freeze
        if (!desc.writable) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) desc = {
            configurable: true,
            writable: true,
            enumerable: desc.enumerable,
            value: target[key]
        };
        Reflect.defineProperty(copy, key, desc);
    });
    return copy;
}
const $1bfe83860855b64a$var$propIsEnum = Object.prototype.propertyIsEnumerable;
function $1bfe83860855b64a$var$shallowCopy(original, options) {
    let markResult;
    if (Array.isArray(original)) return Array.prototype.concat.call(original);
    else if (original instanceof Set) return new Set(original.values());
    else if (original instanceof Map) return new Map(original);
    else if ((options === null || options === void 0 ? void 0 : options.mark) && (markResult = options.mark(original, $1bfe83860855b64a$var$dataTypes), markResult !== undefined) && markResult !== $1bfe83860855b64a$var$dataTypes.mutable) {
        if (markResult === $1bfe83860855b64a$var$dataTypes.immutable) return $1bfe83860855b64a$var$strictCopy(original);
        else if (typeof markResult === "function") {
            if (options.enablePatches || options.enableAutoFreeze) throw new Error(`You can't use mark and patches or auto freeze together.`);
            return markResult();
        }
        throw new Error(`Unsupported mark result: ${markResult}`);
    } else if (typeof original === "object" && Object.getPrototypeOf(original) === Object.prototype) {
        // For best performance with shallow copies,
        // don't use `Object.create(Object.getPrototypeOf(obj), Object.getOwnPropertyDescriptors(obj));` by default.
        const copy = {};
        Object.keys(original).forEach((key)=>{
            copy[key] = original[key];
        });
        Object.getOwnPropertySymbols(original).forEach((key)=>{
            if ($1bfe83860855b64a$var$propIsEnum.call(original, key)) copy[key] = original[key];
        });
        return copy;
    } else throw new Error(`Please check mark() to ensure that it is a stable marker draftable function.`);
}
function $1bfe83860855b64a$var$ensureShallowCopy(target) {
    if (target.copy) return;
    target.copy = $1bfe83860855b64a$var$shallowCopy(target.original, target.options);
}
function $1bfe83860855b64a$var$deepClone(target) {
    if (!$1bfe83860855b64a$export$16e3aed3edb85946(target)) return $1bfe83860855b64a$var$getValue(target);
    if (Array.isArray(target)) return target.map($1bfe83860855b64a$var$deepClone);
    if (target instanceof Map) return new Map(Array.from(target.entries()).map(([k, v])=>[
            k,
            $1bfe83860855b64a$var$deepClone(v)
        ]));
    if (target instanceof Set) return new Set(Array.from(target).map($1bfe83860855b64a$var$deepClone));
    const copy = Object.create(Object.getPrototypeOf(target));
    for(const key in target)copy[key] = $1bfe83860855b64a$var$deepClone(target[key]);
    return copy;
}
function $1bfe83860855b64a$var$cloneIfNeeded(target) {
    return $1bfe83860855b64a$export$541ac630993a4c84(target) ? $1bfe83860855b64a$var$deepClone(target) : target;
}
function $1bfe83860855b64a$var$markChanged(proxyDraft) {
    var _a;
    proxyDraft.assignedMap = (_a = proxyDraft.assignedMap) !== null && _a !== void 0 ? _a : new Map();
    if (!proxyDraft.operated) {
        proxyDraft.operated = true;
        if (proxyDraft.parent) $1bfe83860855b64a$var$markChanged(proxyDraft.parent);
    }
}
function $1bfe83860855b64a$var$throwFrozenError() {
    throw new Error("Cannot modify frozen object");
}
function $1bfe83860855b64a$var$deepFreeze(target, subKey, updatedValues, stack, keys) {
    {
        updatedValues = updatedValues !== null && updatedValues !== void 0 ? updatedValues : new WeakMap();
        stack = stack !== null && stack !== void 0 ? stack : [];
        keys = keys !== null && keys !== void 0 ? keys : [];
        const value = updatedValues.has(target) ? updatedValues.get(target) : target;
        if (stack.length > 0) {
            const index = stack.indexOf(value);
            if (value && typeof value === "object" && index !== -1) {
                if (stack[0] === value) throw new Error(`Forbids circular reference`);
                throw new Error(`Forbids circular reference: ~/${keys.slice(0, index).map((key, index)=>{
                    if (typeof key === "symbol") return `[${key.toString()}]`;
                    const parent = stack[index];
                    if (typeof key === "object" && (parent instanceof Map || parent instanceof Set)) return Array.from(parent.keys()).indexOf(key);
                    return key;
                }).join("/")}`);
            }
            stack.push(value);
            keys.push(subKey);
        } else stack.push(value);
    }
    if (Object.isFrozen(target) || $1bfe83860855b64a$export$541ac630993a4c84(target)) {
        stack.pop();
        keys.pop();
        return;
    }
    const type = $1bfe83860855b64a$var$getType(target);
    switch(type){
        case 2 /* DraftType.Map */ :
            for (const [key, value] of target){
                $1bfe83860855b64a$var$deepFreeze(key, key, updatedValues, stack, keys);
                $1bfe83860855b64a$var$deepFreeze(value, key, updatedValues, stack, keys);
            }
            target.set = target.clear = target.delete = $1bfe83860855b64a$var$throwFrozenError;
            break;
        case 3 /* DraftType.Set */ :
            for (const value of target)$1bfe83860855b64a$var$deepFreeze(value, value, updatedValues, stack, keys);
            target.add = target.clear = target.delete = $1bfe83860855b64a$var$throwFrozenError;
            break;
        case 1 /* DraftType.Array */ :
            Object.freeze(target);
            let index = 0;
            for (const value of target){
                $1bfe83860855b64a$var$deepFreeze(value, index, updatedValues, stack, keys);
                index += 1;
            }
            break;
        default:
            Object.freeze(target);
            // ignore non-enumerable or symbol properties
            Object.keys(target).forEach((name)=>{
                const value = target[name];
                $1bfe83860855b64a$var$deepFreeze(value, name, updatedValues, stack, keys);
            });
    }
    stack.pop();
    keys.pop();
}
function $1bfe83860855b64a$var$has(target, key) {
    return target instanceof Map ? target.has(key) : Object.prototype.hasOwnProperty.call(target, key);
}
function $1bfe83860855b64a$var$getDescriptor(target, key) {
    if (key in target) {
        let prototype = Reflect.getPrototypeOf(target);
        while(prototype){
            const descriptor = Reflect.getOwnPropertyDescriptor(prototype, key);
            if (descriptor) return descriptor;
            prototype = Reflect.getPrototypeOf(prototype);
        }
    }
    return;
}
function $1bfe83860855b64a$var$forEach(target, iter) {
    const type = $1bfe83860855b64a$var$getType(target);
    if (type === 0 /* DraftType.Object */ ) Reflect.ownKeys(target).forEach((key)=>{
        iter(key, target[key], target);
    });
    else if (type === 1 /* DraftType.Array */ ) {
        let index = 0;
        for (const entry of target){
            iter(index, entry, target);
            index += 1;
        }
    } else target.forEach((entry, index)=>iter(index, entry, target));
}
function $1bfe83860855b64a$var$handleValue(target, handledSet, options) {
    if ($1bfe83860855b64a$export$541ac630993a4c84(target) || !$1bfe83860855b64a$export$16e3aed3edb85946(target, options) || handledSet.has(target) || Object.isFrozen(target)) return;
    const isSet = target instanceof Set;
    const setMap = isSet ? new Map() : undefined;
    handledSet.add(target);
    $1bfe83860855b64a$var$forEach(target, (key, value)=>{
        var _a;
        if ($1bfe83860855b64a$export$541ac630993a4c84(value)) {
            const proxyDraft = $1bfe83860855b64a$var$getProxyDraft(value);
            $1bfe83860855b64a$var$ensureShallowCopy(proxyDraft);
            // A draft where a child node has been changed, or assigned a value
            const updatedValue = ((_a = proxyDraft.assignedMap) === null || _a === void 0 ? void 0 : _a.size) || proxyDraft.operated ? proxyDraft.copy : proxyDraft.original;
            // final update value
            $1bfe83860855b64a$var$set(isSet ? setMap : target, key, updatedValue);
        } else $1bfe83860855b64a$var$handleValue(value, handledSet, options);
    });
    if (setMap) {
        const set = target;
        const values = Array.from(set);
        set.clear();
        values.forEach((value)=>{
            set.add(setMap.has(value) ? setMap.get(value) : value);
        });
    }
}
function $1bfe83860855b64a$var$finalizeAssigned(proxyDraft, key) {
    // handle the draftable assigned values， and the value is not a draft
    const copy = proxyDraft.type === 3 /* DraftType.Set */  ? proxyDraft.setMap : proxyDraft.copy;
    if (proxyDraft.finalities.revoke.length > 1 && proxyDraft.assignedMap.get(key) && copy) $1bfe83860855b64a$var$handleValue($1bfe83860855b64a$var$get(copy, key), proxyDraft.finalities.handledSet, proxyDraft.options);
}
function $1bfe83860855b64a$var$finalizeSetValue(target) {
    if (target.type === 3 /* DraftType.Set */  && target.copy) {
        target.copy.clear();
        target.setMap.forEach((value)=>{
            target.copy.add($1bfe83860855b64a$var$getValue(value));
        });
    }
}
function $1bfe83860855b64a$var$finalizePatches(target, generatePatches, patches, inversePatches) {
    const shouldFinalize = target.operated && target.assignedMap && target.assignedMap.size > 0 && !target.finalized;
    if (shouldFinalize) {
        if (patches && inversePatches) {
            const basePath = $1bfe83860855b64a$var$getPath(target);
            if (basePath) generatePatches(target, basePath, patches, inversePatches);
        }
        target.finalized = true;
    }
}
function $1bfe83860855b64a$var$markFinalization(target, key, value, generatePatches) {
    const proxyDraft = $1bfe83860855b64a$var$getProxyDraft(value);
    if (proxyDraft) {
        // !case: assign the draft value
        if (!proxyDraft.callbacks) proxyDraft.callbacks = [];
        proxyDraft.callbacks.push((patches, inversePatches)=>{
            var _a;
            const copy = target.type === 3 /* DraftType.Set */  ? target.setMap : target.copy;
            if ($1bfe83860855b64a$var$isEqual($1bfe83860855b64a$var$get(copy, key), value)) {
                let updatedValue = proxyDraft.original;
                if (proxyDraft.copy) updatedValue = proxyDraft.copy;
                $1bfe83860855b64a$var$finalizeSetValue(target);
                $1bfe83860855b64a$var$finalizePatches(target, generatePatches, patches, inversePatches);
                if (target.options.enableAutoFreeze) {
                    target.options.updatedValues = (_a = target.options.updatedValues) !== null && _a !== void 0 ? _a : new WeakMap();
                    target.options.updatedValues.set(updatedValue, proxyDraft.original);
                }
                // final update value
                $1bfe83860855b64a$var$set(copy, key, updatedValue);
            }
        });
        if (target.options.enableAutoFreeze) // !case: assign the draft value in cross draft tree
        {
            if (proxyDraft.finalities !== target.finalities) target.options.enableAutoFreeze = false;
        }
    }
    if ($1bfe83860855b64a$export$16e3aed3edb85946(value, target.options)) // !case: assign the non-draft value
    target.finalities.draft.push(()=>{
        const copy = target.type === 3 /* DraftType.Set */  ? target.setMap : target.copy;
        if ($1bfe83860855b64a$var$isEqual($1bfe83860855b64a$var$get(copy, key), value)) $1bfe83860855b64a$var$finalizeAssigned(target, key);
    });
}
function $1bfe83860855b64a$var$generateArrayPatches(proxyState, basePath, patches, inversePatches, pathAsArray) {
    let { original: original, assignedMap: assignedMap, options: options } = proxyState;
    let copy = proxyState.copy;
    if (copy.length < original.length) {
        [original, copy] = [
            copy,
            original
        ];
        [patches, inversePatches] = [
            inversePatches,
            patches
        ];
    }
    for(let index = 0; index < original.length; index += 1)if (assignedMap.get(index.toString()) && copy[index] !== original[index]) {
        const _path = basePath.concat([
            index
        ]);
        const path = $1bfe83860855b64a$var$escapePath(_path, pathAsArray);
        patches.push({
            op: $1bfe83860855b64a$var$Operation.Replace,
            path: path,
            // If it is a draft, it needs to be deep cloned, and it may also be non-draft.
            value: $1bfe83860855b64a$var$cloneIfNeeded(copy[index])
        });
        inversePatches.push({
            op: $1bfe83860855b64a$var$Operation.Replace,
            path: path,
            // If it is a draft, it needs to be deep cloned, and it may also be non-draft.
            value: $1bfe83860855b64a$var$cloneIfNeeded(original[index])
        });
    }
    for(let index = original.length; index < copy.length; index += 1){
        const _path = basePath.concat([
            index
        ]);
        const path = $1bfe83860855b64a$var$escapePath(_path, pathAsArray);
        patches.push({
            op: $1bfe83860855b64a$var$Operation.Add,
            path: path,
            // If it is a draft, it needs to be deep cloned, and it may also be non-draft.
            value: $1bfe83860855b64a$var$cloneIfNeeded(copy[index])
        });
    }
    if (original.length < copy.length) {
        // https://www.rfc-editor.org/rfc/rfc6902#appendix-A.4
        // For performance, here we only generate an operation that replaces the length of the array,
        // which is inconsistent with JSON Patch specification
        const { arrayLengthAssignment: arrayLengthAssignment = true } = options.enablePatches;
        if (arrayLengthAssignment) {
            const _path = basePath.concat([
                "length"
            ]);
            const path = $1bfe83860855b64a$var$escapePath(_path, pathAsArray);
            inversePatches.push({
                op: $1bfe83860855b64a$var$Operation.Replace,
                path: path,
                value: original.length
            });
        } else for(let index = copy.length; original.length < index; index -= 1){
            const _path = basePath.concat([
                index - 1
            ]);
            const path = $1bfe83860855b64a$var$escapePath(_path, pathAsArray);
            inversePatches.push({
                op: $1bfe83860855b64a$var$Operation.Remove,
                path: path
            });
        }
    }
}
function $1bfe83860855b64a$var$generatePatchesFromAssigned({ original: original, copy: copy, assignedMap: assignedMap }, basePath, patches, inversePatches, pathAsArray) {
    assignedMap.forEach((assignedValue, key)=>{
        const originalValue = $1bfe83860855b64a$var$get(original, key);
        const value = $1bfe83860855b64a$var$cloneIfNeeded($1bfe83860855b64a$var$get(copy, key));
        const op = !assignedValue ? $1bfe83860855b64a$var$Operation.Remove : $1bfe83860855b64a$var$has(original, key) ? $1bfe83860855b64a$var$Operation.Replace : $1bfe83860855b64a$var$Operation.Add;
        if ($1bfe83860855b64a$var$isEqual(originalValue, value) && op === $1bfe83860855b64a$var$Operation.Replace) return;
        const _path = basePath.concat(key);
        const path = $1bfe83860855b64a$var$escapePath(_path, pathAsArray);
        patches.push(op === $1bfe83860855b64a$var$Operation.Remove ? {
            op: op,
            path: path
        } : {
            op: op,
            path: path,
            value: value
        });
        inversePatches.push(op === $1bfe83860855b64a$var$Operation.Add ? {
            op: $1bfe83860855b64a$var$Operation.Remove,
            path: path
        } : op === $1bfe83860855b64a$var$Operation.Remove ? {
            op: $1bfe83860855b64a$var$Operation.Add,
            path: path,
            value: originalValue
        } : {
            op: $1bfe83860855b64a$var$Operation.Replace,
            path: path,
            value: originalValue
        });
    });
}
function $1bfe83860855b64a$var$generateSetPatches({ original: original, copy: copy }, basePath, patches, inversePatches, pathAsArray) {
    let index = 0;
    original.forEach((value)=>{
        if (!copy.has(value)) {
            const _path = basePath.concat([
                index
            ]);
            const path = $1bfe83860855b64a$var$escapePath(_path, pathAsArray);
            patches.push({
                op: $1bfe83860855b64a$var$Operation.Remove,
                path: path,
                value: value
            });
            inversePatches.unshift({
                op: $1bfe83860855b64a$var$Operation.Add,
                path: path,
                value: value
            });
        }
        index += 1;
    });
    index = 0;
    copy.forEach((value)=>{
        if (!original.has(value)) {
            const _path = basePath.concat([
                index
            ]);
            const path = $1bfe83860855b64a$var$escapePath(_path, pathAsArray);
            patches.push({
                op: $1bfe83860855b64a$var$Operation.Add,
                path: path,
                value: value
            });
            inversePatches.unshift({
                op: $1bfe83860855b64a$var$Operation.Remove,
                path: path,
                value: value
            });
        }
        index += 1;
    });
}
function $1bfe83860855b64a$var$generatePatches(proxyState, basePath, patches, inversePatches) {
    const { pathAsArray: pathAsArray = true } = proxyState.options.enablePatches;
    switch(proxyState.type){
        case 0 /* DraftType.Object */ :
        case 2 /* DraftType.Map */ :
            return $1bfe83860855b64a$var$generatePatchesFromAssigned(proxyState, basePath, patches, inversePatches, pathAsArray);
        case 1 /* DraftType.Array */ :
            return $1bfe83860855b64a$var$generateArrayPatches(proxyState, basePath, patches, inversePatches, pathAsArray);
        case 3 /* DraftType.Set */ :
            return $1bfe83860855b64a$var$generateSetPatches(proxyState, basePath, patches, inversePatches, pathAsArray);
    }
}
let $1bfe83860855b64a$var$readable = false;
const $1bfe83860855b64a$var$checkReadable = (value, options, ignoreCheckDraftable = false)=>{
    if (typeof value === "object" && value !== null && (!$1bfe83860855b64a$export$16e3aed3edb85946(value, options) || ignoreCheckDraftable) && !$1bfe83860855b64a$var$readable) throw new Error(`Strict mode: Mutable data cannot be accessed directly, please use 'unsafe(callback)' wrap.`);
};
/**
 * `unsafe(callback)` to access mutable data directly in strict mode.
 *
 * ## Example
 *
 * ```ts
 * import { create, unsafe } from '../index';
 *
 * class Foobar {
 *   bar = 1;
 * }
 *
 * const baseState = { foobar: new Foobar() };
 * const state = create(
 *   baseState,
 *   (draft) => {
 *    unsafe(() => {
 *      draft.foobar.bar = 2;
 *    });
 *   },
 *   {
 *     strict: true,
 *   }
 * );
 *
 * expect(state).toBe(baseState);
 * expect(state.foobar).toBe(baseState.foobar);
 * expect(state.foobar.bar).toBe(2);
 * ```
 */ function $1bfe83860855b64a$export$aa1c11b655786597(callback) {
    $1bfe83860855b64a$var$readable = true;
    let result;
    try {
        result = callback();
    } finally{
        $1bfe83860855b64a$var$readable = false;
    }
    return result;
}
const $1bfe83860855b64a$var$mapHandler = {
    get size () {
        const current = $1bfe83860855b64a$var$latest($1bfe83860855b64a$var$getProxyDraft(this));
        return current.size;
    },
    has (key) {
        return $1bfe83860855b64a$var$latest($1bfe83860855b64a$var$getProxyDraft(this)).has(key);
    },
    set (key, value) {
        const target = $1bfe83860855b64a$var$getProxyDraft(this);
        const source = $1bfe83860855b64a$var$latest(target);
        if (!source.has(key) || !$1bfe83860855b64a$var$isEqual(source.get(key), value)) {
            $1bfe83860855b64a$var$ensureShallowCopy(target);
            $1bfe83860855b64a$var$markChanged(target);
            target.assignedMap.set(key, true);
            target.copy.set(key, value);
            $1bfe83860855b64a$var$markFinalization(target, key, value, $1bfe83860855b64a$var$generatePatches);
        }
        return this;
    },
    delete (key) {
        if (!this.has(key)) return false;
        const target = $1bfe83860855b64a$var$getProxyDraft(this);
        $1bfe83860855b64a$var$ensureShallowCopy(target);
        $1bfe83860855b64a$var$markChanged(target);
        if (target.original.has(key)) target.assignedMap.set(key, false);
        else target.assignedMap.delete(key);
        target.copy.delete(key);
        return true;
    },
    clear () {
        const target = $1bfe83860855b64a$var$getProxyDraft(this);
        if (!this.size) return;
        $1bfe83860855b64a$var$ensureShallowCopy(target);
        $1bfe83860855b64a$var$markChanged(target);
        target.assignedMap = new Map();
        for (const [key] of target.original)target.assignedMap.set(key, false);
        target.copy.clear();
    },
    forEach (callback, thisArg) {
        const target = $1bfe83860855b64a$var$getProxyDraft(this);
        $1bfe83860855b64a$var$latest(target).forEach((_value, _key)=>{
            callback.call(thisArg, this.get(_key), _key, this);
        });
    },
    get (key) {
        var _a, _b;
        const target = $1bfe83860855b64a$var$getProxyDraft(this);
        const value = $1bfe83860855b64a$var$latest(target).get(key);
        const mutable = ((_b = (_a = target.options).mark) === null || _b === void 0 ? void 0 : _b.call(_a, value, $1bfe83860855b64a$var$dataTypes)) === $1bfe83860855b64a$var$dataTypes.mutable;
        if (target.options.strict) $1bfe83860855b64a$var$checkReadable(value, target.options, mutable);
        if (mutable) return value;
        if (target.finalized || !$1bfe83860855b64a$export$16e3aed3edb85946(value, target.options)) return value;
        // drafted or reassigned
        if (value !== target.original.get(key)) return value;
        const draft = $1bfe83860855b64a$var$internal.createDraft({
            original: value,
            parentDraft: target,
            key: key,
            finalities: target.finalities,
            options: target.options
        });
        $1bfe83860855b64a$var$ensureShallowCopy(target);
        target.copy.set(key, draft);
        return draft;
    },
    keys () {
        return $1bfe83860855b64a$var$latest($1bfe83860855b64a$var$getProxyDraft(this)).keys();
    },
    values () {
        const iterator = this.keys();
        return {
            [$1bfe83860855b64a$var$iteratorSymbol]: ()=>this.values(),
            next: ()=>{
                const result = iterator.next();
                if (result.done) return result;
                const value = this.get(result.value);
                return {
                    done: false,
                    value: value
                };
            }
        };
    },
    entries () {
        const iterator = this.keys();
        return {
            [$1bfe83860855b64a$var$iteratorSymbol]: ()=>this.entries(),
            next: ()=>{
                const result = iterator.next();
                if (result.done) return result;
                const value = this.get(result.value);
                return {
                    done: false,
                    value: [
                        result.value,
                        value
                    ]
                };
            }
        };
    },
    [$1bfe83860855b64a$var$iteratorSymbol] () {
        return this.entries();
    }
};
const $1bfe83860855b64a$var$mapHandlerKeys = Reflect.ownKeys($1bfe83860855b64a$var$mapHandler);
const $1bfe83860855b64a$var$getNextIterator = (target, iterator, { isValuesIterator: isValuesIterator })=>()=>{
        var _a, _b;
        const result = iterator.next();
        if (result.done) return result;
        const key = result.value;
        let value = target.setMap.get(key);
        const currentDraft = $1bfe83860855b64a$var$getProxyDraft(value);
        const mutable = ((_b = (_a = target.options).mark) === null || _b === void 0 ? void 0 : _b.call(_a, value, $1bfe83860855b64a$var$dataTypes)) === $1bfe83860855b64a$var$dataTypes.mutable;
        if (target.options.strict) $1bfe83860855b64a$var$checkReadable(key, target.options, mutable);
        if (!mutable && !currentDraft && $1bfe83860855b64a$export$16e3aed3edb85946(key, target.options) && !target.finalized && target.original.has(key)) {
            // draft a draftable original set item
            const proxy = $1bfe83860855b64a$var$internal.createDraft({
                original: key,
                parentDraft: target,
                key: key,
                finalities: target.finalities,
                options: target.options
            });
            target.setMap.set(key, proxy);
            value = proxy;
        } else if (currentDraft) // drafted
        value = currentDraft.proxy;
        return {
            done: false,
            value: isValuesIterator ? value : [
                value,
                value
            ]
        };
    };
const $1bfe83860855b64a$var$setHandler = {
    get size () {
        const target = $1bfe83860855b64a$var$getProxyDraft(this);
        return target.setMap.size;
    },
    has (value) {
        const target = $1bfe83860855b64a$var$getProxyDraft(this);
        // reassigned or non-draftable values
        if (target.setMap.has(value)) return true;
        $1bfe83860855b64a$var$ensureShallowCopy(target);
        const valueProxyDraft = $1bfe83860855b64a$var$getProxyDraft(value);
        // drafted
        if (valueProxyDraft && target.setMap.has(valueProxyDraft.original)) return true;
        return false;
    },
    add (value) {
        const target = $1bfe83860855b64a$var$getProxyDraft(this);
        if (!this.has(value)) {
            $1bfe83860855b64a$var$ensureShallowCopy(target);
            $1bfe83860855b64a$var$markChanged(target);
            target.assignedMap.set(value, true);
            target.setMap.set(value, value);
            $1bfe83860855b64a$var$markFinalization(target, value, value, $1bfe83860855b64a$var$generatePatches);
        }
        return this;
    },
    delete (value) {
        if (!this.has(value)) return false;
        const target = $1bfe83860855b64a$var$getProxyDraft(this);
        $1bfe83860855b64a$var$ensureShallowCopy(target);
        $1bfe83860855b64a$var$markChanged(target);
        const valueProxyDraft = $1bfe83860855b64a$var$getProxyDraft(value);
        if (valueProxyDraft && target.setMap.has(valueProxyDraft.original)) {
            // delete drafted
            target.assignedMap.set(valueProxyDraft.original, false);
            return target.setMap.delete(valueProxyDraft.original);
        }
        if (!valueProxyDraft && target.setMap.has(value)) // non-draftable values
        target.assignedMap.set(value, false);
        else // reassigned
        target.assignedMap.delete(value);
        // delete reassigned or non-draftable values
        return target.setMap.delete(value);
    },
    clear () {
        if (!this.size) return;
        const target = $1bfe83860855b64a$var$getProxyDraft(this);
        $1bfe83860855b64a$var$ensureShallowCopy(target);
        $1bfe83860855b64a$var$markChanged(target);
        for (const value of target.original)target.assignedMap.set(value, false);
        target.setMap.clear();
    },
    values () {
        const target = $1bfe83860855b64a$var$getProxyDraft(this);
        $1bfe83860855b64a$var$ensureShallowCopy(target);
        const iterator = target.setMap.keys();
        return {
            [Symbol.iterator]: ()=>this.values(),
            next: $1bfe83860855b64a$var$getNextIterator(target, iterator, {
                isValuesIterator: true
            })
        };
    },
    entries () {
        const target = $1bfe83860855b64a$var$getProxyDraft(this);
        $1bfe83860855b64a$var$ensureShallowCopy(target);
        const iterator = target.setMap.keys();
        return {
            [Symbol.iterator]: ()=>this.entries(),
            next: $1bfe83860855b64a$var$getNextIterator(target, iterator, {
                isValuesIterator: false
            })
        };
    },
    keys () {
        return this.values();
    },
    [$1bfe83860855b64a$var$iteratorSymbol] () {
        return this.values();
    },
    forEach (callback, thisArg) {
        const iterator = this.values();
        let result = iterator.next();
        while(!result.done){
            callback.call(thisArg, result.value, result.value, this);
            result = iterator.next();
        }
    }
};
const $1bfe83860855b64a$var$setHandlerKeys = Reflect.ownKeys($1bfe83860855b64a$var$setHandler);
const $1bfe83860855b64a$var$draftsCache = new WeakSet();
const $1bfe83860855b64a$var$proxyHandler = {
    get (target, key, receiver) {
        var _a, _b;
        const copy = (_a = target.copy) === null || _a === void 0 ? void 0 : _a[key];
        // Improve draft reading performance by caching the draft copy.
        if (copy && $1bfe83860855b64a$var$draftsCache.has(copy)) return copy;
        if (key === $1bfe83860855b64a$var$PROXY_DRAFT) return target;
        let markResult;
        if (target.options.mark) {
            // handle `Uncaught TypeError: Method get Map.prototype.size called on incompatible receiver #<Map>`
            // or `Uncaught TypeError: Method get Set.prototype.size called on incompatible receiver #<Set>`
            const value = key === "size" && (target.original instanceof Map || target.original instanceof Set) ? Reflect.get(target.original, key) : Reflect.get(target.original, key, receiver);
            markResult = target.options.mark(value, $1bfe83860855b64a$var$dataTypes);
            if (markResult === $1bfe83860855b64a$var$dataTypes.mutable) {
                if (target.options.strict) $1bfe83860855b64a$var$checkReadable(value, target.options, true);
                return value;
            }
        }
        const source = $1bfe83860855b64a$var$latest(target);
        if (source instanceof Map && $1bfe83860855b64a$var$mapHandlerKeys.includes(key)) {
            if (key === "size") return Object.getOwnPropertyDescriptor($1bfe83860855b64a$var$mapHandler, "size").get.call(target.proxy);
            const handle = $1bfe83860855b64a$var$mapHandler[key];
            if (handle) return handle.bind(target.proxy);
        }
        if (source instanceof Set && $1bfe83860855b64a$var$setHandlerKeys.includes(key)) {
            if (key === "size") return Object.getOwnPropertyDescriptor($1bfe83860855b64a$var$setHandler, "size").get.call(target.proxy);
            const handle = $1bfe83860855b64a$var$setHandler[key];
            if (handle) return handle.bind(target.proxy);
        }
        if (!$1bfe83860855b64a$var$has(source, key)) {
            const desc = $1bfe83860855b64a$var$getDescriptor(source, key);
            return desc ? `value` in desc ? desc.value : (_b = desc.get) === null || _b === void 0 ? void 0 : _b.call(target.proxy) : undefined;
        }
        const value = source[key];
        if (target.options.strict) $1bfe83860855b64a$var$checkReadable(value, target.options);
        if (target.finalized || !$1bfe83860855b64a$export$16e3aed3edb85946(value, target.options)) return value;
        // Ensure that the assigned values are not drafted
        if (value === $1bfe83860855b64a$var$peek(target.original, key)) {
            $1bfe83860855b64a$var$ensureShallowCopy(target);
            target.copy[key] = $1bfe83860855b64a$var$createDraft({
                original: target.original[key],
                parentDraft: target,
                key: target.type === 1 /* DraftType.Array */  ? Number(key) : key,
                finalities: target.finalities,
                options: target.options
            });
            // !case: support for custom shallow copy function
            if (typeof markResult === "function") {
                const subProxyDraft = $1bfe83860855b64a$var$getProxyDraft(target.copy[key]);
                $1bfe83860855b64a$var$ensureShallowCopy(subProxyDraft);
                // Trigger a custom shallow copy to update to a new copy
                $1bfe83860855b64a$var$markChanged(subProxyDraft);
                return subProxyDraft.copy;
            }
            return target.copy[key];
        }
        return value;
    },
    set (target, key, value) {
        var _a;
        if (target.type === 3 /* DraftType.Set */  || target.type === 2 /* DraftType.Map */ ) throw new Error(`Map/Set draft does not support any property assignment.`);
        let _key;
        if (target.type === 1 /* DraftType.Array */  && key !== "length" && !(Number.isInteger(_key = Number(key)) && _key >= 0 && (key === 0 || _key === 0 || String(_key) === String(key)))) throw new Error(`Only supports setting array indices and the 'length' property.`);
        const desc = $1bfe83860855b64a$var$getDescriptor($1bfe83860855b64a$var$latest(target), key);
        if (desc === null || desc === void 0 ? void 0 : desc.set) {
            // !case: cover the case of setter
            desc.set.call(target.proxy, value);
            return true;
        }
        const current = $1bfe83860855b64a$var$peek($1bfe83860855b64a$var$latest(target), key);
        const currentProxyDraft = $1bfe83860855b64a$var$getProxyDraft(current);
        if (currentProxyDraft && $1bfe83860855b64a$var$isEqual(currentProxyDraft.original, value)) {
            // !case: ignore the case of assigning the original draftable value to a draft
            target.copy[key] = value;
            target.assignedMap = (_a = target.assignedMap) !== null && _a !== void 0 ? _a : new Map();
            target.assignedMap.set(key, false);
            return true;
        }
        // !case: handle new props with value 'undefined'
        if ($1bfe83860855b64a$var$isEqual(value, current) && (value !== undefined || $1bfe83860855b64a$var$has(target.original, key))) return true;
        $1bfe83860855b64a$var$ensureShallowCopy(target);
        $1bfe83860855b64a$var$markChanged(target);
        if ($1bfe83860855b64a$var$has(target.original, key) && $1bfe83860855b64a$var$isEqual(value, target.original[key])) // !case: handle the case of assigning the original non-draftable value to a draft
        target.assignedMap.delete(key);
        else target.assignedMap.set(key, true);
        target.copy[key] = value;
        $1bfe83860855b64a$var$markFinalization(target, key, value, $1bfe83860855b64a$var$generatePatches);
        return true;
    },
    has (target, key) {
        return key in $1bfe83860855b64a$var$latest(target);
    },
    ownKeys (target) {
        return Reflect.ownKeys($1bfe83860855b64a$var$latest(target));
    },
    getOwnPropertyDescriptor (target, key) {
        const source = $1bfe83860855b64a$var$latest(target);
        const descriptor = Reflect.getOwnPropertyDescriptor(source, key);
        if (!descriptor) return descriptor;
        return {
            writable: true,
            configurable: target.type !== 1 /* DraftType.Array */  || key !== "length",
            enumerable: descriptor.enumerable,
            value: source[key]
        };
    },
    getPrototypeOf (target) {
        return Reflect.getPrototypeOf(target.original);
    },
    setPrototypeOf () {
        throw new Error(`Cannot call 'setPrototypeOf()' on drafts`);
    },
    defineProperty () {
        throw new Error(`Cannot call 'defineProperty()' on drafts`);
    },
    deleteProperty (target, key) {
        var _a;
        if (target.type === 1 /* DraftType.Array */ ) return $1bfe83860855b64a$var$proxyHandler.set.call(this, target, key, undefined, target.proxy);
        if ($1bfe83860855b64a$var$peek(target.original, key) !== undefined || key in target.original) {
            // !case: delete an existing key
            $1bfe83860855b64a$var$ensureShallowCopy(target);
            $1bfe83860855b64a$var$markChanged(target);
            target.assignedMap.set(key, false);
        } else {
            target.assignedMap = (_a = target.assignedMap) !== null && _a !== void 0 ? _a : new Map();
            // The original non-existent key has been deleted
            target.assignedMap.delete(key);
        }
        if (target.copy) delete target.copy[key];
        return true;
    }
};
function $1bfe83860855b64a$var$createDraft(createDraftOptions) {
    const { original: original, parentDraft: parentDraft, key: key, finalities: finalities, options: options } = createDraftOptions;
    const type = $1bfe83860855b64a$var$getType(original);
    const proxyDraft = {
        type: type,
        finalized: false,
        parent: parentDraft,
        original: original,
        copy: null,
        proxy: null,
        finalities: finalities,
        options: options,
        // Mapping of draft Set items to their corresponding draft values.
        setMap: type === 3 /* DraftType.Set */  ? new Map(original.entries()) : undefined
    };
    // !case: undefined as a draft map key
    if (key || "key" in createDraftOptions) proxyDraft.key = key;
    const { proxy: proxy, revoke: revoke } = Proxy.revocable(type === 1 /* DraftType.Array */  ? Object.assign([], proxyDraft) : proxyDraft, $1bfe83860855b64a$var$proxyHandler);
    finalities.revoke.push(revoke);
    $1bfe83860855b64a$var$draftsCache.add(proxy);
    proxyDraft.proxy = proxy;
    if (parentDraft) {
        const target = parentDraft;
        target.finalities.draft.push((patches, inversePatches)=>{
            var _a, _b;
            const oldProxyDraft = $1bfe83860855b64a$var$getProxyDraft(proxy);
            // if target is a Set draft, `setMap` is the real Set copies proxy mapping.
            let copy = target.type === 3 /* DraftType.Set */  ? target.setMap : target.copy;
            const draft = $1bfe83860855b64a$var$get(copy, key);
            const proxyDraft = $1bfe83860855b64a$var$getProxyDraft(draft);
            if (proxyDraft) {
                // assign the updated value to the copy object
                let updatedValue = proxyDraft.original;
                if (proxyDraft.operated) updatedValue = $1bfe83860855b64a$var$getValue(draft);
                $1bfe83860855b64a$var$finalizeSetValue(proxyDraft);
                $1bfe83860855b64a$var$finalizePatches(proxyDraft, $1bfe83860855b64a$var$generatePatches, patches, inversePatches);
                if (target.options.enableAutoFreeze) {
                    target.options.updatedValues = (_a = target.options.updatedValues) !== null && _a !== void 0 ? _a : new WeakMap();
                    target.options.updatedValues.set(updatedValue, proxyDraft.original);
                }
                // final update value
                $1bfe83860855b64a$var$set(copy, key, updatedValue);
            }
            // !case: handle the deleted key
            (_b = oldProxyDraft.callbacks) === null || _b === void 0 || _b.forEach((callback)=>{
                callback(patches, inversePatches);
            });
        });
    } else {
        // !case: handle the root draft
        const target = $1bfe83860855b64a$var$getProxyDraft(proxy);
        target.finalities.draft.push((patches, inversePatches)=>{
            $1bfe83860855b64a$var$finalizeSetValue(target);
            $1bfe83860855b64a$var$finalizePatches(target, $1bfe83860855b64a$var$generatePatches, patches, inversePatches);
        });
    }
    return proxy;
}
$1bfe83860855b64a$var$internal.createDraft = $1bfe83860855b64a$var$createDraft;
function $1bfe83860855b64a$var$finalizeDraft(result, returnedValue, patches, inversePatches, enableAutoFreeze) {
    var _a;
    const proxyDraft = $1bfe83860855b64a$var$getProxyDraft(result);
    const original = (_a = proxyDraft === null || proxyDraft === void 0 ? void 0 : proxyDraft.original) !== null && _a !== void 0 ? _a : result;
    const hasReturnedValue = !!returnedValue.length;
    if (proxyDraft === null || proxyDraft === void 0 ? void 0 : proxyDraft.operated) while(proxyDraft.finalities.draft.length > 0){
        const finalize = proxyDraft.finalities.draft.pop();
        finalize(patches, inversePatches);
    }
    const state = hasReturnedValue ? returnedValue[0] : proxyDraft ? proxyDraft.operated ? proxyDraft.copy : proxyDraft.original : result;
    if (proxyDraft) $1bfe83860855b64a$var$revokeProxy(proxyDraft);
    if (enableAutoFreeze) $1bfe83860855b64a$var$deepFreeze(state, state, proxyDraft === null || proxyDraft === void 0 ? void 0 : proxyDraft.options.updatedValues);
    return [
        state,
        patches && hasReturnedValue ? [
            {
                op: $1bfe83860855b64a$var$Operation.Replace,
                path: [],
                value: returnedValue[0]
            }
        ] : patches,
        inversePatches && hasReturnedValue ? [
            {
                op: $1bfe83860855b64a$var$Operation.Replace,
                path: [],
                value: original
            }
        ] : inversePatches
    ];
}
function $1bfe83860855b64a$var$draftify(baseState, options) {
    var _a;
    const finalities = {
        draft: [],
        revoke: [],
        handledSet: new WeakSet()
    };
    let patches;
    let inversePatches;
    if (options.enablePatches) {
        patches = [];
        inversePatches = [];
    }
    const isMutable = ((_a = options.mark) === null || _a === void 0 ? void 0 : _a.call(options, baseState, $1bfe83860855b64a$var$dataTypes)) === $1bfe83860855b64a$var$dataTypes.mutable || !$1bfe83860855b64a$export$16e3aed3edb85946(baseState, options);
    const draft = isMutable ? baseState : $1bfe83860855b64a$var$createDraft({
        original: baseState,
        parentDraft: null,
        finalities: finalities,
        options: options
    });
    return [
        draft,
        (returnedValue = [])=>{
            const [finalizedState, finalizedPatches, finalizedInversePatches] = $1bfe83860855b64a$var$finalizeDraft(draft, returnedValue, patches, inversePatches, options.enableAutoFreeze);
            return options.enablePatches ? [
                finalizedState,
                finalizedPatches,
                finalizedInversePatches
            ] : finalizedState;
        }
    ];
}
function $1bfe83860855b64a$var$handleReturnValue(options) {
    const { rootDraft: rootDraft, value: value, useRawReturn: useRawReturn = false, isRoot: isRoot = true } = options;
    $1bfe83860855b64a$var$forEach(value, (key, item, source)=>{
        const proxyDraft = $1bfe83860855b64a$var$getProxyDraft(item);
        // just handle the draft which is created by the same rootDraft
        if (proxyDraft && rootDraft && proxyDraft.finalities === rootDraft.finalities) {
            options.isContainDraft = true;
            const currentValue = proxyDraft.original;
            // final update value, but just handle return value
            if (source instanceof Set) {
                const arr = Array.from(source);
                source.clear();
                arr.forEach((_item)=>source.add(key === _item ? currentValue : _item));
            } else $1bfe83860855b64a$var$set(source, key, currentValue);
        } else if (typeof item === "object" && item !== null) {
            options.value = item;
            options.isRoot = false;
            $1bfe83860855b64a$var$handleReturnValue(options);
        }
    });
    if (isRoot) {
        if (!options.isContainDraft) console.warn(`The return value does not contain any draft, please use 'rawReturn()' to wrap the return value to improve performance.`);
        if (useRawReturn) console.warn(`The return value contains drafts, please don't use 'rawReturn()' to wrap the return value.`);
    }
}
function $1bfe83860855b64a$var$getCurrent(target) {
    const proxyDraft = $1bfe83860855b64a$var$getProxyDraft(target);
    if (!$1bfe83860855b64a$export$16e3aed3edb85946(target, proxyDraft === null || proxyDraft === void 0 ? void 0 : proxyDraft.options)) return target;
    const type = $1bfe83860855b64a$var$getType(target);
    if (proxyDraft && !proxyDraft.operated) return proxyDraft.original;
    let currentValue;
    function ensureShallowCopy() {
        currentValue = type === 2 /* DraftType.Map */  ? new Map(target) : type === 3 /* DraftType.Set */  ? Array.from(proxyDraft.setMap.values()) : $1bfe83860855b64a$var$shallowCopy(target, proxyDraft === null || proxyDraft === void 0 ? void 0 : proxyDraft.options);
    }
    if (proxyDraft) {
        // It's a proxy draft, let's create a shallow copy eagerly
        proxyDraft.finalized = true;
        try {
            ensureShallowCopy();
        } finally{
            proxyDraft.finalized = false;
        }
    } else // It's not a proxy draft, let's use the target directly and let's see
    // lazily if we need to create a shallow copy
    currentValue = target;
    $1bfe83860855b64a$var$forEach(currentValue, (key, value)=>{
        if (proxyDraft && $1bfe83860855b64a$var$isEqual($1bfe83860855b64a$var$get(proxyDraft.original, key), value)) return;
        const newValue = $1bfe83860855b64a$var$getCurrent(value);
        if (newValue !== value) {
            if (currentValue === target) ensureShallowCopy();
            $1bfe83860855b64a$var$set(currentValue, key, newValue);
        }
    });
    return type === 3 /* DraftType.Set */  ? new Set(currentValue) : currentValue;
}
/**
 * `current(draft)` to get current state in the draft mutation function.
 *
 * ## Example
 *
 * ```ts
 * import { create, current } from '../index';
 *
 * const baseState = { foo: { bar: 'str' }, arr: [] };
 * const state = create(
 *   baseState,
 *   (draft) => {
 *     draft.foo.bar = 'str2';
 *     expect(current(draft.foo)).toEqual({ bar: 'str2' });
 *   },
 * );
 * ```
 */ function $1bfe83860855b64a$export$97aac956da55dae9(target) {
    if (!$1bfe83860855b64a$export$541ac630993a4c84(target)) throw new Error(`current() is only used for Draft, parameter: ${target}`);
    return $1bfe83860855b64a$var$getCurrent(target);
}
/**
 * `makeCreator(options)` to make a creator function.
 *
 * ## Example
 *
 * ```ts
 * import { makeCreator } from '../index';
 *
 * const baseState = { foo: { bar: 'str' }, arr: [] };
 * const create = makeCreator({ enableAutoFreeze: true });
 * const state = create(
 *   baseState,
 *   (draft) => {
 *     draft.foo.bar = 'str2';
 *   },
 * );
 *
 * expect(state).toEqual({ foo: { bar: 'str2' }, arr: [] });
 * expect(state).not.toBe(baseState);
 * expect(state.foo).not.toBe(baseState.foo);
 * expect(state.arr).toBe(baseState.arr);
 * expect(Object.isFrozen(state)).toBeTruthy();
 * ```
 */ const $1bfe83860855b64a$export$3cbf9dcc9483e820 = (arg)=>{
    if (arg !== undefined && Object.prototype.toString.call(arg) !== "[object Object]") throw new Error(`Invalid options: ${String(arg)}, 'options' should be an object.`);
    return function create(arg0, arg1, arg2) {
        var _a, _b, _c;
        if (typeof arg0 === "function" && typeof arg1 !== "function") return function(base, ...args) {
            return create(base, (draft)=>arg0.call(this, draft, ...args), arg1);
        };
        const base = arg0;
        const mutate = arg1;
        let options = arg2;
        if (typeof arg1 !== "function") options = arg1;
        if (options !== undefined && Object.prototype.toString.call(options) !== "[object Object]") throw new Error(`Invalid options: ${options}, 'options' should be an object.`);
        options = Object.assign(Object.assign({}, arg), options);
        const state = $1bfe83860855b64a$export$541ac630993a4c84(base) ? $1bfe83860855b64a$export$97aac956da55dae9(base) : base;
        const mark = Array.isArray(options.mark) ? (value, types)=>{
            for (const mark of options.mark){
                if (typeof mark !== "function") throw new Error(`Invalid mark: ${mark}, 'mark' should be a function.`);
                const result = mark(value, types);
                if (result) return result;
            }
            return;
        } : options.mark;
        const enablePatches = (_a = options.enablePatches) !== null && _a !== void 0 ? _a : false;
        const strict = (_b = options.strict) !== null && _b !== void 0 ? _b : false;
        const enableAutoFreeze = (_c = options.enableAutoFreeze) !== null && _c !== void 0 ? _c : false;
        const _options = {
            enableAutoFreeze: enableAutoFreeze,
            mark: mark,
            strict: strict,
            enablePatches: enablePatches
        };
        if (!$1bfe83860855b64a$export$16e3aed3edb85946(state, _options) && typeof state === "object" && state !== null) throw new Error(`Invalid base state: create() only supports plain objects, arrays, Set, Map or using mark() to mark the state as immutable.`);
        const [draft, finalize] = $1bfe83860855b64a$var$draftify(state, _options);
        if (typeof arg1 !== "function") {
            if (!$1bfe83860855b64a$export$16e3aed3edb85946(state, _options)) throw new Error(`Invalid base state: create() only supports plain objects, arrays, Set, Map or using mark() to mark the state as immutable.`);
            return [
                draft,
                finalize
            ];
        }
        let result;
        try {
            result = mutate(draft);
        } catch (error) {
            $1bfe83860855b64a$var$revokeProxy($1bfe83860855b64a$var$getProxyDraft(draft));
            throw error;
        }
        const returnValue = (value)=>{
            const proxyDraft = $1bfe83860855b64a$var$getProxyDraft(draft);
            if (!$1bfe83860855b64a$export$541ac630993a4c84(value)) {
                if (value !== undefined && !$1bfe83860855b64a$var$isEqual(value, draft) && (proxyDraft === null || proxyDraft === void 0 ? void 0 : proxyDraft.operated)) throw new Error(`Either the value is returned as a new non-draft value, or only the draft is modified without returning any value.`);
                const rawReturnValue = value === null || value === void 0 ? void 0 : value[$1bfe83860855b64a$var$RAW_RETURN_SYMBOL];
                if (rawReturnValue) {
                    const _value = rawReturnValue[0];
                    if (_options.strict && typeof value === "object" && value !== null) $1bfe83860855b64a$var$handleReturnValue({
                        rootDraft: proxyDraft,
                        value: value,
                        useRawReturn: true
                    });
                    return finalize([
                        _value
                    ]);
                }
                if (value !== undefined) {
                    if (typeof value === "object" && value !== null) $1bfe83860855b64a$var$handleReturnValue({
                        rootDraft: proxyDraft,
                        value: value
                    });
                    return finalize([
                        value
                    ]);
                }
            }
            if (value === draft || value === undefined) return finalize([]);
            const returnedProxyDraft = $1bfe83860855b64a$var$getProxyDraft(value);
            if (_options === returnedProxyDraft.options) {
                if (returnedProxyDraft.operated) throw new Error(`Cannot return a modified child draft.`);
                return finalize([
                    $1bfe83860855b64a$export$97aac956da55dae9(value)
                ]);
            }
            return finalize([
                value
            ]);
        };
        if (result instanceof Promise) return result.then(returnValue, (error)=>{
            $1bfe83860855b64a$var$revokeProxy($1bfe83860855b64a$var$getProxyDraft(draft));
            throw error;
        });
        return returnValue(result);
    };
};
/**
 * `create(baseState, callback, options)` to create the next state
 *
 * ## Example
 *
 * ```ts
 * import { create } from '../index';
 *
 * const baseState = { foo: { bar: 'str' }, arr: [] };
 * const state = create(
 *   baseState,
 *   (draft) => {
 *     draft.foo.bar = 'str2';
 *   },
 * );
 *
 * expect(state).toEqual({ foo: { bar: 'str2' }, arr: [] });
 * expect(state).not.toBe(baseState);
 * expect(state.foo).not.toBe(baseState.foo);
 * expect(state.arr).toBe(baseState.arr);
 * ```
 */ const $1bfe83860855b64a$export$185802fd694ee1f5 = $1bfe83860855b64a$export$3cbf9dcc9483e820();
/**
 * `apply(state, patches)` to apply patches to state
 *
 * ## Example
 *
 * ```ts
 * import { create, apply } from '../index';
 *
 * const baseState = { foo: { bar: 'str' }, arr: [] };
 * const [state, patches] = create(
 *   baseState,
 *   (draft) => {
 *     draft.foo.bar = 'str2';
 *   },
 *   { enablePatches: true }
 * );
 * expect(state).toEqual({ foo: { bar: 'str2' }, arr: [] });
 * expect(patches).toEqual([{ op: 'replace', path: ['foo', 'bar'], value: 'str2' }]);
 * expect(state).toEqual(apply(baseState, patches));
 * ```
 */ function $1bfe83860855b64a$export$5635d7ef4b8fee1c(state, patches, applyOptions) {
    let i;
    for(i = patches.length - 1; i >= 0; i -= 1){
        const { value: value, op: op, path: path } = patches[i];
        if (!path.length && op === $1bfe83860855b64a$var$Operation.Replace || path === "" && op === $1bfe83860855b64a$var$Operation.Add) {
            state = value;
            break;
        }
    }
    if (i > -1) patches = patches.slice(i + 1);
    const mutate = (draft)=>{
        patches.forEach((patch)=>{
            const { path: _path, op: op } = patch;
            const path = $1bfe83860855b64a$var$unescapePath(_path);
            let base = draft;
            for(let index = 0; index < path.length - 1; index += 1){
                const parentType = $1bfe83860855b64a$var$getType(base);
                let key = path[index];
                if (typeof key !== "string" && typeof key !== "number") key = String(key);
                if ((parentType === 0 /* DraftType.Object */  || parentType === 1 /* DraftType.Array */ ) && (key === "__proto__" || key === "constructor") || typeof base === "function" && key === "prototype") throw new Error(`Patching reserved attributes like __proto__ and constructor is not allowed.`);
                // use `index` in Set draft
                base = $1bfe83860855b64a$var$get(parentType === 3 /* DraftType.Set */  ? Array.from(base) : base, key);
                if (typeof base !== "object") throw new Error(`Cannot apply patch at '${path.join("/")}'.`);
            }
            const type = $1bfe83860855b64a$var$getType(base);
            // ensure the original patch is not modified.
            const value = $1bfe83860855b64a$var$deepClone(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case $1bfe83860855b64a$var$Operation.Replace:
                    switch(type){
                        case 2 /* DraftType.Map */ :
                            return base.set(key, value);
                        case 3 /* DraftType.Set */ :
                            throw new Error(`Cannot apply replace patch to set.`);
                        default:
                            return base[key] = value;
                    }
                case $1bfe83860855b64a$var$Operation.Add:
                    switch(type){
                        case 1 /* DraftType.Array */ :
                            // If the "-" character is used to
                            // index the end of the array (see [RFC6901](https://datatracker.ietf.org/doc/html/rfc6902)),
                            // this has the effect of appending the value to the array.
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* DraftType.Map */ :
                            return base.set(key, value);
                        case 3 /* DraftType.Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case $1bfe83860855b64a$var$Operation.Remove:
                    switch(type){
                        case 1 /* DraftType.Array */ :
                            return base.splice(key, 1);
                        case 2 /* DraftType.Map */ :
                            return base.delete(key);
                        case 3 /* DraftType.Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    throw new Error(`Unsupported patch operation: ${op}.`);
            }
        });
    };
    if ($1bfe83860855b64a$export$541ac630993a4c84(state)) {
        if (applyOptions !== undefined) throw new Error(`Cannot apply patches with options to a draft.`);
        mutate(state);
        return state;
    }
    return $1bfe83860855b64a$export$185802fd694ee1f5(state, mutate, Object.assign(Object.assign({}, applyOptions), {
        enablePatches: false
    }));
}
/**
 * `original(draft)` to get original state in the draft mutation function.
 *
 * ## Example
 *
 * ```ts
 * import { create, original } from '../index';
 *
 * const baseState = { foo: { bar: 'str' }, arr: [] };
 * const state = create(
 *   baseState,
 *   (draft) => {
 *     draft.foo.bar = 'str2';
 *     expect(original(draft.foo)).toEqual({ bar: 'str' });
 *   }
 * );
 * ```
 */ function $1bfe83860855b64a$export$22e8af3f75a010e3(target) {
    const proxyDraft = $1bfe83860855b64a$var$getProxyDraft(target);
    if (!proxyDraft) throw new Error(`original() is only used for a draft, parameter: ${target}`);
    return proxyDraft.original;
}
/**
 * Use rawReturn() to wrap the return value to skip the draft check and thus improve performance.
 *
 * ## Example
 *
 * ```ts
 * import { create, rawReturn } from '../index';
 *
 * const baseState = { foo: { bar: 'str' }, arr: [] };
 * const state = create(
 *   baseState,
 *   (draft) => {
 *     return rawReturn(baseState);
 *   },
 * );
 * expect(state).toBe(baseState);
 * ```
 */ function $1bfe83860855b64a$export$cd901fda21a18b43(value) {
    if (arguments.length === 0) throw new Error("rawReturn() must be called with a value.");
    if (arguments.length > 1) throw new Error("rawReturn() must be called with one argument.");
    if (value !== undefined && (typeof value !== "object" || value === null)) console.warn("rawReturn() must be called with an object(including plain object, arrays, Set, Map, etc.) or `undefined`, other types do not need to be returned via rawReturn().");
    return {
        [$1bfe83860855b64a$var$RAW_RETURN_SYMBOL]: [
            value
        ]
    };
}
const $1bfe83860855b64a$var$constructorString = Object.prototype.constructor.toString();
/**
 * Check if the value is a simple object(No prototype chain object or iframe same-origin object),
 * support case: https://github.com/unadlib/mutative/issues/17
 */ const $1bfe83860855b64a$var$isSimpleObject = (value)=>{
    if (!value || typeof value !== "object") return false;
    const prototype = Object.getPrototypeOf(value);
    if (prototype === null) return true;
    const constructor = Object.hasOwnProperty.call(prototype, "constructor") && prototype.constructor;
    if (constructor === Object) return true;
    return typeof constructor === "function" && Function.toString.call(constructor) === $1bfe83860855b64a$var$constructorString;
};
const $1bfe83860855b64a$export$d16063589ba51e59 = (value)=>{
    if ($1bfe83860855b64a$var$isSimpleObject(value)) return $1bfe83860855b64a$var$dataTypes.immutable;
    return;
};
/**
 * Cast a value to an Draft type value.
 */ function $1bfe83860855b64a$export$c05b21e3257751e5(value) {
    return value;
}
/**
 * Cast a value to an Immutable type value.
 */ function $1bfe83860855b64a$export$20f911b3f8cf0b74(value) {
    return value;
}



var $1bc72aea517c8fea$export$5bdeb9e4de225b16;
(function(Suit) {
    Suit[Suit["Clubs"] = 0] = "Clubs";
    Suit[Suit["Diamonds"] = 1] = "Diamonds";
    Suit[Suit["Hearts"] = 2] = "Hearts";
    Suit[Suit["Spades"] = 3] = "Spades";
})($1bc72aea517c8fea$export$5bdeb9e4de225b16 || ($1bc72aea517c8fea$export$5bdeb9e4de225b16 = {}));
const $1bc72aea517c8fea$export$efcc524239c32c73 = [
    0,
    1,
    2,
    3
];
var $1bc72aea517c8fea$export$5062880c778c5dd2;
(function(CardValue) {
    CardValue[CardValue["Ace"] = 14] = "Ace";
    CardValue[CardValue["Two"] = 2] = "Two";
    CardValue[CardValue["Three"] = 3] = "Three";
    CardValue[CardValue["Four"] = 4] = "Four";
    CardValue[CardValue["Five"] = 5] = "Five";
    CardValue[CardValue["Six"] = 6] = "Six";
    CardValue[CardValue["Seven"] = 7] = "Seven";
    CardValue[CardValue["Eight"] = 8] = "Eight";
    CardValue[CardValue["Nine"] = 9] = "Nine";
    CardValue[CardValue["Ten"] = 10] = "Ten";
    CardValue[CardValue["Jack"] = 11] = "Jack";
    CardValue[CardValue["Queen"] = 12] = "Queen";
    CardValue[CardValue["King"] = 13] = "King";
})($1bc72aea517c8fea$export$5062880c778c5dd2 || ($1bc72aea517c8fea$export$5062880c778c5dd2 = {}));
const $1bc72aea517c8fea$export$801f53f8ff768e98 = [
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14
];



function $40eba99eaa1e9859$export$eafd19060c8b57dd(withJokers) {
    const baseDeck = (0, $1bc72aea517c8fea$export$efcc524239c32c73).flatMap((suit)=>(0, $1bc72aea517c8fea$export$801f53f8ff768e98).map((value)=>({
                suit: suit,
                value: value
            })));
    if (withJokers) baseDeck.push(...Array.from({
        length: 2
    }).map((_, i)=>({
            joker: i
        })));
    return (0, $6c182388e9a195e9$export$448332262467e042)(baseDeck);
}
const $40eba99eaa1e9859$export$47cd02e2cf937030 = [
    {
        cards: 0
    },
    {
        cards: 3
    },
    {
        cards: 1
    },
    {
        cards: 1
    }
];
function $40eba99eaa1e9859$export$aab0d876bb6c7a7f(players, config, winRecord) {
    const deck = $40eba99eaa1e9859$export$eafd19060c8b57dd(config.withJokers);
    const numCards = config.gameMode === (0, $0651f0d0ba30c08f$export$7cd7a93136e7148a).OMAHA ? 4 : 2;
    const state = {
        phase: (0, $0651f0d0ba30c08f$export$1179af6d199a01fa).BIDDING,
        config: config,
        players: players.map((p)=>({
                name: p.name,
                // deal cards to each player (2 for Hold'em, 4 for Omaha)
                hand: deck.splice(0, numCards),
                pastTokens: [],
                token: null
            })),
        communityCards: [],
        deck: deck,
        pastRounds: [],
        futureRounds: $40eba99eaa1e9859$export$47cd02e2cf937030,
        jokerLog: [],
        log: [],
        winRecord: winRecord ?? {
            wins: 0,
            losses: 0,
            targetWins: config.targetWins ?? (0, $0651f0d0ba30c08f$export$a0bea9b09a67f3da).config.targetWins,
            targetLosses: config.targetLosses ?? (0, $0651f0d0ba30c08f$export$a0bea9b09a67f3da).config.targetLosses
        },
        // start out with null tokens in case we need to resolve jokers
        tokens: players.map(()=>null)
    };
    return $40eba99eaa1e9859$export$d68aabd9451ab6d8(state);
}
function $40eba99eaa1e9859$var$allHandsResolved(players) {
    return players.every((p)=>p.hand.every((c)=>!(c instanceof Array) && !("joker" in c)));
}
function $40eba99eaa1e9859$export$4f2c9bb64a518c51(game) {
    return $40eba99eaa1e9859$var$allHandsResolved(game.players);
}
function $40eba99eaa1e9859$export$d68aabd9451ab6d8(game) {
    if ($40eba99eaa1e9859$export$4f2c9bb64a518c51(game)) return $40eba99eaa1e9859$export$9ffc307867ecb30d(game);
    return (0, $1bfe83860855b64a$export$185802fd694ee1f5)(game, (draft)=>{
        draft.players.forEach((player, playerIx)=>{
            if (player.hand.every((obj)=>!(obj instanceof Array))) {
                const ix = player.hand.findIndex((obj)=>"joker" in obj);
                if (ix !== -1) {
                    player.hand[ix] = draft.deck.splice(0, 2);
                    draft.jokerLog.push({
                        player: playerIx
                    });
                }
            }
        });
    });
}
function $40eba99eaa1e9859$export$9ffc307867ecb30d(game) {
    const [draft, finalize] = (0, $1bfe83860855b64a$export$185802fd694ee1f5)(game);
    const currentRound = draft.futureRounds.shift();
    if (currentRound == null) return {
        phase: (0, $0651f0d0ba30c08f$export$1179af6d199a01fa).SCORING,
        config: game.config,
        players: game.players,
        communityCards: game.communityCards,
        deck: game.deck,
        jokerLog: game.jokerLog,
        log: game.log,
        winRecord: game.winRecord,
        pastRounds: game.pastRounds,
        revealIndex: 1
    };
    draft.pastRounds.push(currentRound);
    // update history bookkeeping for a new round
    const roundIndex = draft.log.length;
    if (roundIndex > 0) for (const p of draft.players){
        if (!p.token) throw new Error("can't advance round unless every player has a token!");
        p.pastTokens.push(p.token);
        p.token = null;
    }
    draft.log.push([]);
    // deal new community card(s)
    for(let i = 0; i < currentRound.cards; i += 1){
        const slot = [];
        let cardsInSlot = 1;
        while(cardsInSlot > 0){
            const draw = draft.deck.shift();
            if ("joker" in draw) cardsInSlot += 1;
            else {
                cardsInSlot -= 1;
                slot.push(draw);
            }
        }
        draft.communityCards.push(slot);
    }
    // mint new tokens
    draft.tokens = draft.players.map((_, i)=>({
            index: i + 1,
            round: roundIndex
        }));
    return finalize();
}




var $1wHBI = parcelRequire("1wHBI");
function $e0419569a63e20fa$var$starting(args) {
    const n = parseInt(args || "3");
    return {
        ...(0, $0651f0d0ba30c08f$export$a0bea9b09a67f3da),
        players: Array.from({
            length: n
        }).map((_, i)=>({
                name: `player${i + 1}`
            }))
    };
}
function $e0419569a63e20fa$var$makeResolveJokers(args) {
    const deck = (0, $40eba99eaa1e9859$export$eafd19060c8b57dd)(false);
    return (0, $40eba99eaa1e9859$export$d68aabd9451ab6d8)({
        phase: (0, $0651f0d0ba30c08f$export$1179af6d199a01fa).BIDDING,
        config: (0, $0651f0d0ba30c08f$export$a0bea9b09a67f3da).config,
        players: $e0419569a63e20fa$var$starting(args).players.map((p, i)=>({
                name: p.name,
                hand: i === 0 ? [
                    {
                        joker: 0
                    },
                    deck.shift()
                ] : deck.splice(0, 2),
                pastTokens: [],
                token: null
            })),
        communityCards: [],
        deck: [
            {
                joker: 1
            },
            ...deck
        ],
        pastRounds: [],
        futureRounds: (0, $40eba99eaa1e9859$export$47cd02e2cf937030),
        jokerLog: [],
        log: [],
        tokens: [
            null,
            null,
            null
        ],
        winRecord: {
            wins: 0,
            losses: 0,
            targetWins: 3,
            targetLosses: 3
        }
    });
}
function $e0419569a63e20fa$var$makeFinishing(args) {
    const deck = (0, $40eba99eaa1e9859$export$eafd19060c8b57dd)(false);
    return {
        phase: (0, $0651f0d0ba30c08f$export$1179af6d199a01fa).BIDDING,
        config: (0, $0651f0d0ba30c08f$export$a0bea9b09a67f3da).config,
        players: $e0419569a63e20fa$var$starting(args).players.map((p, i)=>({
                name: p.name,
                hand: deck.splice(0, 2),
                pastTokens: Array.from({
                    length: 3
                }).map((_, j)=>({
                        round: j,
                        index: i + 1
                    })),
                token: {
                    index: i + 1,
                    round: 3
                }
            })),
        communityCards: [
            ...deck.splice(0, 4).map((x)=>[
                    x
                ]),
            deck.splice(0, 2)
        ],
        deck: deck,
        pastRounds: (0, $40eba99eaa1e9859$export$47cd02e2cf937030),
        futureRounds: [],
        jokerLog: [],
        log: [
            []
        ],
        tokens: [
            null,
            null,
            null
        ],
        winRecord: {
            wins: 2,
            losses: 2,
            targetWins: 3,
            targetLosses: 3
        }
    };
}
const $e0419569a63e20fa$export$e0dfa59be8d5deec = {
    starting: $e0419569a63e20fa$var$starting,
    resolveJokers: $e0419569a63e20fa$var$makeResolveJokers,
    finishing: $e0419569a63e20fa$var$makeFinishing
};
let $e0419569a63e20fa$var$STATE = {};
if (null) {
    null.dispose((data)=>{
        data.state = $e0419569a63e20fa$var$STATE;
    });
    null.accept(()=>{
        $e0419569a63e20fa$var$STATE = null?.data.state;
    });
}
function $e0419569a63e20fa$export$f43f349e7f6bb870(roomName, args) {
    const [state, setState] = (0, $1wHBI.useState)(null);
    (0, $1wHBI.useEffect)(()=>{
        if (!Object.prototype.hasOwnProperty.call($e0419569a63e20fa$export$e0dfa59be8d5deec, roomName)) return;
        const makeSetGameState = (version)=>(newState)=>{
                $e0419569a63e20fa$var$STATE[roomName] = newState;
                setState({
                    roomName: roomName,
                    gameState: newState,
                    stateVersion: version + 1,
                    setGameState: makeSetGameState(version + 1)
                });
            };
        if (!(roomName in $e0419569a63e20fa$var$STATE)) $e0419569a63e20fa$var$STATE[roomName] = $e0419569a63e20fa$export$e0dfa59be8d5deec[roomName](args);
        setState({
            roomName: roomName,
            gameState: $e0419569a63e20fa$var$STATE[roomName],
            stateVersion: 1,
            setGameState: makeSetGameState(1)
        });
    }, [
        roomName,
        args
    ]);
    return state;
}


function $d31ba949eddf516f$var$useDevGame(roomName) {
    // not really my favourite
    const [a, b] = roomName.split("/", 2);
    const useFake = Object.prototype.hasOwnProperty.call((0, $e0419569a63e20fa$export$e0dfa59be8d5deec), a);
    const fake = (0, $e0419569a63e20fa$export$f43f349e7f6bb870)(a, b ?? "");
    const real = $d31ba949eddf516f$var$useRealGame(useFake ? "" : roomName);
    return useFake ? fake : real;
}
const $d31ba949eddf516f$export$b33a393274d59d25 = $d31ba949eddf516f$var$useRealGame;
async function $d31ba949eddf516f$var$listLoop(roomName, version, signal) {
    let backoff = 1000;
    while(true)try {
        const result = await (0, $473c30c918a6f195$export$8f24540c37096eb6)(roomName, version, signal);
        backoff = 1000;
        if (result == null) // TODO: potentially add error state
        return null;
        else if ("timeout" in result) continue;
        else return {
            roomName: roomName,
            gameState: result.data,
            stateVersion: result.version,
            setGameState: (newState, abortSignal)=>{
                (0, $473c30c918a6f195$export$254d8d9a9e824f11)(roomName, result.version, newState, abortSignal).then((response)=>{
                    if (!response.success) console.log("commit failed; race condition occurred");
                }).catch((reason)=>{
                    if (!abortSignal.aborted) console.error(reason);
                });
            }
        };
    } catch (e) {
        if (signal.aborted) return null;
        console.error(e);
        // back off and retry
        console.log(`Backing off for ${backoff} ms`);
        await (0, $6c182388e9a195e9$export$1391212d75b2ee65)(backoff);
        backoff *= Math.random() + 0.5;
        backoff = Math.min(backoff, 30000);
        continue;
    }
}
function $d31ba949eddf516f$var$useRealGame(roomName) {
    const [state, setState] = (0, $1wHBI.useState)(null);
    const version = state?.stateVersion || 0;
    (0, $1wHBI.useEffect)(()=>{
        const abortController = new AbortController();
        if (roomName) $d31ba949eddf516f$var$listLoop(roomName, version, abortController.signal).then(setState);
        return ()=>abortController.abort();
    }, [
        roomName,
        version
    ]);
    return state;
}
function $d31ba949eddf516f$export$e133dff257bbd218(game, mutator, initial) {
    const { gameState: gameState, setGameState: setGameState } = game;
    const [mutation, setMutation] = (0, $1wHBI.useState)(initial);
    (0, $1wHBI.useEffect)(()=>{
        if (mutation === undefined) return;
        const newState = mutator(gameState, mutation);
        if ((0, $6c182388e9a195e9$export$9cb4719e2e525b7a)(gameState, newState)) {
            // noop.
            setMutation(undefined);
            return;
        }
        const abortController = new AbortController();
        setGameState(newState, abortController.signal);
        return ()=>abortController.abort();
    }, [
        setGameState,
        gameState,
        mutator,
        mutation
    ]);
    return [
        mutation,
        setMutation
    ];
}






var $cdd85af40fedd746$export$e15a579eead45913;
var $cdd85af40fedd746$export$aa3e815946b80764;
var $cdd85af40fedd746$export$d4f9a5f4ca31f0b6;
var $cdd85af40fedd746$export$ff214d0d604522b5;
var $cdd85af40fedd746$export$a3c666151edc0af1;
var $cdd85af40fedd746$export$57744285f109f80a;
var $cdd85af40fedd746$export$15b07da190767bbe;
var $cdd85af40fedd746$export$d83f873d3f5ec352;
var $cdd85af40fedd746$export$34e0f9847d4c02dd;
var $cdd85af40fedd746$export$5ce6e2f0ed680964;
var $cdd85af40fedd746$export$dc9aaa456befc6ef;
var $cdd85af40fedd746$export$ab2b7135509352b8;
var $cdd85af40fedd746$export$59e091b63458fcad;
var $cdd85af40fedd746$export$f9d2386380135291;
var $cdd85af40fedd746$export$46e4a324ac90507f;
var $cdd85af40fedd746$export$186885b852792ae6;
var $cdd85af40fedd746$export$1ca2d5cca6ec0684;
var $cdd85af40fedd746$export$bef1f36f5486a6a3;
var $cdd85af40fedd746$export$5695df298eac90c7;
var $cdd85af40fedd746$export$2478040385952f4;
var $cdd85af40fedd746$export$6363130eec868cea;
var $cdd85af40fedd746$export$ae96dc96a6d2b85;
var $cdd85af40fedd746$export$9fc9795b76ef397;
var $cdd85af40fedd746$export$b96c721ebdea39c5;
var $cdd85af40fedd746$export$615455393ee443ca;
var $cdd85af40fedd746$export$777feab933bd57da;
var $cdd85af40fedd746$export$2b8dccb26e41f6c2;
var $cdd85af40fedd746$export$c19b0e76dce888eb;
var $cdd85af40fedd746$export$f99014d66fbedb21;
var $cdd85af40fedd746$export$7c019dd0d8dd20e9;
var $cdd85af40fedd746$export$7817e5b9f07d367d;
var $cdd85af40fedd746$export$684005c1234186c6;
var $cdd85af40fedd746$export$766d56154a07562d;
var $cdd85af40fedd746$export$274575f92f7d9549;
var $cdd85af40fedd746$export$9e1725a4cfeada27;
var $cdd85af40fedd746$export$295a54748b69c781;
var $cdd85af40fedd746$export$dce947101b6c7e1f;
var $cdd85af40fedd746$export$6975c428062f2314;
var $cdd85af40fedd746$export$e5260f96c83f90f4;
var $cdd85af40fedd746$export$49ccc6e12fc9278a;
var $cdd85af40fedd746$export$1009eb603770e7e2;
var $cdd85af40fedd746$export$10a0f131c0eea21b;
var $cdd85af40fedd746$export$d77e2c2b3d2d6ff8;
$cdd85af40fedd746$export$e15a579eead45913 = `xL7ZpG_blackSuit`;
$cdd85af40fedd746$export$aa3e815946b80764 = `xL7ZpG_card`;
$cdd85af40fedd746$export$d4f9a5f4ca31f0b6 = `xL7ZpG_cardClickable`;
$cdd85af40fedd746$export$ff214d0d604522b5 = `xL7ZpG_cardHighlight`;
$cdd85af40fedd746$export$a3c666151edc0af1 = `xL7ZpG_cardJoker`;
$cdd85af40fedd746$export$57744285f109f80a = `xL7ZpG_cardStack`;
$cdd85af40fedd746$export$15b07da190767bbe = `xL7ZpG_clubsSuit`;
$cdd85af40fedd746$export$d83f873d3f5ec352 = `xL7ZpG_communityCards`;
$cdd85af40fedd746$export$34e0f9847d4c02dd = `xL7ZpG_container`;
$cdd85af40fedd746$export$5ce6e2f0ed680964 = `xL7ZpG_diamondsSuit`;
$cdd85af40fedd746$export$dc9aaa456befc6ef = `xL7ZpG_futureRound`;
$cdd85af40fedd746$export$ab2b7135509352b8 = `xL7ZpG_gameResult`;
$cdd85af40fedd746$export$59e091b63458fcad = `xL7ZpG_hand`;
$cdd85af40fedd746$export$f9d2386380135291 = `xL7ZpG_handScore`;
$cdd85af40fedd746$export$46e4a324ac90507f = `xL7ZpG_heading`;
$cdd85af40fedd746$export$186885b852792ae6 = `xL7ZpG_heartsSuit`;
$cdd85af40fedd746$export$1ca2d5cca6ec0684 = `xL7ZpG_highlightPlayer`;
$cdd85af40fedd746$export$bef1f36f5486a6a3 = `xL7ZpG_log`;
$cdd85af40fedd746$export$5695df298eac90c7 = `xL7ZpG_loss`;
$cdd85af40fedd746$export$2478040385952f4 = `xL7ZpG_noCard`;
$cdd85af40fedd746$export$6363130eec868cea = `xL7ZpG_noToken`;
$cdd85af40fedd746$export$ae96dc96a6d2b85 = `xL7ZpG_notLoss`;
$cdd85af40fedd746$export$9fc9795b76ef397 = `xL7ZpG_notWin`;
$cdd85af40fedd746$export$b96c721ebdea39c5 = `xL7ZpG_pastToken`;
$cdd85af40fedd746$export$615455393ee443ca = `xL7ZpG_player`;
$cdd85af40fedd746$export$777feab933bd57da = `xL7ZpG_playerName`;
$cdd85af40fedd746$export$2b8dccb26e41f6c2 = `xL7ZpG_players`;
$cdd85af40fedd746$export$c19b0e76dce888eb = `xL7ZpG_redSuit`;
$cdd85af40fedd746$export$f99014d66fbedb21 = `xL7ZpG_revealLog`;
$cdd85af40fedd746$export$7c019dd0d8dd20e9 = `xL7ZpG_roundCards`;
$cdd85af40fedd746$export$7817e5b9f07d367d = `xL7ZpG_roundLog`;
$cdd85af40fedd746$export$684005c1234186c6 = `xL7ZpG_roundLogEntry`;
$cdd85af40fedd746$export$766d56154a07562d = `xL7ZpG_smallToken`;
$cdd85af40fedd746$export$274575f92f7d9549 = `xL7ZpG_spadesSuit`;
$cdd85af40fedd746$export$9e1725a4cfeada27 = `xL7ZpG_token`;
$cdd85af40fedd746$export$295a54748b69c781 = `xL7ZpG_token1`;
$cdd85af40fedd746$export$dce947101b6c7e1f = `xL7ZpG_token2`;
$cdd85af40fedd746$export$6975c428062f2314 = `xL7ZpG_token3`;
$cdd85af40fedd746$export$e5260f96c83f90f4 = `xL7ZpG_token4`;
$cdd85af40fedd746$export$49ccc6e12fc9278a = `xL7ZpG_tokenPlaceholder`;
$cdd85af40fedd746$export$1009eb603770e7e2 = `xL7ZpG_tokenPool`;
$cdd85af40fedd746$export$10a0f131c0eea21b = `xL7ZpG_win`;
$cdd85af40fedd746$export$d77e2c2b3d2d6ff8 = `xL7ZpG_winRecord`;




var $c013627b4740a8f2$export$717297effe2ca6d9;
(function(HandKind) {
    HandKind[HandKind["HighCard"] = 1] = "HighCard";
    HandKind[HandKind["Pair"] = 2] = "Pair";
    HandKind[HandKind["TwoPair"] = 3] = "TwoPair";
    HandKind[HandKind["ThreeOfAKind"] = 4] = "ThreeOfAKind";
    HandKind[HandKind["Straight"] = 5] = "Straight";
    HandKind[HandKind["Flush"] = 6] = "Flush";
    HandKind[HandKind["FullHouse"] = 7] = "FullHouse";
    HandKind[HandKind["FourOfAKind"] = 8] = "FourOfAKind";
    HandKind[HandKind["StraightFlush"] = 9] = "StraightFlush";
})($c013627b4740a8f2$export$717297effe2ca6d9 || ($c013627b4740a8f2$export$717297effe2ca6d9 = {}));
function $c013627b4740a8f2$export$341946c3512d5b4f(a, b) {
    if (a.kind !== b.kind) return a.kind < b.kind;
    for(let i = 0; i < a.order.length; i += 1){
        if (a.order[i] !== b.order[i]) return a.order[i] < b.order[i];
    }
    return false;
}
function $c013627b4740a8f2$export$9429a84df33c7b5e(inputHand) {
    if (inputHand.length !== 5) throw new Error("what game is this?");
    const hand = inputHand.toSorted((a, b)=>{
        if (a.value === b.value) return a.suit - b.suit;
        return a.value - b.value;
    });
    const isFlush = hand.every((c)=>c.suit === hand[0].suit);
    const isStraight = hand.every((c, i)=>i === 0 || c.value === hand[i - 1].value + 1 || /* Special case: ace counts as 1 for a straight */ c.value === (0, $1bc72aea517c8fea$export$5062880c778c5dd2).Ace && hand[i - 1].value === (0, $1bc72aea517c8fea$export$5062880c778c5dd2).Five);
    const straightValue = isStraight ? hand[4].value === (0, $1bc72aea517c8fea$export$5062880c778c5dd2).Ace && hand[3].value === (0, $1bc72aea517c8fea$export$5062880c778c5dd2).Five ? (0, $1bc72aea517c8fea$export$5062880c778c5dd2).Five : hand[4].value : null;
    if (isFlush && straightValue != null) // Straight flush and/or royal flush
    // i am obliged to consider a royal flush to be a special case of a straight flush that doesn't require extra handling
    return {
        kind: 9,
        order: [
            straightValue
        ]
    };
    // why is this spelled out?
    let pair, secondPair, triple, quad;
    for (const cardValue of (0, $1bc72aea517c8fea$export$801f53f8ff768e98)){
        const count = hand.reduce((count, card)=>count + (card.value === cardValue ? 1 : 0), 0);
        if (count === 2) {
            if (pair != null) secondPair = cardValue;
            else pair = cardValue;
        } else if (count === 3) triple = cardValue;
        else if (count === 4) quad = cardValue;
    }
    if (quad) {
        const kicker = hand.find((c)=>c.value !== quad);
        return {
            kind: 8,
            order: [
                quad,
                kicker.value
            ]
        };
    }
    if (triple && pair) return {
        kind: 7,
        order: [
            triple,
            pair
        ]
    };
    if (isFlush) return {
        kind: 6,
        order: hand.reverse().map((c)=>c.value)
    };
    if (straightValue != null) return {
        kind: 5,
        order: [
            straightValue
        ]
    };
    if (triple) {
        const kicker = hand.filter((c)=>c.value !== triple);
        return {
            kind: 4,
            order: [
                triple,
                kicker[1].value,
                kicker[0].value
            ]
        };
    }
    if (secondPair) {
        const kicker = hand.find((c)=>c.value !== pair && c.value !== secondPair);
        // secondPair is always higher than pair
        return {
            kind: 3,
            order: [
                secondPair,
                pair,
                kicker.value
            ]
        };
    }
    if (pair) {
        const kicker = hand.filter((c)=>c.value !== pair);
        return {
            kind: 2,
            order: [
                pair,
                kicker[2].value,
                kicker[1].value,
                kicker[0].value
            ]
        };
    }
    return {
        kind: 1,
        order: hand.reverse().map((c)=>c.value)
    };
}
function $c013627b4740a8f2$export$49fc09f142764042(cards) {
    if (cards.length < 5) throw new Error("no");
    const picked = [];
    let best = null;
    const dfs = (i)=>{
        if (picked.length === 5) {
            const score = $c013627b4740a8f2$export$9429a84df33c7b5e(picked);
            if (best == null || $c013627b4740a8f2$export$341946c3512d5b4f(best[1], score)) best = [
                [
                    ...picked
                ],
                score
            ];
            return;
        }
        if (cards.length - i < 5 - picked.length) return;
        if (cards[i] instanceof Array) for (const card of cards[i]){
            picked.push(card);
            dfs(i + 1);
            picked.pop();
        }
        else {
            picked.push(cards[i]);
            dfs(i + 1);
            picked.pop();
        }
        dfs(i + 1);
    };
    dfs(0);
    return best;
}
function $c013627b4740a8f2$export$9bb0b1c644f80ff4(holeCards, communityCards) {
    if (holeCards.length !== 4) throw new Error("Omaha requires 4 hole cards");
    if (communityCards.length !== 5) throw new Error("Omaha requires 5 community cards");
    // Flatten community cards (handle joker expansions)
    const flatCommunity = communityCards.map((c)=>c instanceof Array ? c : [
            c
        ]);
    let best = null;
    // Try all C(4,2) = 6 combinations of hole cards
    for(let h1 = 0; h1 < 4; h1++)for(let h2 = h1 + 1; h2 < 4; h2++){
        // Try all C(5,3) = 10 combinations of community cards
        for(let c1 = 0; c1 < 5; c1++)for(let c2 = c1 + 1; c2 < 5; c2++){
            for(let c3 = c2 + 1; c3 < 5; c3++)// Handle joker card arrays
            for (const card1 of flatCommunity[c1]){
                for (const card2 of flatCommunity[c2])for (const card3 of flatCommunity[c3]){
                    const hand = [
                        holeCards[h1],
                        holeCards[h2],
                        card1,
                        card2,
                        card3
                    ];
                    const score = $c013627b4740a8f2$export$9429a84df33c7b5e(hand);
                    if (best == null || $c013627b4740a8f2$export$341946c3512d5b4f(best[1], score)) best = [
                        hand,
                        score
                    ];
                }
            }
        }
    }
    return best;
}



var $1wHBI = parcelRequire("1wHBI");



var $1wHBI = parcelRequire("1wHBI");
const $aba4ea7937697371$var$TokenAnimatorContext = /*#__PURE__*/ (0, $1wHBI.createContext)(null);
function $aba4ea7937697371$export$98719c5386511477({ children: children }) {
    const m = (0, $1wHBI.useRef)(null);
    if (m.current == null) m.current = new Map();
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($aba4ea7937697371$var$TokenAnimatorContext.Provider, {
        value: m.current,
        children: children
    });
}
function $aba4ea7937697371$var$tokenStr(t) {
    return `${t.round}-${t.index}`;
}
const $aba4ea7937697371$export$46749a52babc13e3 = [
    $cdd85af40fedd746$export$295a54748b69c781,
    $cdd85af40fedd746$export$dce947101b6c7e1f,
    $cdd85af40fedd746$export$6975c428062f2314,
    $cdd85af40fedd746$export$e5260f96c83f90f4
];
function $aba4ea7937697371$export$bfce916c5bf59899(props) {
    const { token: token, disabled: disabled, past: past, onClick: onClick } = props;
    const animatorContext = (0, $1wHBI.useContext)($aba4ea7937697371$var$TokenAnimatorContext);
    const containerRef = (0, $1wHBI.useRef)(null);
    const ref = (0, $1wHBI.useRef)(null);
    (0, $1wHBI.useLayoutEffect)(()=>{
        if (!token || !animatorContext) return;
        const name = $aba4ea7937697371$var$tokenStr(token);
        if (!ref.current || !containerRef.current) return;
        const x = containerRef.current.offsetLeft;
        const y = containerRef.current.offsetTop;
        const existing = animatorContext.get(name);
        if (existing) {
            const dx = existing.x - x;
            const dy = existing.y - y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            const time = distance / 1200 + 0.1;
            ref.current.style.transition = "";
            ref.current.style.position = "relative";
            ref.current.style.left = `${dx}px`;
            ref.current.style.top = `${dy}px`;
            ref.current.offsetLeft; // force a relayout
            const timingFunction = "cubic-bezier(0.285, 0.880, 0.790, 1)";
            ref.current.style.transition = `top ${time}s ${timingFunction}, left ${time}s ${timingFunction}`;
            ref.current.style.left = "0";
            ref.current.style.top = "0";
        }
        animatorContext.set(name, {
            x: x,
            y: y
        });
        const observer = new ResizeObserver(()=>{
            if (containerRef.current) animatorContext.set(name, {
                x: containerRef.current.offsetLeft,
                y: containerRef.current.offsetTop
            });
        });
        observer.observe(document.body);
        return ()=>observer.disconnect();
    }, [
        token,
        animatorContext
    ]);
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
        className: $cdd85af40fedd746$export$6363130eec868cea,
        ref: containerRef,
        children: token && /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("button", {
            className: `${$cdd85af40fedd746$export$9e1725a4cfeada27} ${past ? $cdd85af40fedd746$export$b96c721ebdea39c5 : ""} ${$aba4ea7937697371$export$46749a52babc13e3[token.round]}`,
            disabled: disabled,
            onClick: onClick,
            ref: ref,
            children: token.index
        })
    });
}




var $1wHBI = parcelRequire("1wHBI");
const $b17ff6d7fd5b0895$var$FX_FPS = 90;
var $b17ff6d7fd5b0895$var$ParticleBufferOffset;
(function(ParticleBufferOffset) {
    ParticleBufferOffset[ParticleBufferOffset["TTL"] = 0] = "TTL";
    ParticleBufferOffset[ParticleBufferOffset["X"] = 1] = "X";
    ParticleBufferOffset[ParticleBufferOffset["Y"] = 2] = "Y";
    ParticleBufferOffset[ParticleBufferOffset["ANGLE"] = 3] = "ANGLE";
    ParticleBufferOffset[ParticleBufferOffset["DX"] = 4] = "DX";
    ParticleBufferOffset[ParticleBufferOffset["DY"] = 5] = "DY";
    ParticleBufferOffset[ParticleBufferOffset["DANGLE"] = 6] = "DANGLE";
    ParticleBufferOffset[ParticleBufferOffset["T0"] = 7] = "T0";
    ParticleBufferOffset[ParticleBufferOffset["LENGTH"] = 8] = "LENGTH";
})($b17ff6d7fd5b0895$var$ParticleBufferOffset || ($b17ff6d7fd5b0895$var$ParticleBufferOffset = {}));
class $b17ff6d7fd5b0895$var$ParticleSystem {
    constructor({ maxParticles: maxParticles, particleLifespanS: particleLifespanS, gravity: gravity, drag: drag }){
        this.maxParticles = maxParticles;
        this.particleLifespan = particleLifespanS;
        this.gravity = gravity ?? 0;
        this.drag = drag;
        this.numParticles = 0;
        this.startOffset = 0;
        this.particleBuffer = new Float32Array(maxParticles * 8);
    }
    addParticle(x, y, angle, dx, dy, dangle, time) {
        const particleOffset = (this.startOffset + this.numParticles) % this.maxParticles * 8;
        this.particleBuffer[particleOffset + 0] = this.particleLifespan;
        this.particleBuffer[particleOffset + 1] = x;
        this.particleBuffer[particleOffset + 2] = y;
        this.particleBuffer[particleOffset + 3] = angle;
        this.particleBuffer[particleOffset + 4] = dx;
        this.particleBuffer[particleOffset + 5] = dy;
        this.particleBuffer[particleOffset + 6] = dangle;
        this.particleBuffer[particleOffset + 7] = time;
        if (this.numParticles + 1 > this.maxParticles) {
            this.startOffset += 1;
            this.numParticles = this.maxParticles;
        } else this.numParticles += 1;
    }
    forEachParticle(time, cb) {
        const { drag: drag, gravity: gravity } = this;
        for(let i = 0; i < this.numParticles; i++){
            const idx = (this.startOffset + i) % this.maxParticles;
            const particleOffset = idx * 8;
            const t0 = this.particleBuffer[particleOffset + 7];
            const t = time - t0;
            const ttl = this.particleBuffer[particleOffset + 0] - t;
            if (ttl < 0) continue;
            const expt = Math.expm1(drag * t);
            const x0 = this.particleBuffer[particleOffset + 1];
            const dx0 = this.particleBuffer[particleOffset + 4];
            const x = dx0 * expt / drag + x0;
            const y0 = this.particleBuffer[particleOffset + 2];
            const dy0 = this.particleBuffer[particleOffset + 5];
            const y = ((dy0 + gravity / drag) * expt - gravity * t) / drag + y0;
            const angle = this.particleBuffer[particleOffset + 3] + time * this.particleBuffer[particleOffset + 6];
            cb({
                idx: idx,
                ttl: ttl,
                x: x,
                y: y,
                angle: angle
            });
        }
    }
}
class $b17ff6d7fd5b0895$var$ConfettiEmitter {
    constructor(){
        this.particleSystem = new $b17ff6d7fd5b0895$var$ParticleSystem({
            maxParticles: 10000,
            particleLifespanS: 8,
            gravity: 1000,
            drag: -3
        });
    }
    shootConfetti(x, y, angle, power, time) {
        for(let i = 0; i < 600; i++){
            const angleDeviation = Math.PI * 0.8 * (Math.random() - 0.5);
            const powerDeviation = -0.95 * Math.random() * power;
            this.particleSystem.addParticle(x, y, Math.random() * Math.PI * 2, Math.cos(angle + angleDeviation) * (power + powerDeviation), Math.sin(angle + angleDeviation) * (power + powerDeviation), (Math.random() - 0.5) * 4, time);
        }
    }
    render(gfx, time) {
        let particles = 0;
        this.particleSystem.forEachParticle(time, ({ idx: idx, ttl: ttl, x: x, y: y, angle: angle })=>{
            const alpha = Math.min(ttl, 1.0);
            gfx.fillStyle = `rgba(${[
                "168,100,253",
                "41,205,255",
                "120,255,68",
                "255,113,141",
                "253,255,106"
            ][idx % 5]},${alpha})`;
            const xOffset = Math.sin(angle) * 30;
            gfx.translate(x + xOffset, y);
            gfx.rotate(angle);
            gfx.fillRect(-5, -3, 10, 6);
            gfx.resetTransform();
            particles += 1;
        });
        return particles;
    }
}
const $b17ff6d7fd5b0895$export$b8875e128ae6a5e2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1wHBI))).createContext({
    shootConfetti: ()=>{}
});
const $b17ff6d7fd5b0895$export$9dda24da7a3e1479 = ({ children: children })=>{
    const canvasRef = (0, $1wHBI.useRef)(null);
    const confettiRef = (0, $1wHBI.useRef)();
    (0, $1wHBI.useEffect)(()=>{
        if (canvasRef.current === null) return;
        const fx = $b17ff6d7fd5b0895$var$createFxContext(canvasRef.current);
        if (fx === null) return;
        const confettiEmitter = new $b17ff6d7fd5b0895$var$ConfettiEmitter();
        fx.emitters.push(confettiEmitter);
        confettiRef.current = (x, y, angle)=>{
            confettiEmitter.shootConfetti(x, y, angle, 6000, document.timeline.currentTime / 1000);
            $b17ff6d7fd5b0895$var$startFxLoop(fx);
        };
        return ()=>{
            fx.active = false;
        };
    }, []);
    const shootConfetti = (0, $1wHBI.useCallback)((x, y, angle)=>{
        confettiRef.current?.(x, y, angle);
    }, [
        confettiRef
    ]);
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)($b17ff6d7fd5b0895$export$b8875e128ae6a5e2.Provider, {
        value: {
            shootConfetti: shootConfetti
        },
        children: [
            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("canvas", {
                ref: canvasRef,
                style: {
                    top: 0,
                    left: 0,
                    position: "fixed",
                    pointerEvents: "none"
                }
            }),
            children
        ]
    });
};
function $b17ff6d7fd5b0895$var$startFxLoop(fx) {
    if (!fx.paused) return;
    fx.paused = false;
    const loopImpl = (nowMs)=>{
        if (!fx.active) return;
        const now = (nowMs ?? document.timeline.currentTime) / 1000;
        if (fx.lastRender == null || now - fx.lastRender > 1 / $b17ff6d7fd5b0895$var$FX_FPS) {
            fx.lastRender = now;
            // Throttle animation, since this is just silly effect
            if (!$b17ff6d7fd5b0895$var$renderFxFrame(fx, now)) {
                // No particles left, stop looping.
                fx.paused = true;
                return;
            }
        }
        requestAnimationFrame(loopImpl);
    };
    loopImpl(null);
}
function $b17ff6d7fd5b0895$var$createFxContext(canvas) {
    const gfx = canvas.getContext("2d");
    if (gfx === null) return null;
    return {
        canvas: canvas,
        gfx: gfx,
        emitters: [],
        active: true,
        lastRender: null,
        paused: true
    };
}
function $b17ff6d7fd5b0895$var$renderFxFrame(fx, time) {
    const width = window.innerWidth;
    const height = window.innerHeight;
    fx.canvas.width = width;
    fx.canvas.height = height;
    fx.gfx.clearRect(0, 0, width, height);
    let particles = 0;
    for (const emitter of fx.emitters)particles += emitter.render(fx.gfx, time);
    return particles;
}





var $1wHBI = parcelRequire("1wHBI");
const $80abff5d98bd5d06$var$DEFAULT_PREFERENCES = {
    fourColourSuits: false
};
const $80abff5d98bd5d06$var$STORAGE_KEY = "ruffians-preferences";
function $80abff5d98bd5d06$var$loadPreferences() {
    try {
        const stored = localStorage.getItem($80abff5d98bd5d06$var$STORAGE_KEY);
        if (stored) return {
            ...$80abff5d98bd5d06$var$DEFAULT_PREFERENCES,
            ...JSON.parse(stored)
        };
    } catch (e) {
        console.error("Failed to load preferences:", e);
    }
    return $80abff5d98bd5d06$var$DEFAULT_PREFERENCES;
}
function $80abff5d98bd5d06$var$savePreferences(prefs) {
    try {
        localStorage.setItem($80abff5d98bd5d06$var$STORAGE_KEY, JSON.stringify(prefs));
    } catch (e) {
        console.error("Failed to save preferences:", e);
    }
}
const $80abff5d98bd5d06$var$PreferencesContext = /*#__PURE__*/ (0, $1wHBI.createContext)(null);
function $80abff5d98bd5d06$export$3d5a0a3e1b7bc50c({ children: children }) {
    const [preferences, setPreferencesState] = (0, $1wHBI.useState)($80abff5d98bd5d06$var$loadPreferences);
    const setPreferences = (updates)=>{
        setPreferencesState((prev)=>{
            const next = {
                ...prev,
                ...updates
            };
            $80abff5d98bd5d06$var$savePreferences(next);
            return next;
        });
    };
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($80abff5d98bd5d06$var$PreferencesContext.Provider, {
        value: {
            preferences: preferences,
            setPreferences: setPreferences
        },
        children: children
    });
}
function $80abff5d98bd5d06$export$bbd7d970555e2952() {
    const context = (0, $1wHBI.useContext)($80abff5d98bd5d06$var$PreferencesContext);
    if (!context) throw new Error("usePreferences must be used within PreferencesProvider");
    return [
        context.preferences,
        context.setPreferences
    ];
}


var $7387bb10f4c48d81$export$6d59db4903f20f7d;
var $7387bb10f4c48d81$export$a75d1723e6bda2ec;
var $7387bb10f4c48d81$export$29dd17c7f3c81c36;
var $7387bb10f4c48d81$export$21f42ab9b6679f44;
$7387bb10f4c48d81$export$6d59db4903f20f7d = `IRU1Ha_description`;
$7387bb10f4c48d81$export$a75d1723e6bda2ec = `IRU1Ha_option`;
$7387bb10f4c48d81$export$29dd17c7f3c81c36 = `IRU1Ha_overlay`;
$7387bb10f4c48d81$export$21f42ab9b6679f44 = `IRU1Ha_panel`;


function $f32ae0fd7750bd2b$export$a8eae1dfb4299f8(props) {
    const { onClose: onClose } = props;
    const [preferences, setPreferences] = (0, $80abff5d98bd5d06$export$bbd7d970555e2952)();
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
        className: $7387bb10f4c48d81$export$29dd17c7f3c81c36,
        onClick: onClose,
        children: /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
            className: $7387bb10f4c48d81$export$21f42ab9b6679f44,
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("h2", {
                    children: "Preferences"
                }),
                /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                    className: $7387bb10f4c48d81$export$a75d1723e6bda2ec,
                    children: [
                        /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("input", {
                            type: "checkbox",
                            id: "fourColourSuits",
                            checked: preferences.fourColourSuits,
                            onChange: (e)=>setPreferences({
                                    fourColourSuits: e.target.checked
                                })
                        }),
                        /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("label", {
                            htmlFor: "fourColourSuits",
                            children: "Four-colour suits"
                        }),
                        /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("p", {
                            className: $7387bb10f4c48d81$export$6d59db4903f20f7d,
                            children: "Display each suit in a different colour."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("button", {
                    onClick: onClose,
                    children: "Close"
                })
            ]
        })
    });
}


function $0a2fa7723e9783be$export$985739bfa5723e08(props) {
    const { username: username, setUsername: setUsername, roomName: roomName } = props;
    const game = (0, $d31ba949eddf516f$export$b33a393274d59d25)(roomName);
    if (!game) return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
        children: "loading..."
    });
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $80abff5d98bd5d06$export$3d5a0a3e1b7bc50c), {
        children: /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$GameInner, {
            username: username,
            setUsername: setUsername,
            game: game
        })
    });
}
function $0a2fa7723e9783be$var$GameInner(props) {
    const { username: username, setUsername: setUsername, game: game } = props;
    switch(game.gameState.phase){
        case (0, $0651f0d0ba30c08f$export$1179af6d199a01fa).SETUP:
            // https://github.com/microsoft/TypeScript/issues/18758
            return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$SetupGame, {
                username: username,
                game: {
                    ...game,
                    gameState: game.gameState
                }
            });
        case (0, $0651f0d0ba30c08f$export$1179af6d199a01fa).BIDDING:
            return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $aba4ea7937697371$export$98719c5386511477), {
                children: /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$BiddingGame, {
                    username: username,
                    setUsername: setUsername,
                    game: {
                        ...game,
                        gameState: game.gameState
                    }
                })
            });
        case (0, $0651f0d0ba30c08f$export$1179af6d199a01fa).SCORING:
            return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $b17ff6d7fd5b0895$export$9dda24da7a3e1479), {
                children: /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$ScoringGame, {
                    username: username,
                    game: {
                        ...game,
                        gameState: game.gameState
                    }
                })
            });
    }
}
function $0a2fa7723e9783be$var$joinRoomMutator(game, username) {
    if (game.players.some((p)=>p.name === username)) return game;
    return {
        ...game,
        players: [
            ...game.players,
            {
                name: username
            }
        ]
    };
}
function $0a2fa7723e9783be$var$leaveRoomMutator(game, username) {
    return {
        ...game,
        players: game.players.filter((p)=>p.name !== username)
    };
}
function $0a2fa7723e9783be$var$withJokersMutator(game, withJokers) {
    return (0, $1bfe83860855b64a$export$185802fd694ee1f5)(game, (draft)=>{
        draft.config.withJokers = withJokers;
    });
}
function $0a2fa7723e9783be$var$gameModeMutator(game, gameMode) {
    return (0, $1bfe83860855b64a$export$185802fd694ee1f5)(game, (draft)=>{
        draft.config.gameMode = gameMode;
    });
}
function $0a2fa7723e9783be$var$startGameMutator(game) {
    return (0, $40eba99eaa1e9859$export$aab0d876bb6c7a7f)(game.players, game.config);
}
function $0a2fa7723e9783be$var$SetupGame(props) {
    const { username: username, game: game } = props;
    const inRoom = game.gameState.players.some((p)=>p.name === username);
    const [, setJoinRoom] = (0, $d31ba949eddf516f$export$e133dff257bbd218)(game, $0a2fa7723e9783be$var$joinRoomMutator);
    const [, setLeaveRoom] = (0, $d31ba949eddf516f$export$e133dff257bbd218)(game, $0a2fa7723e9783be$var$leaveRoomMutator);
    const joinRoom = ()=>setJoinRoom(username);
    const [withJokersMutation, setWithJokers] = (0, $d31ba949eddf516f$export$e133dff257bbd218)(game, $0a2fa7723e9783be$var$withJokersMutator);
    const [gameModeMutation, setGameMode] = (0, $d31ba949eddf516f$export$e133dff257bbd218)(game, $0a2fa7723e9783be$var$gameModeMutator);
    const [, setStartGame] = (0, $d31ba949eddf516f$export$e133dff257bbd218)(game, $0a2fa7723e9783be$var$startGameMutator);
    const startGame = ()=>setStartGame(true);
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
        className: $cdd85af40fedd746$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                className: $cdd85af40fedd746$export$2b8dccb26e41f6c2,
                children: [
                    game.gameState.players.map((p, pi)=>/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                            className: $cdd85af40fedd746$export$615455393ee443ca,
                            children: [
                                /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("span", {
                                    className: $cdd85af40fedd746$export$777feab933bd57da,
                                    style: p.name === username ? {} : {
                                        color: $0a2fa7723e9783be$var$playerColour(pi)
                                    },
                                    children: p.name
                                }),
                                inRoom && /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)((0, $9677d902f5c96280$exports.Fragment), {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("button", {
                                            onClick: ()=>setLeaveRoom(p.name),
                                            children: p.name === username ? "Leave" : "Kick"
                                        })
                                    ]
                                })
                            ]
                        }, p.name)),
                    !inRoom && /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
                        className: $cdd85af40fedd746$export$615455393ee443ca,
                        children: /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("button", {
                            onClick: joinRoom,
                            children: "Join room"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                children: [
                    game.gameState.winRecord && /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)((0, $9677d902f5c96280$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$WinRecordView, {
                                record: game.gameState.winRecord
                            }),
                            game.gameState.winRecord.wins === game.gameState.winRecord.targetWins && "You won!",
                            game.gameState.winRecord.losses === game.gameState.winRecord.targetLosses && "You unwon."
                        ]
                    }),
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
                        className: $cdd85af40fedd746$export$46e4a324ac90507f,
                        children: "Creating a new game"
                    }),
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("input", {
                        type: "checkbox",
                        checked: withJokersMutation ?? game.gameState.config.withJokers,
                        onChange: (e)=>setWithJokers(e.target.checked),
                        id: "with_jokers"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("label", {
                        htmlFor: "with_jokers",
                        children: "Include jokers in the deck"
                    }),
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("label", {
                                children: "Game mode:"
                            }),
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("input", {
                                        type: "radio",
                                        name: "gameMode",
                                        id: "texas_holdem",
                                        checked: (gameModeMutation ?? game.gameState.config.gameMode ?? (0, $0651f0d0ba30c08f$export$7cd7a93136e7148a).TEXAS_HOLDEM) === (0, $0651f0d0ba30c08f$export$7cd7a93136e7148a).TEXAS_HOLDEM,
                                        onChange: ()=>setGameMode((0, $0651f0d0ba30c08f$export$7cd7a93136e7148a).TEXAS_HOLDEM)
                                    }),
                                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("label", {
                                        htmlFor: "texas_holdem",
                                        children: "Texas Hold'em (2 cards)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("input", {
                                        type: "radio",
                                        name: "gameMode",
                                        id: "omaha",
                                        checked: (gameModeMutation ?? game.gameState.config.gameMode ?? (0, $0651f0d0ba30c08f$export$7cd7a93136e7148a).TEXAS_HOLDEM) === (0, $0651f0d0ba30c08f$export$7cd7a93136e7148a).OMAHA,
                                        onChange: ()=>setGameMode((0, $0651f0d0ba30c08f$export$7cd7a93136e7148a).OMAHA)
                                    }),
                                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("label", {
                                        htmlFor: "omaha",
                                        children: "Omaha (4 cards)"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("button", {
                        className: "startGame",
                        disabled: !inRoom || game.gameState.players.length < 2 || withJokersMutation != null || gameModeMutation != null,
                        onClick: startGame,
                        children: "Start game"
                    })
                ]
            })
        ]
    });
}
function $0a2fa7723e9783be$var$moveTokenMutator(game, [username, token, from]) {
    return (0, $1bfe83860855b64a$export$185802fd694ee1f5)(game, (draft)=>{
        const toPlayerIndex = draft.players.findIndex((p)=>p.name === username);
        if (toPlayerIndex === -1) return;
        const toPlayer = draft.players[toPlayerIndex];
        const log = draft.log[draft.log.length - 1];
        const relinquish = ()=>{
            if (toPlayer.token) {
                const t = toPlayer.token;
                draft.tokens[toPlayer.token.index - 1] = t;
                toPlayer.token = null;
                return t;
            }
            return null;
        };
        if (!token) {
            const put = relinquish();
            if (put) log.push({
                player: toPlayerIndex,
                action: {
                    put: put
                }
            });
        } else if (from != null) {
            if (from === username) return; // this makes no sense
            // take from another player
            const fromPlayerIndex = draft.players.findIndex((p)=>p.name === from);
            if (fromPlayerIndex !== -1) {
                const fromPlayer = draft.players[fromPlayerIndex];
                if ((0, $6c182388e9a195e9$export$9cb4719e2e525b7a)(fromPlayer.token, token)) {
                    const put = relinquish();
                    log.push({
                        player: toPlayerIndex,
                        action: {
                            from: fromPlayerIndex,
                            put: put,
                            take: token
                        }
                    });
                    toPlayer.token = fromPlayer.token;
                    fromPlayer.token = null;
                }
            }
        } else {
            const ix = draft.tokens.findIndex((t)=>(0, $6c182388e9a195e9$export$9cb4719e2e525b7a)(t, token));
            if (ix !== -1) {
                draft.tokens[ix] = null;
                const put = relinquish();
                log.push({
                    player: toPlayerIndex,
                    action: {
                        from: null,
                        put: put,
                        take: token
                    }
                });
                toPlayer.token = token;
            }
        }
    });
}
function $0a2fa7723e9783be$var$advanceRoundMutator(game) {
    if (!(0, $40eba99eaa1e9859$export$4f2c9bb64a518c51)(game)) return game;
    if (!game.tokens.every((t)=>t == null)) return game;
    return (0, $40eba99eaa1e9859$export$9ffc307867ecb30d)(game);
}
function $0a2fa7723e9783be$var$selectCardMutator(game, [username, card, index]) {
    const [draft, finalize] = (0, $1bfe83860855b64a$export$185802fd694ee1f5)(game);
    const player = draft.players.find((p)=>p.name === username);
    if (!player) return game;
    const stackIndex = player.hand.findIndex((cards)=>cards instanceof Array);
    if (stackIndex === -1) return game;
    if (!(0, $6c182388e9a195e9$export$9cb4719e2e525b7a)(player.hand[stackIndex][index], card)) return game;
    player.hand[stackIndex] = card;
    return (0, $40eba99eaa1e9859$export$d68aabd9451ab6d8)(finalize());
}
function $0a2fa7723e9783be$var$BiddingGame(props) {
    const { username: username, setUsername: setUsername, game: game } = props;
    const inRoom = game.gameState.players.some((p)=>p.name === username);
    const [preferences] = (0, $80abff5d98bd5d06$export$bbd7d970555e2952)();
    const [showPreferences, setShowPreferences] = (0, $1wHBI.useState)(false);
    const [, setSelectCard] = (0, $d31ba949eddf516f$export$e133dff257bbd218)(game, $0a2fa7723e9783be$var$selectCardMutator);
    const selectCard = (card, index)=>{
        setSelectCard([
            username,
            card,
            index
        ]);
    };
    const [, setMoveToken] = (0, $d31ba949eddf516f$export$e133dff257bbd218)(game, $0a2fa7723e9783be$var$moveTokenMutator);
    const [, setAdvanceRound] = (0, $d31ba949eddf516f$export$e133dff257bbd218)(game, $0a2fa7723e9783be$var$advanceRoundMutator);
    const waitingForJoker = !(0, $40eba99eaa1e9859$export$4f2c9bb64a518c51)(game.gameState);
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
        className: $cdd85af40fedd746$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
                className: $cdd85af40fedd746$export$2b8dccb26e41f6c2,
                children: game.gameState.players.map((p, pi)=>/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                        className: $cdd85af40fedd746$export$615455393ee443ca,
                        children: [
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("span", {
                                className: $cdd85af40fedd746$export$777feab933bd57da,
                                style: p.name === username ? {} : {
                                    color: $0a2fa7723e9783be$var$playerColour(pi)
                                },
                                children: p.name
                            }),
                            false,
                            p.name === username && " (You)",
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                                className: $cdd85af40fedd746$export$59e091b63458fcad,
                                children: [
                                    p.hand.map((c, i)=>!inRoom || p.name === username ? c instanceof Array ? /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$CardStack, {
                                            cards: c,
                                            onClick: p.name === username ? selectCard : undefined,
                                            fourColourSuits: preferences.fourColourSuits
                                        }, i) : /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$Card, {
                                            card: c,
                                            fourColourSuits: preferences.fourColourSuits
                                        }, i) : /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$NoCard, {}, i)),
                                    p.pastTokens.map((t, i)=>/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $aba4ea7937697371$export$bfce916c5bf59899), {
                                            token: t,
                                            past: true,
                                            disabled: true
                                        }, i)),
                                    !waitingForJoker && /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $aba4ea7937697371$export$bfce916c5bf59899), {
                                        token: p.token,
                                        disabled: !inRoom,
                                        onClick: ()=>setMoveToken([
                                                username,
                                                username === p.name ? null : p.token,
                                                p.name
                                            ])
                                    }),
                                    game.gameState.futureRounds.map((_, i)=>/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
                                            className: $cdd85af40fedd746$export$49ccc6e12fc9278a
                                        }, i))
                                ]
                            }),
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
                                className: $cdd85af40fedd746$export$f9d2386380135291,
                                children: "\xa0"
                            })
                        ]
                    }, p.name))
            }),
            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$WinRecordView, {
                        record: game.gameState.winRecord
                    }),
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                        className: $cdd85af40fedd746$export$46e4a324ac90507f,
                        children: [
                            waitingForJoker ? "Waiting for players to choose their cards" : `Round ${game.gameState.log.length} - ${(game.gameState.config.gameMode ?? (0, $0651f0d0ba30c08f$export$7cd7a93136e7148a).TEXAS_HOLDEM) === (0, $0651f0d0ba30c08f$export$7cd7a93136e7148a).OMAHA ? "Omaha" : "Hold'em"}`,
                            " ",
                            !inRoom && "(You are spectating.) ",
                            inRoom && /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$KillGameButton, {
                                game: game
                            }),
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("button", {
                                onClick: ()=>setShowPreferences(true),
                                children: "\u2699"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$CommunityCards, {
                        gameState: game.gameState,
                        fourColourSuits: preferences.fourColourSuits
                    }),
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
                        className: $cdd85af40fedd746$export$1009eb603770e7e2,
                        children: game.gameState.tokens.map((token, i)=>/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $aba4ea7937697371$export$bfce916c5bf59899), {
                                token: token,
                                disabled: !inRoom,
                                onClick: ()=>setMoveToken([
                                        username,
                                        token,
                                        null
                                    ])
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("button", {
                        disabled: !inRoom || waitingForJoker || !game.gameState.tokens.every((t)=>t == null),
                        onClick: ()=>setAdvanceRound(true),
                        children: game.gameState.futureRounds.length === 0 ? "Finish" : "Next round"
                    }),
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$GameLog, {
                        players: game.gameState.players,
                        jokerLog: game.gameState.jokerLog,
                        log: game.gameState.log,
                        username: username
                    })
                ]
            }),
            showPreferences && /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $f32ae0fd7750bd2b$export$a8eae1dfb4299f8), {
                onClose: ()=>setShowPreferences(false)
            })
        ]
    });
}
function $0a2fa7723e9783be$var$killGameMutator(game) {
    return {
        phase: (0, $0651f0d0ba30c08f$export$1179af6d199a01fa).SETUP,
        players: game.players.map((p)=>({
                name: p.name
            })),
        config: game.config
    };
}
function $0a2fa7723e9783be$var$KillGameButton({ game: game }) {
    const [, setKillGame] = (0, $d31ba949eddf516f$export$e133dff257bbd218)(game, $0a2fa7723e9783be$var$killGameMutator);
    const [reallyKillGame, setReallyKillGame] = (0, $1wHBI.useState)(false);
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)((0, $9677d902f5c96280$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("button", {
                onClick: ()=>{
                    if (reallyKillGame) setKillGame(true);
                    else setReallyKillGame(true);
                },
                children: reallyKillGame ? "Really go back to game setup" : "Go back to game setup"
            }),
            reallyKillGame && /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("button", {
                onClick: ()=>setReallyKillGame(false),
                children: "Just kidding"
            })
        ]
    });
}
function $0a2fa7723e9783be$var$setRevealIndexMutator(game, newRevealIndex) {
    return {
        ...game,
        revealIndex: Math.max(game.revealIndex, newRevealIndex)
    };
}
function $0a2fa7723e9783be$var$isWinRecordFinished(record) {
    return record.wins === record.targetWins || record.losses === record.targetLosses;
}
function $0a2fa7723e9783be$var$startNextGameMutator(game, newWinRecord) {
    if ($0a2fa7723e9783be$var$isWinRecordFinished(newWinRecord)) return {
        ...$0a2fa7723e9783be$var$killGameMutator(game),
        winRecord: newWinRecord
    };
    return (0, $40eba99eaa1e9859$export$aab0d876bb6c7a7f)(game.players, game.config, newWinRecord);
}
function $0a2fa7723e9783be$var$ScoringGame(props) {
    const { username: username, game: game } = props;
    const { players: players, communityCards: communityCards, revealIndex: revealIndex } = game.gameState;
    const [preferences] = (0, $80abff5d98bd5d06$export$bbd7d970555e2952)();
    const [showPreferences, setShowPreferences] = (0, $1wHBI.useState)(false);
    const handScores = (0, $1wHBI.useMemo)(()=>players.map((p)=>{
            const mode = game.gameState.config.gameMode ?? (0, $0651f0d0ba30c08f$export$7cd7a93136e7148a).TEXAS_HOLDEM;
            return mode === (0, $0651f0d0ba30c08f$export$7cd7a93136e7148a).OMAHA ? (0, $c013627b4740a8f2$export$9bb0b1c644f80ff4)(p.hand, communityCards) : (0, $c013627b4740a8f2$export$49fc09f142764042)([
                ...p.hand,
                ...communityCards
            ]);
        }), [
        players,
        communityCards,
        game.gameState.config.gameMode
    ]);
    const inRoom = players.some((p)=>p.name === username);
    const [, setRevealIndex] = (0, $d31ba949eddf516f$export$e133dff257bbd218)(game, $0a2fa7723e9783be$var$setRevealIndexMutator);
    const [, setStartNextGame] = (0, $d31ba949eddf516f$export$e133dff257bbd218)(game, $0a2fa7723e9783be$var$startNextGameMutator);
    const revealedPlayerIndex = players.findIndex((p)=>p.token.index === revealIndex);
    const revealedPlayerBestHand = new Set(handScores[revealedPlayerIndex][0]);
    const playerScores = (0, $1wHBI.useMemo)(()=>players.map((p, i)=>({
                index: p.token.index,
                score: handScores[i][1],
                playerIndex: i
            })).sort((p, q)=>p.index - q.index), [
        players,
        handScores
    ]);
    const gameWon = (0, $1wHBI.useMemo)(()=>{
        return playerScores.every((p, i)=>i === 0 || !(0, $c013627b4740a8f2$export$341946c3512d5b4f)(p.score, playerScores[i - 1].score));
    }, [
        playerScores
    ]);
    const { shootConfetti: shootConfetti } = (0, $1wHBI.useContext)((0, $b17ff6d7fd5b0895$export$b8875e128ae6a5e2));
    const doneRevealing = revealIndex === players.length;
    (0, $1wHBI.useEffect)(()=>{
        if (doneRevealing && gameWon) {
            shootConfetti(0, window.innerHeight, -Math.PI / 2 + 0.3);
            setTimeout(()=>{
                shootConfetti(window.innerWidth, window.innerHeight, -Math.PI / 2 - 0.3);
            }, 400);
        }
    }, [
        doneRevealing,
        gameWon,
        shootConfetti
    ]);
    const nextWinRecord = doneRevealing ? {
        wins: (game.gameState.winRecord?.wins ?? 0) + (gameWon ? 1 : 0),
        losses: (game.gameState.winRecord?.losses ?? 0) + (gameWon ? 0 : 1),
        targetWins: game.gameState.winRecord?.targetWins ?? (0, $0651f0d0ba30c08f$export$a0bea9b09a67f3da).config.targetWins,
        targetLosses: game.gameState.winRecord?.targetLosses ?? (0, $0651f0d0ba30c08f$export$a0bea9b09a67f3da).config.targetLosses
    } : game.gameState.winRecord;
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
        className: $cdd85af40fedd746$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
                className: $cdd85af40fedd746$export$2b8dccb26e41f6c2,
                children: players.map((p, pi)=>/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                        className: `${$cdd85af40fedd746$export$615455393ee443ca} ${pi === revealedPlayerIndex ? $cdd85af40fedd746$export$1ca2d5cca6ec0684 : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("span", {
                                className: $cdd85af40fedd746$export$777feab933bd57da,
                                style: p.name === username ? {} : {
                                    color: $0a2fa7723e9783be$var$playerColour(pi)
                                },
                                children: p.name
                            }),
                            p.name === username && " (You)",
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                                className: $cdd85af40fedd746$export$59e091b63458fcad,
                                children: [
                                    p.hand.map((c, i)=>!inRoom || p.name === username || p.token.index <= revealIndex ? /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$Card, {
                                            card: c,
                                            highlight: revealedPlayerBestHand.has(c),
                                            fourColourSuits: preferences.fourColourSuits
                                        }, i) : /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$NoCard, {}, i)),
                                    p.pastTokens.map((t, i)=>/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $aba4ea7937697371$export$bfce916c5bf59899), {
                                            token: t,
                                            past: true,
                                            disabled: true
                                        }, i)),
                                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $aba4ea7937697371$export$bfce916c5bf59899), {
                                        token: p.token,
                                        disabled: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
                                className: $cdd85af40fedd746$export$f9d2386380135291,
                                children: p.token.index <= revealIndex ? $0a2fa7723e9783be$var$formatScore(handScores[pi][1]) : /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $9677d902f5c96280$exports.Fragment), {
                                    children: "\xa0"
                                })
                            })
                        ]
                    }, p.name))
            }),
            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$WinRecordView, {
                        record: nextWinRecord
                    }),
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                        className: $cdd85af40fedd746$export$46e4a324ac90507f,
                        children: [
                            "Scoring: ",
                            revealIndex,
                            " (",
                            players[revealedPlayerIndex].name,
                            ") -",
                            " ",
                            (game.gameState.config.gameMode ?? (0, $0651f0d0ba30c08f$export$7cd7a93136e7148a).TEXAS_HOLDEM) === (0, $0651f0d0ba30c08f$export$7cd7a93136e7148a).OMAHA ? "Omaha" : "Hold'em",
                            " ",
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("button", {
                                onClick: ()=>setShowPreferences(true),
                                children: "\u2699"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$CommunityCards, {
                        gameState: game.gameState,
                        highlight: revealedPlayerBestHand,
                        fourColourSuits: preferences.fourColourSuits
                    }),
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
                        className: $cdd85af40fedd746$export$f99014d66fbedb21,
                        children: playerScores.slice(1, revealIndex).map((p, j)=>{
                            const i = j + 1;
                            const beat = !(0, $c013627b4740a8f2$export$341946c3512d5b4f)(playerScores[i].score, playerScores[i - 1].score);
                            const tied = beat && !(0, $c013627b4740a8f2$export$341946c3512d5b4f)(playerScores[i - 1].score, playerScores[i].score);
                            return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("span", {
                                        className: $cdd85af40fedd746$export$777feab933bd57da,
                                        children: players[playerScores[i].playerIndex].name
                                    }),
                                    "'s hand ",
                                    tied ? "tied" : beat ? "beat" : "didn't beat",
                                    " ",
                                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("span", {
                                        className: $cdd85af40fedd746$export$777feab933bd57da,
                                        children: players[playerScores[i - 1].playerIndex].name
                                    }),
                                    "."
                                ]
                            }, i);
                        })
                    }),
                    revealIndex < players.length && /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("button", {
                        disabled: !inRoom,
                        onClick: ()=>setRevealIndex(revealIndex + 1),
                        children: [
                            "Reveal ",
                            revealIndex + 1,
                            " (",
                            players.find((p)=>p.token.index === revealIndex + 1)?.name,
                            ")"
                        ]
                    }),
                    doneRevealing && /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)((0, $9677d902f5c96280$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
                                className: $cdd85af40fedd746$export$ab2b7135509352b8,
                                children: gameWon ? "You won this one!" : "You didn't wonnered."
                            }),
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("button", {
                                onClick: ()=>setStartNextGame(nextWinRecord),
                                children: $0a2fa7723e9783be$var$isWinRecordFinished(nextWinRecord) ? "Finish" : "Next game"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$GameLog, {
                        players: game.gameState.players,
                        jokerLog: game.gameState.jokerLog,
                        log: game.gameState.log,
                        username: username
                    })
                ]
            }),
            showPreferences && /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $f32ae0fd7750bd2b$export$a8eae1dfb4299f8), {
                onClose: ()=>setShowPreferences(false)
            })
        ]
    });
}
function $0a2fa7723e9783be$var$CommunityCards({ gameState: gameState, highlight: highlight, fourColourSuits: fourColourSuits }) {
    // Group up cards into their rounds
    const rounds = gameState.pastRounds ? "futureRounds" in gameState ? [
        ...gameState.pastRounds,
        ...gameState.futureRounds
    ] : gameState.pastRounds : /* migration */ (0, $40eba99eaa1e9859$export$47cd02e2cf937030);
    let ix = 0;
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
        className: $cdd85af40fedd746$export$d83f873d3f5ec352,
        children: rounds.map(({ cards: cards }, i)=>{
            const start = ix;
            const end = ix + cards;
            ix = end;
            if (!cards) return;
            return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
                className: `${(0, $aba4ea7937697371$export$46749a52babc13e3)[i]} ${$cdd85af40fedd746$export$7c019dd0d8dd20e9} ${start >= gameState.communityCards.length ? $cdd85af40fedd746$export$dc9aaa456befc6ef : ""}`,
                children: start < gameState.communityCards.length ? gameState.communityCards.slice(start, end).map((c, j)=>/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$CardStack, {
                        cards: c,
                        highlight: highlight,
                        fourColourSuits: fourColourSuits
                    }, j)) : Array.from({
                    length: cards
                }).map((_, j)=>/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$NoCard, {}, j))
            }, i);
        })
    });
}
function $0a2fa7723e9783be$var$GameLog({ players: players, jokerLog: jokerLog, log: log, username: username }) {
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $9677d902f5c96280$exports.Fragment), {
        children: /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
            className: $cdd85af40fedd746$export$bef1f36f5486a6a3,
            children: [
                jokerLog.length > 0 && /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                    className: $cdd85af40fedd746$export$7817e5b9f07d367d,
                    children: [
                        /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("h2", {
                            children: "Setup"
                        }),
                        jokerLog.map((entry, i)=>/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                                className: $cdd85af40fedd746$export$684005c1234186c6,
                                children: [
                                    /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("span", {
                                        className: $cdd85af40fedd746$export$777feab933bd57da,
                                        children: players[entry.player].name
                                    }),
                                    " discarded a joker"
                                ]
                            }, i))
                    ]
                }),
                log.map((roundLog, roundIndex)=>/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                        className: $cdd85af40fedd746$export$7817e5b9f07d367d,
                        children: [
                            /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("h2", {
                                children: [
                                    "Round ",
                                    roundIndex + 1
                                ]
                            }),
                            roundLog.map((logEntry, i)=>/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                                    className: $cdd85af40fedd746$export$684005c1234186c6,
                                    children: [
                                        /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("span", {
                                            className: $cdd85af40fedd746$export$777feab933bd57da,
                                            style: players[logEntry.player].name === username ? {} : {
                                                color: $0a2fa7723e9783be$var$playerColour(logEntry.player)
                                            },
                                            children: players[logEntry.player].name
                                        }),
                                        "take" in logEntry.action ? /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)((0, $9677d902f5c96280$exports.Fragment), {
                                            children: [
                                                " ",
                                                "took the ",
                                                /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$SmallToken, {
                                                    token: logEntry.action.take
                                                }),
                                                " from",
                                                " ",
                                                logEntry.action.from == null ? /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $9677d902f5c96280$exports.Fragment), {
                                                    children: "the middle"
                                                }) : /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("span", {
                                                    className: $cdd85af40fedd746$export$777feab933bd57da,
                                                    style: players[logEntry.action.from].name === username ? {} : {
                                                        color: $0a2fa7723e9783be$var$playerColour(logEntry.action.from)
                                                    },
                                                    children: players[logEntry.action.from].name
                                                }),
                                                logEntry.action.put != null && /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)((0, $9677d902f5c96280$exports.Fragment), {
                                                    children: [
                                                        " ",
                                                        "and returned the ",
                                                        /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$SmallToken, {
                                                            token: logEntry.action.put
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)((0, $9677d902f5c96280$exports.Fragment), {
                                            children: [
                                                " ",
                                                "returned the ",
                                                /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$SmallToken, {
                                                    token: logEntry.action.put
                                                })
                                            ]
                                        })
                                    ]
                                }, i))
                        ]
                    }, roundIndex))
            ]
        })
    });
}
function $0a2fa7723e9783be$var$playerColour(i) {
    return `hsl(${190 + i * 137} 90 80)`;
}
const $0a2fa7723e9783be$var$BREAK = {
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).Flush]: null,
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).HighCard]: null,
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).Straight]: null,
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).StraightFlush]: null,
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).FourOfAKind]: 1,
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).Pair]: 1,
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).TwoPair]: 2,
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).ThreeOfAKind]: 1,
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).FullHouse]: null
};
const $0a2fa7723e9783be$var$HAND_KIND_NAME = {
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).Flush]: "Flush",
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).HighCard]: "High card",
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).Straight]: "Straight",
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).StraightFlush]: "Straight flush",
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).FourOfAKind]: "Four of a kind",
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).Pair]: "Pair",
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).TwoPair]: "Two pair",
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).ThreeOfAKind]: "Three of a kind",
    [(0, $c013627b4740a8f2$export$717297effe2ca6d9).FullHouse]: "Full house"
};
function $0a2fa7723e9783be$var$formatScore(score) {
    const brk = $0a2fa7723e9783be$var$BREAK[score.kind];
    if (score.kind === (0, $c013627b4740a8f2$export$717297effe2ca6d9).StraightFlush && score.order[0] === (0, $1bc72aea517c8fea$export$5062880c778c5dd2).Ace) // wow you are so cool
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $9677d902f5c96280$exports.Fragment), {
        children: "Royal Flush!!!"
    });
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)((0, $9677d902f5c96280$exports.Fragment), {
        children: [
            $0a2fa7723e9783be$var$HAND_KIND_NAME[score.kind],
            " (",
            score.order.slice(0, brk != null ? brk : score.order.length).map($0a2fa7723e9783be$var$formatCardValue).join(","),
            brk != null ? "; " + score.order.slice(brk).map($0a2fa7723e9783be$var$formatCardValue).join(",") : "",
            ")"
        ]
    });
}
const $0a2fa7723e9783be$var$STRING_VALUES = {
    [(0, $1bc72aea517c8fea$export$5062880c778c5dd2).Ace]: "A",
    [(0, $1bc72aea517c8fea$export$5062880c778c5dd2).Jack]: "J",
    [(0, $1bc72aea517c8fea$export$5062880c778c5dd2).Queen]: "Q",
    [(0, $1bc72aea517c8fea$export$5062880c778c5dd2).King]: "K"
};
function $0a2fa7723e9783be$var$formatCardValue(value) {
    return $0a2fa7723e9783be$var$STRING_VALUES[value] ?? value.toString();
}
const $0a2fa7723e9783be$var$UNICODE_SUITS = {
    [(0, $1bc72aea517c8fea$export$5bdeb9e4de225b16).Diamonds]: "\u2666",
    [(0, $1bc72aea517c8fea$export$5bdeb9e4de225b16).Hearts]: "\u2665",
    [(0, $1bc72aea517c8fea$export$5bdeb9e4de225b16).Clubs]: "\u2663",
    [(0, $1bc72aea517c8fea$export$5bdeb9e4de225b16).Spades]: "\u2660"
};
const $0a2fa7723e9783be$var$FOUR_COLOUR_SUIT_STYLES = {
    [(0, $1bc72aea517c8fea$export$5bdeb9e4de225b16).Clubs]: $cdd85af40fedd746$export$15b07da190767bbe,
    [(0, $1bc72aea517c8fea$export$5bdeb9e4de225b16).Diamonds]: $cdd85af40fedd746$export$5ce6e2f0ed680964,
    [(0, $1bc72aea517c8fea$export$5bdeb9e4de225b16).Hearts]: $cdd85af40fedd746$export$186885b852792ae6,
    [(0, $1bc72aea517c8fea$export$5bdeb9e4de225b16).Spades]: $cdd85af40fedd746$export$274575f92f7d9549
};
const $0a2fa7723e9783be$var$TWO_COLOUR_SUIT_STYLES = {
    [(0, $1bc72aea517c8fea$export$5bdeb9e4de225b16).Clubs]: $cdd85af40fedd746$export$e15a579eead45913,
    [(0, $1bc72aea517c8fea$export$5bdeb9e4de225b16).Diamonds]: $cdd85af40fedd746$export$c19b0e76dce888eb,
    [(0, $1bc72aea517c8fea$export$5bdeb9e4de225b16).Hearts]: $cdd85af40fedd746$export$c19b0e76dce888eb,
    [(0, $1bc72aea517c8fea$export$5bdeb9e4de225b16).Spades]: $cdd85af40fedd746$export$e15a579eead45913
};
function $0a2fa7723e9783be$var$Card(props) {
    const { card: card, onClick: onClick, highlight: highlight, fourColourSuits: fourColourSuits = true } = props;
    const suitStyles = fourColourSuits ? $0a2fa7723e9783be$var$FOUR_COLOUR_SUIT_STYLES : $0a2fa7723e9783be$var$TWO_COLOUR_SUIT_STYLES;
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
        className: `${$cdd85af40fedd746$export$aa3e815946b80764} ${highlight ? $cdd85af40fedd746$export$ff214d0d604522b5 : ""} ${onClick != null ? $cdd85af40fedd746$export$d4f9a5f4ca31f0b6 : ""} ${"joker" in card ? $cdd85af40fedd746$export$a3c666151edc0af1 : ""}`,
        onClick: onClick,
        children: "joker" in card ? /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $9677d902f5c96280$exports.Fragment), {
            children: "\u2728"
        }) : /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)((0, $9677d902f5c96280$exports.Fragment), {
            children: [
                $0a2fa7723e9783be$var$formatCardValue(card.value),
                /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("span", {
                    className: suitStyles[card.suit],
                    children: $0a2fa7723e9783be$var$UNICODE_SUITS[card.suit]
                })
            ]
        })
    });
}
function $0a2fa7723e9783be$var$CardStack(props) {
    const { cards: cards, onClick: onClick, highlight: highlight, fourColourSuits: fourColourSuits } = props;
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
        className: $cdd85af40fedd746$export$57744285f109f80a,
        children: cards.map((card, i)=>/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)($0a2fa7723e9783be$var$Card, {
                card: card,
                onClick: onClick != null ? ()=>onClick(card, i) : undefined,
                highlight: highlight?.has(card),
                fourColourSuits: fourColourSuits
            }, i))
    });
}
function $0a2fa7723e9783be$var$NoCard() {
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("div", {
        className: $cdd85af40fedd746$export$2478040385952f4
    });
}
function $0a2fa7723e9783be$var$SmallToken({ token: token }) {
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("span", {
        className: $cdd85af40fedd746$export$766d56154a07562d,
        children: token.index
    });
}
function $0a2fa7723e9783be$var$WinRecordView({ record: record }) {
    if (!record) return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $9677d902f5c96280$exports.Fragment), {}); // for migration purposes
    const { wins: wins, losses: losses, targetWins: targetWins, targetLosses: targetLosses } = record;
    return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
        className: $cdd85af40fedd746$export$d77e2c2b3d2d6ff8,
        children: [
            Array.from({
                length: targetWins
            }).map((_, i)=>/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("span", {
                    className: i < targetWins - wins ? $cdd85af40fedd746$export$9fc9795b76ef397 : $cdd85af40fedd746$export$10a0f131c0eea21b
                }, i)),
            Array.from({
                length: targetLosses
            }).map((_, i)=>/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("span", {
                    className: i < losses ? $cdd85af40fedd746$export$5695df298eac90c7 : $cdd85af40fedd746$export$ae96dc96a6d2b85
                }, i + targetWins))
        ]
    });
}


function $18cb66d1e7a58135$var$useUsername() {
    const [username, setUsername] = (0, $1wHBI.useState)(()=>window.localStorage.getItem("username"));
    return [
        username,
        (name)=>{
            window.localStorage.setItem("username", name);
            setUsername(name);
        }
    ];
}
function $18cb66d1e7a58135$var$useRoomName() {
    const [hash, setHash] = (0, $1wHBI.useState)(()=>window.location.hash);
    (0, $1wHBI.useEffect)(()=>{
        const listener = ()=>{
            setHash(window.location.hash);
        };
        window.addEventListener("hashchange", listener);
        return ()=>window.removeEventListener("hashchange", listener);
    });
    const roomName = hash.replace("#", "");
    return [
        roomName || null,
        (newRoomName)=>{
            window.location.hash = newRoomName ? "#" + newRoomName : "";
        }
    ];
}
var $c338a9aa8bfc252b$exports = {};

$c338a9aa8bfc252b$exports = (parcelRequire("lanWR")).getBundleURL("8jssz") + "uwu_plain.89c01b2b.svg";


const $18cb66d1e7a58135$var$LOGO = new URL($c338a9aa8bfc252b$exports);
function $18cb66d1e7a58135$var$App() {
    const [username, saveUsername] = $18cb66d1e7a58135$var$useUsername();
    const [roomName, setRoomName] = $18cb66d1e7a58135$var$useRoomName();
    const [inGame, setInGame] = (0, $1wHBI.useState)(Boolean(username && roomName));
    if (!username || !roomName || !inGame) {
        if (inGame) setInGame(false); // bad practice
        const newRoom = async ()=>{
            if (!username) return;
            setRoomName((await (0, $473c30c918a6f195$export$5ad94f5fb1ec657b)({
                ...(0, $0651f0d0ba30c08f$export$a0bea9b09a67f3da),
                players: [
                    {
                        name: username
                    }
                ]
            })).room);
            setInGame(true);
        };
        return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("header", {
            className: $77458c27d140f8c4$export$38e42c68cf43b5d4,
            children: [
                /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("img", {
                    className: $77458c27d140f8c4$export$db3c28d99448dcff,
                    src: $18cb66d1e7a58135$var$LOGO.toString(),
                    alt: "the ruffians"
                }),
                /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("div", {
                    children: [
                        "What's your name?",
                        /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("input", {
                            type: "input",
                            value: username ?? "",
                            onChange: (e)=>saveUsername(e.target.value)
                        })
                    ]
                }),
                !roomName && /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $9677d902f5c96280$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)("button", {
                        disabled: !username,
                        onClick: newRoom,
                        children: "New game"
                    })
                }),
                roomName && /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $9677d902f5c96280$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsxs)("button", {
                        onClick: ()=>setInGame(true),
                        children: [
                            "View game (",
                            roomName,
                            ")"
                        ]
                    })
                })
            ]
        });
    } else return /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $0a2fa7723e9783be$export$985739bfa5723e08), {
        username: username,
        setUsername: saveUsername,
        roomName: roomName
    }, roomName);
}
var $18cb66d1e7a58135$export$2e2bcd8739ae039 = $18cb66d1e7a58135$var$App;


const $7dfc410149830cad$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($988ab8cd0f14a6fc$exports))).createRoot(document.getElementById("root"));
$7dfc410149830cad$var$root.render(/*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1wHBI))).StrictMode, {
    children: /*#__PURE__*/ (0, $9677d902f5c96280$exports.jsx)((0, $18cb66d1e7a58135$export$2e2bcd8739ae039), {})
}));

})();
//# sourceMappingURL=index.c0b1a077.js.map
